{
  "accessibility": {
    "closeModal": "Fermer la fenêtre modale",
    "useSetting": "Utiliser le réglage",
    "srOnly": {
      "close": "Fermer",
      "loading": "Chargement…"
    }
  },
  "account": {
    "salesResources": {
      "title": "Ressources de ventes",
      "searchDocuments": "Rechercher des documents",
      "minimalRating": "Évaluation minimale",
      "maxRating": "Note Max"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Activez la refacturation pour ce client afin de réaliser jusqu'à 10 fois plus de profits sur l'utilisation du téléphone, des courriels, des automatisations, etc.",
      "enableRebilling": "Activer la refacturation",
      "servicesActivateAfterPayment": "Les services de refacturation seront actifs après que le client ait ajouté une méthode de paiement. D’ici là, l’accès au compte du client sera restreint.",
      "cannotModifyOnHold": "Impossible de modifier les configurations de refacturation puisque ce compte possède déjà un forfait SaaS en attente. Les majorations de refacturation seront configurées selon le forfait lorsque le client ajoutera un mode de paiement.",
      "rebillingSettings": "Paramètres de Refacturation"
    }
  },
  "affiliates": {
    "aboutMe": "A propos de moi",
    "error": {
      "unableToSend": "Impossible d'envoyer un Email"
    },
    "industriesServed": "Secteurs desservis",
    "sendAMessage": "Envoyer un message",
    "sendMessageIntro": "Envoyez un message pour vous présenter à ce conseiller. Incluez des détails sur vous-même et les services que vous recherchez.",
    "socialSites": "Sites de réseaux sociaux",
    "success": {
      "emailSent": "Courriel envoyé avec succès"
    },
    "validationErrors": {
      "validEmail": "Veuillez fournir un courriel valide.",
      "validMessage": "Veuillez fournir un message valide.",
      "validName": "Veuillez fournir un nom valide."
    },
    "yearsInBusiness": "Années en affaires",
    "yourEmail": "Votre courriel",
    "yourName": "Votre nom",
    "paymentDetailsAccessMessage": " Cette section sur les détails de paiement est accessible et modifiable uniquement par le <strong>propriétaire de l’agence</strong>. Si vous avez besoin d’aide, veuillez contacter <strong>le propriétaire de votre agence ({ agencyOwnerEmail })</strong>.",
    "partnerBadgeAlt": "Badge de partenaire",
    "photoAlt": "Photo de partenaire",
    "defaultCompany": "Aucune entreprise",
    "moreServices": "+ {count} autres services"
  },
  "agency": {
    "saas": {
      "saasMode": "Mode SaaS",
      "pendingPaymentInformation": "Détails de paiement en attente",
      "customerId": "Identifiant du client",
      "noPaymentMethods": "Il semble qu'aucun mode de paiement n'a été ajouté! Veuillez ajouter un mode de paiement pour activer le mode SaaS",
      "enableSaasDescription": "Activez le SaaS à cet emplacement pour créer un abonnement, et refacturer l'utilisation du téléphone et du courriel",
      "missingEmailAddress": "L'adresse courriel du compte est manquante, veuillez d'abord ajouter les détails.",
      "toConvertToSaaS": "Pour convertir ce compte en SaaS, vous devez d'abord ajouter un administrateur de site et réessayer",
      "newUser": "Créer un nouvel utilisateur",
      "stripeCustomerConnected": "Le client Stripe a été connecté avec succès!",
      "requestClientPaymentDetails": "Demander les détails de paiement du client",
      "saasLocationDescription": "Les emplacements en mode SaaS nécessitent la carte de crédit de votre client pour fonctionner. Vous pouvez faire votre demande en envoyant un courriel, un texto ou en partageant une URL",
      "selectSpace": "Veuillez sélectionner l’espace pour continuer",
      "spaceDescription": "L’espace que vous sélectionnez ici sera utilisé pour stocker les informations de ce client, traiter ses paiements et gérer ses abonnements.",
      "stripe": "Stripe",
      "freeCreditsDescription": "Quand un utilisateur s'inscrit, vous pouvez lui offrir des crédits gratuits à utiliser pour les services de courriel et de téléphonie.",
      "thatAboutMinsInCalls": "Cela représente environ {count} textes ou {count1} min d'appels",
      "subscriptionSettings": "Paramètres d'abonnement",
      "toUpgradeOrCancelPlan": "Mettre à niveau ou résilier l'abonnement",
      "allowClientUpgrade": "Permettre au client (sous-compte) de passer à un forfait supérieur.",
      "addNewPlanFeatures": "Ajoutez les fonctionnalités du nouveau forfait lors de la mise à niveau",
      "upgradeFeatureDescription": "En passant à un forfait supérieur, les sous-comptes auront accès aux fonctionnalités supplémentaires dans le nouveau forfait. accès aux fonctionnalités supplémentaires du nouveau forfait.",
      "allowClientCancel": "Permet au client (sous-compte) d'annuler son abonnement.",
      "snapshotDescription": "L'instantané sélectionné sera automatiquement ajouté à l'emplacement SaaS nouvellement créé",
      "ownSnapshots": "Instantanés personnels",
      "selectAndContinue": "Sélectionnez et continuez"
    },
    "advancedSettings": {
      "controlLocationSettings": "Contrôler les paramètres d'emplacement",
      "disableAddSmtp": "Désactiver le bouton Ajouter un service de messagerie dans les paramètres des services de messagerie du sous-compte",
      "disableAddSmtpDescription": "Restreindre les utilisateurs de sous-comptes à ajouter leur propre fournisseur de service de courriel",
      "enableReVerification": "Activer la revérification après 90 jours",
      "lcEmailNotEnabled": "L'emplacement n'a pas LeadConnector comme fournisseur de courriles par défaut.",
      "onlyVisibleForAgency": "Vous ne pouvez voir que ces paramètres activés pour l'agence.",
      "reVerificationDescription": "Chaque statut de vérification de courriel sera révoqué après 90 jours (Protégez votre réputation d'expéditeur et assurez la meilleure délivrabilité dans la boîte de réception).",
      "account": {
        "accountDetails": "Détails du compte",
        "advancedEmailSettings": "Réglages avancés de messagerie",
        "hipaa": "HIPAA",
        "hipaaCompliant": "Conforme à la HIPAA",
        "smsEmailLimits": "Limites de SMS/Courriels",
        "socialProfiles": "Profils de réseaux sociaux",
        "subscribed": "Abonné"
      },
      "activityTracking": {
        "history": "Historique"
      },
      "addAccount": {
        "accountInfo": "Renseignements sur le compte",
        "accountSnapshots": "Instantanés du compte",
        "businessNiche": "Créneau commercial",
        "chooseBusinessNiche": "Sélectionner un créneau commercial…",
        "pickSnapshot": "Veuillez sélectionner un instantané",
        "selectSnapshot": "Sélectionner un instantané",
        "title": "Ajouter un sous-compte",
        "accountInfo1": "Informations sur le compte"
      },
      "addBalance": {
        "addBalanceToWallet": "Ajouter un montant au portefeuille",
        "addMoneyToWallet": "Ajoutez de l’argent au portefeuille",
        "balanceAddedSuccessfully": "Montant ajouté avec succès",
        "cardWillBeCharged": "La carte se terminant par {cardNumber} sera débitée",
        "complimentaryCredits": "Crédits offerts ({credits})",
        "creditsRemovedByAgency": "Crédits supprimés via l’agence",
        "currentBalance": "Solde actuel",
        "customerCCWillNotBeCharged": "La carte de crédit du client ne sera pas facturée",
        "moneyWillBeAddedToWallet": "L'argent sera ajouté au portefeuille",
        "pleaseProvideAmountBetween": "Veuillez fournir un montant entre {min} et {max}",
        "processing": "Traitement en cours",
        "removeBalance": "Supprimer le montant",
        "transactionSuccessful": "Transaction réussie",
        "walletBalance": "Montant du portefeuille ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Ajout en cours…",
        "cardDetails": "Info de la carte",
        "cardSuccessfullyAdded": "Carte ajoutée avec succès",
        "errorWhileAddingCard": "Une erreur s'est produite lors de l'ajout de la nouvelle carte!",
        "maximumCardUpdateLimitReached": "Limite maximale de mise à jour de la carte atteinte",
        "rateLimitMessage": "Il semble que vous ayez atteint le nombre maximal de tentatives autorisées pour ajouter des cartes aujourd'hui. Veuillez réessayer dans 24 heures."
      },
      "aiProductRebilling": {
        "funnel": " entonnoir",
        "images": " Images,",
        "per1000Words": " /1 000 mots, ",
        "perFunnel": " /entonnoir",
        "perImage": " /Image,",
        "pleaseCheckSupport": "veuillez vérifier nos",
        "ratesMayDiffer": "Les taux peuvent varier selon la région. Les calculs présentés sont basés sur les taux pour le Royaume-Uni,",
        "ratesMayDifferUS": "Les taux peuvent varier selon la région. Les calculs sont affichés selon les tarifs de Twilio pour les États-Unis, veuillez consulter Twilio pour plus de détails.",
        "pleaseCheckTwilioRates": "Les SMS sortants pour les États-Unis/leCanada seront facturés à 0,0079 $/segment. SMS entrants à 0,0075 $/segment.",
        "words": " mots, "
      },
      "api": {
        "advancedFunctionalityNote": "Message de fonctionnalité avancée",
        "agencyApiKeys": "Clés API de l'agence",
        "apiAccess": {
          "partOfAdvancedApi": "Cela fait partie de l’API avancée qui est disponible dans le plan Pro.",
          "toUpgrade": "pour mettre à niveau."
        },
        "createNew": "Créer un nouveau",
        "developerCouncilInfo": "Informations du Conseil des développeurs",
        "noAccess": "Vous n'avez pas accès à cette section.",
        "securityAlert": "Message d'alerte de sécurité",
        "table": {
          "fetchingKeys": "Récupération des clés d'entreprise…",
          "noKeysYet": "Vous n’avez pas encore de clés API.",
          "toCreateFirstKeys": "pour créer vos premières clés API."
        },
        "zapierNote": "Message Zapier"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Possibilité de choisir les agendas Google à « Ajouter » et les agendas en conflit à vérifier pour calculer la disponibilité de chaque utilisateur.",
        "abilityToAllocateRoundRobin": "Possibilité d'attribuer des rendez-vous à tour de rôle",
        "abilityToChooseSpecificUser": "Possibilité de choisir un utilisateur spécifique avec lequel prendre rendez-vous",
        "adminAbilitySeeEveryUser": "Administrateur – Possibilité de consulter les rendez-vous du calendrier de chaque utilisateur",
        "adminAbilityViewAllCalendar": "Administrateur – Possibilité de consulter les rendez-vous du calendrier de tous les utilisateurs",
        "adminsCanDeleteIntegrations": "Les administrateurs peuvent supprimer toutes les intégrations qu'ils souhaitent, mais les utilisateurs ne peuvent supprimer que les leurs.",
        "adminsCanSeeAllIntegrations": "Les administrateurs peuvent voir toutes les intégrations, quel que soit leur créateur, mais les utilisateurs ne peuvent voir que les intégrations qu'ils ont créées pour eux-mêmes.",
        "contactDetailAppointments": "Détails de contact > Rendez-vous (Nouveau)",
        "conversationsScheduleAppointment": "Conversations > Prise de rendez-vous (Nouveau)",
        "essentialConsiderations": "Considérations essentielles",
        "funnelsWebsitesCalendar": "Entonnoirs/Sites Web > Calendrier (Nouveau)",
        "helpReorientTriggers": "Pendant l'appel, nous vous aiderons à réorienter les déclencheurs pour s'adapter à la nouvelle configuration du calendrier",
        "iAgreeMessage": "Si les modifications susmentionnées vous conviennent, veuillez cliquer sur « J’accepte » et commencez à utiliser le calendrier (Bêta) à cet emplacement.",
        "integrationNew": "Intégration (Nouveau)",
        "loseAbilityToViewEdit": "Les utilisateurs de la nouvelle version ne pourront plus « afficher/modifier » les rendez-vous (créés dans la version précédente) via la fenêtre modale Détails de l'opportunité, mais ils pourront continuer à effectuer toutes ces actions sur la page des rendez-vous",
        "newOldTriggersCoexist": "Les nouveaux et anciens déclencheurs coexisteront",
        "nonAdminAbilityViewPersonal": "Non-administrateur - Possibilité de ne voir que leurs rendez-vous personnels (Les données assignées / la cartographie du calendrier sous GESTION DU GROUPE n’ont aucun impact)",
        "nonAdminViewPersonalOnly": "Non administrateur – Possibilité de voir uniquement ses rendez-vous personnels",
        "notAtMoment": "Pas pour l’instant. Mais nous nous efforçons de l'amener sur mobile dès que possible.",
        "oldAppointmentsCanBeViewed": "Les anciens rendez-vous peuvent être consultés sur la page des rendez-vous à l'aide d'un bouton bascule.",
        "oldAppointmentsDisplayed": "Les anciens rendez-vous seront affichés à côté des nouveaux rendez-vous dans la même liste de rendez-vous",
        "oldCalendarVersionAppointments": "Ancienne version du calendrier + Anciens rendez-vous",
        "onlyNewCalendarWidget": "Seul le nouveau widget de calendrier peut être ajouté.",
        "opportunityAddAppointment": "Opportunité > Ajouter un rendez-vous (Nouveau)",
        "profilePageAdmin": "Page de profil pour administrateur (Nouveau)",
        "profilePageAllUsers": "Page de profil (tous les utilisateurs)",
        "providesAllOptions": "Fournit toutes les options (Groupes + Services) nécessaires pour configurer le nouveau calendrier",
        "reintegratingConnectionsRequired": "Il pourrait être nécessaire de réintégrer toutes les connexions une fois que la version bêta du calendrier est activée pour un emplacement.",
        "roundRobinHighlight": "La possibilité de répartir les rendez-vous entre différents groupes d'agents est le principal point fort de cette mise à jour.",
        "schedulingCalendarAppointments": "Planification > Calendrier/Rendez-vous (nouveaux filtres + bascule pour passer entre les nouveaux et les anciens rendez-vous)",
        "settingsCalendarBeta": "Paramètres > Calendrier (Bêta)",
        "surfacingFirstTime": "Mise en avant pour la première fois",
        "teamManagementAdminOnly": "Gestion de groupe (disponible uniquement pour les administrateurs)",
        "toggleOffNewVersion": "Désactiver (Nouvelle Version)",
        "toggleOnOldVersion": "Activer (ancienne version)",
        "whatChangesWithNewVersion": "Quelles sont les nouveautés de la nouvelle version du calendrier?",
        "whatDoesCalendarEntail": "En quoi consiste le calendrier (Private Beta) ?",
        "whatHappensToOldAppointments": "Que se passera-t-il avec nos anciens rendez-vous après l'effet d'animation?",
        "whatWillWeSeeMobile": "Que verrons-nous sur mobile durant la phase bêta?",
        "willOldAppointmentsBeFactored": "Les anciens rendez-vous seront-ils pris en compte lors du calcul de la disponibilité pour les nouveaux rendez-vous?",
        "willOldCalendarUrlsWork": "Est-ce que nos anciennes URL de calendrier continueront de fonctionner après la transition ?",
        "willWeGetNewVersionMobile": "Pourrons-nous utiliser la nouvelle version sur mobile durant la phase bêta?",
        "yesOldSettingsPageContinues": "Oui. En fait, l’ancienne page de paramètres continuera d’exister, tout comme votre capacité à y apporter des modifications. L'ancien widget de calendrier et le nouveau widget de calendrier fonctionneront indépendamment tout en restant en synchronisation constante pour assurer un calcul précis de votre disponibilité sur les deux systèmes. Pour éviter toute confusion, nous vous encourageons vivement à utiliser les nouvelles URL autant que possible, afin de ne pas avoir à gérer deux ensembles d'URL distincts pour les mêmes groupes d'utilisateurs.",
        "yesSyncOnGoogleCalendar": "Oui, puisqu’il y a la synchronisation unidirectionnelle activée, le calendrier Google s’assure que les emplacements non disponibles sont bloqués."
      },
      "companyPlansModal": {
        "billedAnnually": "Facturé annuellement",
        "billedMonthly": "Facturation mensuelle",
        "changePlanFor": "Changement de forfait pour {locationName}",
        "notAuthorized": "Vous n'avez pas l'autorisation d'effectuer cette action. Seuls les utilisateurs/administrateurs de l'agence et les administrateurs de l'emplacement peuvent le faire.",
        "payAnnually": "Paiement annuel",
        "payMonthly": "Paiement mensuel"
      },
      "locationBillingHistory": {
        "billingHistory": "Historique de facturation",
        "cardNo": "N° de carte",
        "errorWhileFetchingInvoices": "Une erreur s'est produite lors de la récupération des factures, cliquez pour réessayer.",
        "invoiceDescription": "Description de la facture",
        "invoiceNo": "N° de facture",
        "noInvoices": "Aucune facture",
        "refunded": "Remboursé",
        "succeeded": "réussi",
        "view": "VOIR"
      },
      "locationWallet": {
        "autoRechargeWith": "Recharge automatique avec",
        "balance": "Montant :",
        "credits": "Crédits",
        "seeTransactions": "Voir les transactions",
        "whenBalanceLowerThan": "quand le montant est inférieur à"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Veuillez vérifier vos courriels ({emails}).",
        "csvSentMessage": "Nous vous enverrons un fichier CSV par courriel. Cela prend habituellement entre 7 et 10 minutes.",
        "enterEmailAddress": "Saisir l'adresse courriel",
        "exportAndSendCsv": "Exporter et envoyer le fichier CSV",
        "exportTransactions": "Transactions d'exportation",
        "itUsuallyArrives": "Cela arrive généralement en 10 minutes.",
        "useCommasToSeparate": "Utilisez des virgules pour séparer plusieurs courriels."
      },
      "modifySubscription": {
        "cancelClientDescription": "Annuler l'abonnement de votre client et fermer le compte",
        "cancelDescription": "Annuler votre abonnement et fermer le compte",
        "cancelImmediately": "Annulez immédiatement",
        "cancelNow": "Annuler maintenant",
        "cancelSubscription": "Annulez l'abonnement",
        "changedYourMind": "Avez-vous changé d’avis?",
        "changedYourMindClient": "Vous pouvez reprendre l'abonnement de votre client",
        "changedYourMindYou": "Vous pouvez reprendre votre abonnement.",
        "confirmByTyping": "Confirmez en tapant {text} ci-dessous.",
        "confirmCancellation": "Confirmer l'annulation",
        "modifySubscription": "Modifier l'abonnement",
        "modifyYourSubscription": "Modifier votre abonnement",
        "resumeSubscription": "Reprendre l’abonnement",
        "subscriptionWillBeCancelledOn": "Cela programmera l'annulation de votre abonnement pour le {date}. Vous pouvez reprendre votre abonnement en annulant la résiliation programmée à tout moment.",
        "subscriptionWillBeCancelledOnClient": "Ceci planifiera l'annulation de l’abonnement de votre client pour le {date}. Vous et vos clients pouvez reprendre votre abonnement en annulant la résiliation programmée à tout moment.",
        "subscriptionWillBeCancelledOnDate": "Votre abonnement sera annulé le {date}.",
        "subscriptionWillBeCancelledOnDateClient": "L'abonnement de votre client sera annulé le {date}.",
        "subscriptionWillBeResumed": "Votre abonnement sera réactivé et vous recommencerez à être facturé(e) normalement.",
        "subscriptionWillBeResumedClient": "L'abonnement de votre client sera réactivé et il recommencera à être facturé normalement.",
        "upgradeDescription": "Passer à un forfait d'abonnement supérieur",
        "weAreGladYouStaying": "Nous sommes heureux de savoir que vous restez.",
        "nextBillingDate": "Date de facturation suivante : {date}",
        "cancelImmediatelyTitle": "Voulez-vous vraiment annuler l'abonnement immédiatement ?",
        "cancelNowDescription": "Votre abonnement sera annulé le {date}. Si vous choisissez d’annuler maintenant, votre compte, y compris toute activité sortante comme les messages et courriels programmés, sera immédiatement arrêté.",
        "cancelNowDescriptionClient": "L’abonnement de votre client est prévu pour être annulé le {date}. Si vous choisissez d’annuler maintenant, alors le compte de votre client, y compris toute activité sortante comme les messages et courriels planifiés, sera immédiatement arrêté.",
        "modifyDescription": "Vous pouvez {action} votre abonnement",
        "modifyDescriptionClient": "Vous pouvez {action} l’abonnement de votre client"
      },
      "noPaymentMethodWarning": {
        "addNow": "Ajoutez maintenant",
        "youNeedToEnterCardInfo": "Vous devez saisir les détails de votre carte.",
        "youNeedToEnterClientCardInfo": "Vous devez saisir les détails de la carte de votre client."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "Les frais sont basés sur des jetons. Le nombre de mots indiqué ci-dessous est une estimation destinée à vous aider à comprendre l'utilisation. La facturation réelle peut varier.",
        "examplePricingGpt4oMini": "Exemple de tarification – GPT-4o Mini",
        "for750kWords": "(pour 750 000 mots) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Entrée",
        "or": "ou ",
        "output": "Sortie",
        "perImage": " / Image",
        "perResultSelection": " / Sélection des résultats",
        "ratesMayDifferUK": "Les tarifs peuvent varier selon la région. Les calculs indiqués sont basés sur les taux pour le Royaume-Uni, veuillez vérifier nos",
        "ratesMayDifferUS": "Les tarifs peuvent varier selon la région et le type de numéro. Calculs indiqués selon les tarifs de Twilio pour les États-Unis,",
        "pleaseCheckSupport": "veuillez vérifier nos",
        "resultSelection": " Sélection de résultats",
        "supportDoc": "documentation à l'appui",
        "forMoreDetails": "pour plus de détails",
        "words": " mots"
      },
      "removePaymentMethod": {
        "endingIn": "Se terminant en *{cardNo}",
        "no": "Non",
        "removeCard": "Supprimer la carte?",
        "removing": "Suppression en cours…",
        "yesRemove": "Oui, supprimer"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Demander les détails de paiement des clients",
        "saasLocationDescription": "Configurer un abonnement SaaS pour cet emplacement",
        "selectSpace": "Sélectionner un espace",
        "spaceDescription": "Choisissez où vous voulez configurer la facturation pour cet emplacement."
      },
      "saasEnableProducts": {
        "disable": "Désactiver",
        "enableDisableProducts": "Activer/Désactiver les produits",
        "feature": "Caractéristique",
        "unsavedChanges": "Modifications non enregistrées"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "La prochaine facturation de ce client semble être passée. Cela se produit lorsque le compte Stripe de votre agence ne fonctionne pas correctement. Veuillez vous connecter au Stripe de votre agence pour le résoudre.",
        "copiedText": "texte copié :",
        "couldNotCopy": "Asynchrone : Impossible de copier le texte : ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Prochaine date de facturation : ",
        "plan": "Forfait",
        "pleaseContactAgency": "Veuillez communiquer avec l'agence pour activer votre abonnement.",
        "stripeSubscriptionId": "ID d'abonnement Stripe :",
        "subscriptionPlans": "Forfait d'abonnement",
        "subscriptionWillBeCancelledOn": "Votre abonnement sera annulé le {date}.",
        "subscriptionWillBeCancelledOnClient": "L'abonnement de votre client sera annulé le {date}",
        "toModifyClientSubscription": "pour modifier l'abonnement de votre client",
        "toModifyYourSubscription": "pour modifier votre abonnement",
        "whatsappNumberSubscription": "Abonnement au numéro WhatsApp",
        "yourBillingDatePast": "Votre prochaine date de facturation semble être déjà passée. Veuillez communiquer avec {email} pour résoudre ce problème. Entre-temps, tout se déroulera comme d'habitude."
      },
      "salesResources": {
        "certifiedUser": "Utilisateur certifié",
        "clearFilter": "Effacer le filtre",
        "dateRange": "Période couverte"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "Vous paierez {amount} $ par mois, facturés {interval}.",
        "planUpgradeFailed": "Votre calendrier n'a pas pu être mis à niveau!",
        "planUpgraded": "Votre forfait a été mis à niveau!",
        "retryUpgrade": "Réessayer la mise à niveau",
        "upgradeFailed": "La mise à niveau de votre forfait a échoué. Veuillez réessayer.",
        "upgradedSuccessfully": "Vous avez réussi à mettre à niveau votre forfait {oldPlan} à {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "facturé en tant que frais mensuels de {amount} / mois",
        "billedAsYearlyCharge": "facturé comme une charge annuelle de {amount} /année",
        "upgradeFrom": "Mettre à niveau à partir de",
        "whatYouWillGet": "Ce que vous obtiendrez :"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Montant après la transaction :",
        "callDuration": "Durée de l'appel :",
        "callSid": "Appelez SID :",
        "charge": "Charge :",
        "contact": "Contact\t:",
        "contactName": "Nom du contact :",
        "contactPhone": "Téléphone du contact :",
        "credit": "Crédit :",
        "creditsAfterTransaction": "Crédits après la transaction :",
        "dateSent": "Date d'envoi",
        "deleted": "<Deleted>.",
        "discount": "Rabais :",
        "eventId": "ID de l'événement :",
        "from": "De :",
        "noContactFound": "Aucun contact trouvé",
        "noOfSegments": "Nombre de segments :",
        "openContactPage": "Ouvrir la page de contact",
        "openConversation": "Conversation ouverte",
        "openEvent": "Événement ouvert",
        "originalCharge": "Charge originale :",
        "received": "Reçu",
        "smsSid": "SMS SID :",
        "timeBilled": "Temps facturé :",
        "timeOfCall": "Heure de l'appel",
        "transactionDetails": "Détails de la transaction -",
        "transactionId": "ID de la transaction :",
        "type": "Type :",
        "segments": "Segments"
      },
      "calendarSettings": {
        "meetings": "Réunions",
        "services": "Services",
        "hideCalendarWarning": "Si vous souhaitez masquer complètement le module Calendrier, faites-le à partir des paramètres du sous-compte > Mon personnel > Rôles et autorisations",
        "calendarSettingsUpdated": "Paramètres du calendrier mis à jour",
        "meetingDescription": "Activez cette option pour permettre aux sous-comptes d'utiliser la fonctionnalité Réunions, conçue pour gérer les calendriers de vente, les appels de recrutement, les planifications à la ronde, les collaborations d'équipe, les réservations de cours, les entrevues, et plus encore. Idéal pour les entreprises ayant besoin d'outils de planification flexibles et collaboratifs.",
        "serviceDescription": "Activez l'option Services pour permettre aux sous-comptes d'accéder à une solution de réservation complète pour les entreprises de services. Cela comprend la création de pages de réservation avec plusieurs services, la gestion des ressources, la gestion de plusieurs sites, la fixation de prix particuliers pour le personnel, l'ajout de variations de service ou de modules complémentaires, et bien plus encore."
      }
    },
    "apiKeys": {
      "apiKey": "ApiKey",
      "copied": "Copié!",
      "copyApiKey": "Copier la clé API",
      "createApiKey": "Créer une clé API",
      "deleteAllKeys": "Supprimer toutes les clés",
      "nameRequired": "Le champ Nom est requis.",
      "somethingWentWrong": "Oups! Une erreur s'est produite! Veuillez réessayer.",
      "updatedSuccessfully": "La mise à jour a bien été effectuée."
    },
    "billing": {
      "accountPaused": "Votre compte {name} a été suspendu.",
      "accountProvisioned": "Votre compte est en cours de création.",
      "activateSubAccount": "Activer le sous-compte",
      "activeServices": "Services actifs",
      "addNewCard": "Ajouter une nouvelle carte",
      "addNewService": "Ajouter un nouveau service",
      "addPaymentMethod": "ajouter un mode de paiement.",
      "alertIcon": "Icône d'alerte",
      "approve": "Approuver",
      "authenticateCardMessage": "Dans un souci de sécurité accrue, veuillez authentifier à nouveau les informations de votre carte.",
      "badActorWarning": "Si vous pensez que ce sous-compte a été créé par un acteur malveillant, nous vous recommandons de supprimer ce sous-compte et d'annuler l'abonnement correspondant.",
      "callUs": "Nous appeler",
      "cancelAndDelete": "Annuler l’abonnement et supprimer le sous-compte",
      "completeFormNextStep": "Veuillez remplir le formulaire à l'étape suivante.",
      "congratulations": "🎉 Félicitations ! 🎉",
      "contactAgency": "Veuillez communiquer avec votre agence pour résoudre ce problème.",
      "contactThroughEmailOrPhone": "Vous pouvez nous joindre par courriel ou par téléphone pour résoudre ce problème.",
      "dataSafe": "Toutes vos données sont sécurisées et toutes les automatisations, pages Web, etc. reprendront leur fonctionnement après le paiement.",
      "declineSubAccount": "Rejeter le sous-compte",
      "deleteRecommendation": "Il est recommandé de supprimer ce sous-compte. Ou sinon, vous pouvez le faire plus tard à partir de la page Sous-comptes > Gérer le client.",
      "emailUsAt": "Envoyez-nous un courriel à",
      "moveToDashboard": "Passer au tableau de bord",
      "noPaymentMethods": "Il semble qu'aucun mode de paiement n'a été ajouté. Veuillez",
      "paymentMethod": "Mode de paiement",
      "paymentMethodUpdated": "Votre mode de paiement a été mis à jour.",
      "paymentNotCompleted": "Vous voyez ce message parce que le paiement n’a pas été effectué.",
      "proceedToNextStep": "Passer à l'étape suivante",
      "questionMark": "?",
      "reachOutMessage": "N'hésitez pas à communiquer avec nous si vous avez des questions.",
      "reactivateBillingFor": "Réactiver la facturation pour {location}",
      "retryPayment": "Réessayer le paiement",
      "secureSystemMessage": "Nous avons migré vers un système de facturation plus sécurisé.",
      "setupMessage": "Quelqu'un va vous contacter pour configurer le compte. Cela prend habituellement de 12 à 24 heures,",
      "signout": "Déconnexion",
      "subAccountId": "ID de sous-compte :",
      "successfullyInitiated": "{product} a bien été lancé.",
      "systemError": "Une erreur système s'est produite.",
      "toReactivate": "pour réactiver le compte",
      "userImage": "userImage",
      "verificationSkipped": "La vérification par courriel et téléphone sera ignorée pour ce sous-compte et le client pourra y accéder.",
      "verifyAccount": "Vérifier le compte",
      "verifyAfterAttempt": "Vous pouvez vérifier ce compte après au moins une tentative de vérification effectuée par l'administrateur du sous-compte",
      "verifySubAccount": "Vérifier le sous-compte",
      "recommendedPlans": "Plans Recommandés",
      "buildYourOwnPlan": "CONSTRUISEZ VOTRE PROPRE FORFAIT",
      "resetToDefaults": "Réinitialiser aux valeurs par défaut",
      "paymentMethodChange": "Si vous devez changer votre mode de paiement",
      "approveSubAccount": "Approuver le sous-compte",
      "approveSubAccountDescription": "Le sous-compte sera réactivé et les administrateurs du sous-compte pourront y accéder et l'utiliser.",
      "productInitiated": "Produit initié"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Cette action ne peut pas être annulée.",
      "cancelKeep": "Annuler, conserver",
      "confirmDeletionInstructions": "Confirmer la suppression en tapant {word} ci-dessous :",
      "enterConfirm": "Entrez {word} pour régénérer",
      "message": "La clé API de cet emplacement sera supprimée.",
      "title": "Supprimer la clé API de l'emplacement?",
      "yesDelete": "Oui, supprimer"
    },
    "generalDetails": {
      "noPermission": "Vous n’avez pas l'autorisation de téléverser le fichier. Vérifiez vos autorisations avec l'administrateur de votre agence.",
      "relatedContacts": "Contacts associés ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Voulez-vous vraiment supprimer toutes les clés API de l'emplacement?",
      "deleteAllConfirmTitle": "Supprimer toutes les clés API de l'emplacement?",
      "deleteConfirmMessage": "Cela supprimera la clé API pour l'emplacement : {location} Voulez-vous continuer?",
      "deleteAgencyApiKeyConfirmMessage": "Cela supprimera la clé API. Voulez-vous continuer?",
      "fetchingLocations": "Récupération des emplacements…",
      "maxApiKeysMessage": "Vous pouvez avoir un maximum de 5 clés API.",
      "noLocationsFound": "Aucun emplacement trouvé",
      "old": "Ancien",
      "proPlanRequiredMessage": "Cela fait partie de l’API avancée disponible sur le plan Pro.",
      "searchLocation": "Rechercher l'emplacement",
      "title": "Clé API de l'emplacement"
    },
    "locationCard": {
      "deletionScheduledMessage": "Ce sous-compte sera supprimé le {date}, si vous avez changé d'avis –",
      "emailUsageNotRebilled": "L'utilisation des courriels n'est pas refacturée.",
      "emailUsageRebilled": "L'utilisation de l'Email est refacturée à votre Client",
      "listings": "Annonces",
      "manageClient": "Gérer le client",
      "paymentPending": "Le paiement est en attente.",
      "remainingWalletBalance": "Solde disponible dans le portefeuille de cet emplacement SaaS",
      "requestPaymentAgain": "Redemander le paiement",
      "saasModeActivated": "Le mode SaaS est activé.",
      "saasModeNotActivated": "Le mode SaaS n'est pas activé.",
      "saasSubscriptionNotEnabled": "Le forfait d'abonnement SaaS n'est pas activé.",
      "saasSubscriptionRunning": "Le forfait d'abonnement SaaS est en cours.",
      "social": "Social",
      "switchToSaaS": "Passer au SaaS",
      "switchToSubAccount": "Passer au sous-compte",
      "telephoneUsageNotBilled": "L'utilisation du téléphone n'est pas facturée.",
      "telephoneUsageRebilled": "L'utilisation du téléphone est refacturée à votre client.",
      "wordpressActive": "Wordpress dynamique",
      "wordpressInactive": "WordPress inactif",
      "wordpressNotSoldYet": "WordPress n'est pas encore vendu",
      "wordpressSaleSuccessful": "Vente WordPress réussie",
      "yextActive": "Yext dynamique",
      "yextInactive": "Yext inactif",
      "yextNotSoldYet": "Yext n'est pas encore vendu",
      "yextSaleSuccessful": "Vente Yext réussie",
      "reviews": "Avis"
    },
    "messageUsage": {
      "acceptTnc": "Veuillez accepter les T&C",
      "cannotPerformAction": "Impossible d'effectuer cette action. N’hésitez pas à contacter le service d'assistance.",
      "currentLimit": "Limite actuelle",
      "days": "jour(s)",
      "failedToUpdate": "La mise à jour de l'utilisation des messages a échoué.",
      "helpCentre": "Centre d'aide",
      "increaseLimitFurther": "Augmenter la limite davantage",
      "increaseLimitNow": "Augmenter la limite maintenant",
      "lessThanUsage": "L'utilisation actuelle est de {usage}, et l'utilisation sélectionnée est inférieure à l'utilisation actuelle.",
      "lessThanUsageModal": "L'utilisation actuelle est de {usage}, la limite ne peut pas être inférieure à l'utilisation actuelle.",
      "limitAlreadyUnlocked": "La limite est déjà déverrouillée.",
      "limitReached": "Limite atteinte",
      "limitUpdatedFrom": "La limite de {type} a été mise à jour, passant de {old} à {new}.",
      "lookingForSmsLimit": "Vous recherchez une limite de SMS?",
      "minLimitShould": "La limite minimale doit être de {limit}.",
      "newLimit": "Nouvelle limite de {type}",
      "perDay": "/ Jour",
      "sameLimit": "La limite sélectionnée est identique à la limite actuelle!",
      "smsLimitLocation": "La limite de SMS peut maintenant être trouvée au niveau de l'emplacement",
      "smsLimitSettingsInfo": "Vous pouvez maintenant trouver ces paramètres sous « Limite de messagerie » dans les « Paramètres avancés »",
      "timesInLast30Days": "Fois au cours des 30 derniers jours",
      "todaysUsage": "Utilisation d'aujourd'hui",
      "typePerDay": "{type} / jour",
      "updateLimit": "Mettre à jour la limite",
      "updateLimitFor": "Mettre à jour la limite de {type} pour {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "{type} actifs",
      "contactSource": "Source du contact",
      "customer": "Client",
      "noPastCampaignsWorkflows": "{type} aucun passé",
      "pastCampaignsWorkflows": "Passé {type}"
    },
    "settings": {
      "affiliateSettings": "Paramètres d'affiliation",
      "agencyBilling": "Facturation de l'agence",
      "agencyTeamManagement": "Gestion des équipes d'agence",
      "apiKeys": "Clés API",
      "compliance": "Conformité",
      "customMenuLink": "Lien de menu personnalisé",
      "launchpadSettings": "Paramètres de la plateforme de lancement",
      "phoneSystemTwilio": "Système téléphonique – Twilio",
      "smtpService": "Service SMTP",
      "userSettings": "Paramètres utilisateur",
      "agencySettings": "Paramètres de l'agence",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Une erreur s'est produite lors de la création de l'instantané.",
      "pickAnAccount": "Vous devez sélectionner un compte.",
      "snapshotName": "Nom de l'instantané",
      "snapshotNameRequired": "Vous devez donner un nom à l'instantané."
    },
    "socialDetails": {
      "blogRss": "Blogue RSS",
      "foursquare": "Foursquare",
      "foursquareUrl": "URL Foursquare",
      "googlePlacesId": "ID d'emplacement Google",
      "googlePlus": "Google+",
      "googlePlusUrl": "URL de Google+",
      "instagramUrl": "URL Instagram",
      "linkedInUrl": "URL LinkedIn",
      "pinterest": "Pinterest",
      "pinterestUrl": "URL Pinterest",
      "yelp": "Yelp",
      "yelpUrl": "Yelp URL",
      "youTube": "YouTube"
    },
    "requestSms": "Demande via SMS",
    "iAlreadyHaveACustomer": "J'ai déjà un client.",
    "noAccountFound": "Aucun compte trouvé!!",
    "thisIs": "Ceci est",
    "pleaseEnterValueBetween0To30Days": "Veuillez entrer une valeur comprise entre 0 et 30 jours",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Découvrez comment ajouter des frais d'installation uniques à ces forfaits",
    "doNotDeleteStripeProductsWarning": "Veuillez <span style=\"font-weight: bold;\">ne pas supprimer</span> ces produits dans votre compte Stripe.",
    "opportunityStats": "Statistiques des opportunités",
    "createNewSnapshot": "Créer un nouvel instantané",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Tableau de bord de l'agence visible par",
      "onlyMe": "Moi seul",
      "allAgencyAdmins": "Tous les administrateurs de l'agence",
      "stripeConnect": "Sera bientôt abandonné. Passer à Stripe Connect",
      "recommendStripe": "Nous vous recommandons d'utiliser Stripe Connect pour une sécurité accrue.",
      "switchToStripeConnect": "Passer à Stripe Connect",
      "highLevelAccess": "HighLevel aura accès à vos données et pourra créer des paiements et des clients en votre nom.",
      "stripeAccountWarning": "Une fois connecté, le compte Stripe ne peut plus être modifié par la suite. Il est recommandé d'utiliser un nouveau compte Stripe dédié aux revenus Highlevel.",
      "connectToStripeAccount": "Connectez-vous à votre compte Stripe",
      "unverified": "Le compte Stripe connecté à cette agence n'est pas vérifié et ne peut pas percevoir les paiements. Veuillez terminer la vérification en vous connectant à votre compte Stripe.",
      "loginToStripe": "Connectez-vous à Stripe",
      "connectedAccount": "Compte connecté",
      "verified": "VÉRIFIÉ",
      "totalPendingBalance": "Montant total en attente",
      "disconnectStripe": "Déconnecter Stripe",
      "removeSaasPlanConfigurations": "Supprimer toutes les configurations de plans SaaS?",
      "haveSaasPlans": "Vous avez des forfaits SaaS créés dans le compte Stripe!",
      "disconnectWarning": "Si vous le déconnectez, tous les forfaits SaaS seront perdus et vous devrez les créer à nouveau.",
      "acknowledgeDisconnect": "Je reconnais que tous mes forfaits SaaS seront perdus et que je devrai les créer à nouveau",
      "disconnect": "Déconnecter"
    },
    "zoomSuccess": {
      "title": "J'espère que vous avez eu une excellente expérience!",
      "message": "Merci d’avoir participé à l'appel. Nous avons hâte de vous accueillir de nouveau!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Votre spécialiste en expérience d'essai",
      "successSpecialist": "Votre spécialiste du succès",
      "supportSpecialist": "Votre spécialiste en soutien",
      "jumpOnZoomCall": "Rejoignez-moi sur Zoom pour un appel de lancement",
      "jumpOnChat": "Entamez un clavardage avec moi pour obtenir de l'aide",
      "joinVideoCallNow": "Rejoindre l'appel vidéo maintenant",
      "whatToExpect": "À quoi s'attendre?",
      "helpArticles": "Articles d'aide",
      "changelog": "Journal des modifications",
      "ideasBoard": "Tableau d'idées"
    },
    "saasDashboard": {
      "title": "Tableau de bord SaaS",
      "plansAndPricing": "Forfaits et tarifications"
    },
    "listAccounts": {
      "newInterfaceAvailable": "Une interface plus propre et plus rapide est maintenant disponible pour cette page. Essayez-la!",
      "enableInLabs": "Activer dans les laboratoires",
      "pendingTransferRequests": "Vous avez des demandes de transfert de sous-compte en attente.",
      "otherAgenciesRequested": "D'autres agences ont demandé de vous transférer des sous-comptes.",
      "reviewRequests": "Demandes d'avis",
      "clientList": "Liste des clients (Sous-comptes)",
      "subAccountTransfers": "Transferts de sous-comptes"
    },
    "implementationModal": {
      "title": "Votre expérience d’appel vidéo de HighLevel est sur le point de commencer!",
      "videoCall": "Appel vidéo",
      "whatsNext": "Qu'est-ce qui suit ?",
      "enteringLobby": "Vous entrerez dans notre hall avec d'autres Highlevelers juste comme vous!",
      "successConcierge": "Notre concierge du succès vous accueillera et vous mettra en contact avec le prochain conseiller disponible pour une séance individuelle.",
      "haveReady": "Veuillez préparer les éléments suivants",
      "stableInternet": "Connexion Internet stable.",
      "videoNameMatches": "Le nom de votre vidéo correspond à votre nom d'utilisateur HighLevel.",
      "estimatedDuration": "Durée estimée de la session",
      "firstVisit": "Première visite : Session d'intégration HighLevel : (45 à 60 minutes).",
      "returning": "Retour : Assistance continue à la configuration (15 à 25 minutes).",
      "meetingBegins": "Votre réunion débutera automatiquement dans <span class=\"text-[#155EEF]\">{ countdown } secondes.</span>  Ou vous pouvez vous joindre immédiatement en cliquant sur le bouton ci-dessous :",
      "joinNow": "Rejoignez maintenant"
    },
    "gdpr": {
      "logo": "Logo du RGPD",
      "dataProtection": "Protection des données et RGPD",
      "introduction": "Introduction",
      "intro1": "HighLevel s'engage à protéger la vie privée de nos utilisateurs et de leurs clients. Nous nous tenons constamment au courant de l'évolution de la législation en matière de protection des données afin de vous assurer une sécurité optimale via notre plateforme.",
      "intro2": "Cette page vise à expliquer quelles sont les règles, comment elles s’appliquent à votre utilisation de la plateforme HighLevel et les démarches que nous avons suivies pour nous y conformer.",
      "intro3": " Vous devriez consulter ce document en lien avec notre politique de confidentialité et contacter un professionnel du droit spécialisé si vous avez besoin de plus d’informations ou de conseils.",
      "gdprRegulation": "Règlement général sur la protection des données (RGPD)",
      "regulation1": "Le règlement (UE) 2016/679, plus communément appelé Règlement général sur la protection des données (RGPD), est un règlement de l'UE visant à harmoniser les lois sur la protection des données et la confidentialité dans l'ensemble de l'UE. Les dispositions du RGPD s’appliquent partout où des données personnelles d’une personne concernée par l’UE sont concernées.",
      "regulation2": "Le RGPD vise à donner aux individus un meilleur contrôle sur l'utilisation de leurs données par les entreprises, et à rendre la collecte et le traitement des données plus transparents.",
      "regulation3": "Le RGPD a été intégré directement à la loi britannique à la fin de la période de transition du Brexit, ce qui signifie que les entreprises britanniques doivent toujours se conformer à ses dispositions via le « RGPD britannique ».",
      "basicConcepts": "Concepts de base du RGPD",
      "controllerAndProcessor": "Contrôleur et processeur",
      "controllerProcessorObligation": "Le RGPD impose diverses obligations à un individu selon qu'il est un contrôleur ou un sous-traitant de données personnelles.",
      "controllerDefinition": " Un contrôleur est une entité qui décide de traiter des données personnelles et qui prend des décisions concernant la base du traitement et les méthodes qui seront utilisées. Les contrôleurs ont certaines obligations concernant les données personnelles, que vous devriez vous familiariser avec avant de recueillir des données personnelles auprès de vos clients.",
      "processorDefinition": "Un processeur est une entité qui traite des données pour et au nom d'un contrôleur. Ils ne prennent aucune décision indépendante concernant les données ou leur traitement, car ils ne les traitent qu'au nom du contrôleur et doivent se conformer à toutes les instructions données par ce dernier.",
      "youAreController": "Quand vous utilisez le service HighLevel, vous êtes un contrôleur. Vous contrôlez les données que vous téléchargez dans le système HighLevel, ce que vous en faites, et pourquoi. En conséquence, vous êtes responsable de vous assurer d’avoir une base légale pour traiter les données, et de ne pas les conserver plus longtemps que nécessaire.",
      "highlevelIsProcessor": "Vous devez vous assurer de bien comprendre vos obligations en tant que contrôleur, et mettre à jour vos propres systèmes et politiques pour permettre le transfert légal de données personnelles vers HighLevel. HighLevel est un processeur de données. Nous, via la plateforme HighLevel, stockons et gérons les données que vous avez recueillies sous vos instructions. Nous n’utiliserons jamais aucune donnée personnelle que vous avez téléchargée dans le système HighLevel à nos propres fins ou sans vos instructions.",
      "legalBasisForProcessing": "Base juridique du traitement",
      "legalBasisRequirement": "Les données personnelles ne peuvent être recueillies et traitées que s’il existe une base légale pour le faire. Les bases juridiques admises sont énoncées dans le RGPD.",
      "processorReliesOnCustomers": "En tant que processeur, HighLevel compte sur nos clients pour choisir la base correcte dans laquelle ils collecteront et traiteront les données personnelles, ainsi que pour mettre en place les avis et consentements appropriés. Avant d’utiliser le service HighLevel, vous devriez prendre le temps d’identifier la base juridique qui pourrait vous être accessible, et ne recueillir et conserver les données personnelles que dans la mesure nécessaire pour cette base. Vous ne devriez pas changer la base sur laquelle vous avez collecté vos données personnelles sans une très bonne raison, il est donc important de comprendre les exigences des différentes bases et de vous assurer de choisir la bonne dès le départ.",
      "dataSubjectAccessRights": "Droits d’accès des personnes concernées",
      "dataSubjectRights": "Le RGPD accorde aux personnes concernées (c.-à-d. vos clients) certains droits relatifs à leurs données personnelles, y compris le droit d’accéder, de corriger et/ou de supprimer toute donnée qui les concerne.",
      "highlevelEasySystems": "HighLevel a mis en place des systèmes simples pour que vous puissiez nous informer si vous recevez une telle demande d’une personne concernée, et pour que nous puissions vous informer si nous recevons une telle demande. Nous veillerons à ce que, suivant vos instructions, ces demandes soient rapidement respectées. Vous devriez vous familiariser avec les obligations qui vous seront imposées, y compris concernant toute donnée personnelle que vous détenez sur vos propres systèmes ou services autres que HighLevel.",
      "transfersToUSA": "Transferts de données vers les États-Unis",
      "transfersRestrictions": "Les données personnelles ne peuvent pas être transférées en dehors de l'EEE sauf dans des circonstances spécifiques. Nous utilisons les clauses contractuelles types dans le cadre de notre entente de traitement des données que nous signons avec tous nos clients.",
      "dataSecurity": "Sécurité des données",
      "securitySafeguards": "Nous avons mis en place de fortes mesures de sécurité pour garantir que toutes les données personnelles que nous détenons soient stockées en toute sécurité. Nous testons régulièrement nos produits pour détecter des bogues et des vulnérabilités.",
      "backupSystems": "Nous nous assurons d’avoir des systèmes de sauvegarde réguliers en place, et de disposer de systèmes et processus de récupération et d’intégrité des données afin de minimiser le risque de corruption ou de perte de données personnelles.",
      "stepsForCompliance": "Mesures que nous avons prises pour assurer la conformité au RGPD",
      "dutyAsProcessor": "Nous prenons nos responsabilités en tant que processeur très au sérieux. Nous avons mis en place plusieurs procédures et pris plusieurs mesures afin de nous assurer que nous restons conformes au RGPD et que vous puissiez nous transmettre légalement les données personnelles recueillies par vous, par exemple :",
      "standardContractualClauses": "Notre entente de traitement des données utilise les clauses contractuelles standard afin de garantir que vous pouvez nous envoyer légalement des données personnelles aux États-Unis.",
      "detectBreaches": "Nous sommes en mesure de détecter les atteintes à la vie privée et d'informer nos clients dès que possible.",
      "dealWithAccessRequests": "Nous sommes en mesure de traiter les demandes d'accès aux données et les demandes de droit à l'effacement, et nous vous avisons lorsqu'une personne concernée nous adresse une telle demande.",
      "assessedDocumented": "Nous avons évalué et documenté les données personnelles traitées en votre nom.",
      "assessedSecurity": "Nous avons évalué notre sécurité et l'avons améliorée lorsque nécessaire afin de nous assurer qu'elle est appropriée au niveau de risque auquel nous faisons face en cas de violation de données.",
      "dataProcessingAgreement": "Entente sur le traitement des données",
      "dateUpdated": "Date de mise à jour : le 1er avril 2023",
      "downloadAgreement": "Téléchargez l'entente",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Avez-vous des questions?"
    },
    "sendGridSettings": {
      "title": "Paramètres de SendGrid",
      "settingsForLocations": "Réglages SendGrid pour les emplacements",
      "sendGrid": "SendGrid",
      "last12Months": "Les 12 derniers mois",
      "totalSent": "Total envoyé",
      "opens": "Ouvre",
      "clicks": "Clics",
      "bounces": "Rebonds"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Désactiver Launchpad pour tous mes emplacements.",
      "description1": "Launchpad est une page d'accueil bien pensée qui a prouvé son efficacité pour augmenter la satisfaction et la fidélisation des clients en augmentant l'utilisation du produit. ",
      "description2": "Connecter GMB, FB, le plugin de clavardage Web, utiliser une application mobile, etc., se sont avérés être d’excellentes fonctionnalités qui retiennent les clients plus longtemps.",
      "confirmDisable": "Êtes-vous sûr de vouloir désactiver Launchpad ?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Voici votre lien d'affiliation. Utilisez-le pour permettre à vos connaissances de créer un compte et vous recevrez 40 % de leurs revenus mensuels récurrents à vie.",
      "appendToUrls": "Ajoutez ceci à la fin de vos URL :",
      "needToSignUp": "Besoin de s'inscrire?",
      "goToUrl": "Accédez à l'URL :",
      "andSignUpUsing": "et inscrivez-vous en utilisant l'adresse courriel",
      "asYourEmailAddress": "comme votre adresse courriel pour FirstPromoter.",
      "pageSettings": "Paramètres de la page",
      "facebookPixelId": "ID de pixel Facebook",
      "pixelId": "ID de pixel"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "À partir du 17 juin 2024, la sécurité renforcée des comptes sera automatiquement activée par défaut sur votre compte. Les améliorations de la sécurité renforcée incluent :",
      "discontinuationOfAutoGeneration": "Arrêt de la génération automatique des clés API d'emplacement",
      "exclusionOfApiKeysInLocationCrudApis": "Exclusion des clés d'API dans les API CRUD d'emplacement",
      "optOutLink": "Pour vous désinscrire de ce changement, veuillez désactiver la Sécurité accrue des comptes dans <a href=\"/settings/company\">Paramètres &gt; Entreprise</a>",
      "advancedFunctionalityNote": "Cette API est destinée à des fonctionnalités avancées. Notre équipe de soutien n'est pas en mesure de fournir une assistance directe concernant la configuration de l'API.",
      "developerCouncilInfo": "Nous offrons un Conseil des développeurs qui se réunit pour des heures de bureau une fois par mois (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) et un canal Slack de la communauté des développeurs où vous pouvez obtenir de l'aide de la communauté et de notre équipe API. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "Pour utiliser Zapier, vous devez utiliser la clé API de localisation pour l'emplacement spécifique. Vous pouvez obtenir cela à partir de la liste ci-dessous ou en passant au compte à l'aide du commutateur situé dans le menu de gauche.",
      "partOfAdvancedApi": "Cela fait partie de l'API avancée qui est disponible dans le plan Pro.",
      "upgradeMessage": "Cela fait partie de l’API avancée qui est disponible dans le plan Pro. <a>Cliquez ici</a> pour mettre à niveau."
    },
    "accountMap": {
      "addAccountManually": "Ajouter un compte manuellement"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Paramètres en tant que groupes."
    },
    "accountDetails": {
      "basicDetails": "Détails de base",
      "saas": "SaaS",
      "rebilling": "Refacturation",
      "marketplaceApps": "Applis du marché",
      "advancedEmailSettings": "Paramètres avancés",
      "calendarSettings": "Paramètres du calendrier"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Contrôler les paramètres d'emplacement",
      "disableAddEmailService": "Désactivez le bouton Ajouter un service de messagerie dans les paramètres des services de messagerie du sous-compte",
      "disableAddSmtp": "Désactiver le bouton Ajouter un service de messagerie dans les paramètres des services de messagerie du sous-compte",
      "restrictSubAccountEmailProvider": "Restreindre les utilisateurs de sous-comptes à ajouter leur propre fournisseur de service de courriel",
      "disableAddSmtpDescription": "Restreindre les utilisateurs de sous-comptes à ajouter leur propre fournisseur de service de courriel",
      "enableReVerification": "Activer la revérification après 90 jours",
      "locationNoLeadConnector": "L'emplacement n'a pas LeadConnector comme fournisseur de courriels par défaut",
      "lcEmailNotEnabled": "L'emplacement n'a pas LeadConnector comme fournisseur de courriels par défaut.",
      "onlyForAgency": "Vous ne pouvez voir que ces paramètres activés pour l'agence",
      "onlyVisibleForAgency": "Vous ne pouvez voir que ces paramètres activés pour l'agence.",
      "reVerificationDescription": "Chaque statut de vérification de courriel sera révoqué après 90 jours (Protégez votre réputation d'expéditeur et assurez la meilleure délivrabilité dans la boîte de réception)"
    }
  },
  "attributes": {
    "addAttribute": "Ajouter une propriété",
    "attributeName": "Nom de la propriété",
    "enterAttributeName": "Saisissez le nom de la propriété",
    "number": "Nombre",
    "selectAttributeType": "Sélectionnez le type de propriété"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Métadonnées supplémentaires",
      "title": "Domaines ajoutés / mis à jour"
    }
  },
  "bulkActions": {
    "additionalDetails": "Détails supplémentaires",
    "allOnGivenDate": "Tout à une date donnée",
    "attempted": "Tenté",
    "batchQuantity": "Quantité du lot",
    "bulkActionProcessing": "Traitement des actions en masse",
    "bulkActionTitle": "Action en masse",
    "campaignRequired": "La campagne est obligatoire",
    "currentStatus": "Situation actuelle",
    "delayBetweenBatches": "Délai entre les lots",
    "dispatchMode": "Mode d'expédition : {mode}",
    "editBatchQuantity": "Modifier la quantité du lot",
    "emailStats": "Statistiques sur les courriels",
    "enterBatchSprintLimit": "Veuillez saisir une limite de traitement par lots",
    "hideStats": "Masquer les statistiques",
    "mode": "Mode",
    "nextProcessingOn": "Prochain traitement activé",
    "noStatsFound": "Aucune statistique trouvée",
    "parentBulkActionID": "ID d'action en masse parent",
    "pleaseEnterQuantity": "Veuillez saisir une quantité",
    "processAllAsSoonAsPossible": "Traiter tout le plus rapidement possible",
    "processAllOnGivenDate": "Traiter tout à la date indiquée",
    "processDuring": "Traitement pendant",
    "processGraduallyDrip": "Procéder graduellement (goutte-à-goutte)",
    "processingAllowedOn": "Traitement autorisé le",
    "restoredBulkActionId": "ID d’action en masse restauré :",
    "revert": "Annuler",
    "revertedBulkActionId": "ID de l'action en masse annulée :",
    "saveChanges": "Enregistrer les modifications",
    "scheduledStart": "Début programmé",
    "showErrorLog": "Afficher le journal des erreurs",
    "showImported": "Afficher les importés",
    "showStats": "Afficher les statistiques",
    "skipped": "Sauté",
    "statistics": "Statistiques",
    "statuses": {
      "complete": "Terminer",
      "next-drip": "Prochain traitement goutte à goutte",
      "notStarted": "Pas commencé",
      "processing": "En traitement",
      "queueing": "Mise en file d'attente",
      "reading": "Lecture",
      "resumed": "Reprendre",
      "reverted": "annulé",
      "waiting": "En attente"
    },
    "successful": "Réussite",
    "tagsAdded": "Mots clés ajoutés",
    "tagsRemoved": "Mots clés supprimés",
    "tagsRestored": "Mots clés restaurés",
    "timeElapsed": "Temps écoulé",
    "totalExported": "Total exporté",
    "totalMerge": "Total fusionné",
    "unknownError": "Erreur inconnue",
    "updateBatchQuantity": "Mettre à jour la quantité du lot",
    "updated": "Mise à jour",
    "usesDynamicList": "** Utilise une liste dynamique",
    "workflowRequired": "Le flux de travail est obligatoire."
  },
  "business": {
    "addedToCompany": "Contact(s) ajouté(s) avec succès à l'entreprise",
    "cantAddMoreContacts": "Impossible d'inclure plus de 50 contacts à la fois",
    "cleanerUi": "Interface utilisateur épurée",
    "common": {
      "addContact": "Ajouter un contact",
      "internalServerError": "Erreur interne du serveur",
      "to": "à"
    },
    "companiesNowHave": "Les entreprises disposent maintenant",
    "companyNoteLabsText": "Notes d'entreprise est une fonctionnalité de labos",
    "contactRemoveCompany": "Voulez-vous vraiment supprimer ce contact de l'entreprise?",
    "moreFunctionalUx": "UX plus fonctionnelle",
    "newCompanyUpdate": "Nouvelle mise à jour de l’entreprise.",
    "tabs": "Onglets",
    "tasks": {
      "assignTask": "Attribuer une tâche",
      "assignee": "Responsable",
      "deleteTask": "Supprimer la tâche",
      "editTask": "Modifier la tâche",
      "markAsComplete": "Marquer comme terminé",
      "markAsPending": "Marquer comme en attente",
      "nameAndDescription": "Nom et description",
      "noTasksAvailable": "Aucune activité disponible"
    },
    "visitLabs": "Visiter les labos"
  },
  "calendar": {
    "googleCalendar": "Google Agenda",
    "noSync": "Pas de synchronisation",
    "outlookCalendar": "Calendrier Outlook"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Activer/désactiver le débogueur frontal"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Une erreur s'est produite, veuillez réessayer",
    "tabs": "Onglets",
    "showPassword": "Afficher le mot de passe",
    "hidePassword": "Masquer le mot de passe",
    "goToHomepage": "Aller à la page d'accueil",
    "leadConnectorHqLogo": "Logo Lead Connector HQ",
    "companyLogo": "Logo de l'entreprise",
    "countries": {
      "australia": "Australie",
      "austria": "Autriche",
      "czechRepublic": "République tchèque",
      "belgium": "Belgique",
      "brazil": "Brésil",
      "canada": "Canada",
      "chile": "Chili",
      "denmark": "Danemark",
      "switzerland": "Suisse",
      "germany": "Allemagne",
      "estonia": "Estonie",
      "spain": "Espagne",
      "finland": "Finlande",
      "france": "France",
      "uk": "Royaume-Uni",
      "hongKong": "Hong Kong",
      "hungary": "Hongrie",
      "ireland": "Irlande",
      "italy": "Italie",
      "japan": "Japon",
      "kenya": "Kenya",
      "lithuania": "Lituanie",
      "mexico": "Mexique",
      "netherlands": "Pays-Bas",
      "newZealand": "Nouvelle-Zélande",
      "norway": "Norvège",
      "philippines": "Philippines",
      "puertoRico": "Porto Rico",
      "poland": "Pologne",
      "portugal": "Portugal",
      "sweden": "Suède",
      "singapore": "Singapour",
      "unitedStates": "États-Unis",
      "vietnam": "Vietnam",
      "southAfrica": "Afrique du Sud"
    },
    "countryshortcodes": {
      "ca": "CA",
      "eu": "UE",
      "in": "IN",
      "na": "NA",
      "us": "US"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "Fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "SMS",
      "api": "API",
      "otp": "OTP",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "TVA",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "MasterCard",
      "dinersClub": "Diners Club",
      "2fa": "A2F",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Modifier le pool de numéros – <strong>{name}</strong>",
      "displayphonenumber": "displayPhoneNumber",
      "js_heap_memory": "Mémoire JS Heap",
      "vuex_store_modules": "Modules du Store Vuex",
      "vuex_store_size": "Taille du Store Vuex",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "model-image",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "file-image",
      "urlimage": "url-image",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}exemple.com",
      "httpexamplecom": "http://example.com",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com ou utm_campaign=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "La vérification <strong>SHAKEN/STIR</strong> est complète pour votre sous-compte. Bâtissez la confiance avec vos clients grâce à des appels vérifiés.",
      "mp3wavfile": "fichier mp3/wav",
      "usd": "$",
      "1_555_9876543": "+1 (555) 987-6543"
    },
    "stepProgress": "Étape {currentStep} sur {totalSteps}",
    "loadMore": "Charger plus",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "1 segment équivaut à un SMS de 160 caractères. Cliquez sur l’icône pour en savoir plus sur les prix.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "1 segment équivaut à un SMS de 160 caractères. Cliquez sur l’icône pour en savoir plus sur les prix.",
    "_email": "/ courriel",
    "_ip": "/ IP",
    "_min": " / min",
    "_of_total": "% du total",
    "_please_add_a_payment_method_for": "! Veuillez ajouter une méthode de paiement pour ",
    "_segment": " / segment",
    "_used": "% utilisé",
    "a_new_twilio_account_needs_to_be_created_before_we": "Un nouveau compte Twilio doit être créé avant que nous puissions commencer la refacturation",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "Un sous-compte peut avoir jusqu'à 10 objets personnalisés. Si la limite est dépassée, aucun objet personnalisé ne sera créé à partir de cet instantané.",
    "a_twilio_account_is_already_setup_for_this_location": "Un compte Twilio est déjà configuré pour cet emplacement.",
    "accountName": "Nom du compte",
    "account_sid": "SID du compte :",
    "action": "Action",
    "actions": "Actions",
    "activate": "Activer",
    "active": "Actif",
    "active_listeners": "Auditeurs actifs",
    "active_subscriptions": "Abonnements actifs",
    "ad_manager": " Gestionnaire de publicité",
    "add": "Ajouter",
    "addAction": "Ajouter une action",
    "add_eliza": "Ajoutez Eliza",
    "add_image": "Ajouter une image",
    "add_payment_method": "Ajouter un mode de paiement",
    "add_to_account": "Ajouter au compte",
    "add_user_icon": "Ajouter une icône d'utilisateur",
    "add_your_first_email": "Ajoutez votre premier courriel.",
    "address": "Adresse",
    "adwords_reporting": "Rapports Adwords",
    "affiliate_manager": "Gestionnaire d'affiliation",
    "agency": "Agence",
    "agency_logo": "logo de l'agence",
    "agency_settings": "Paramètres de l'agence",
    "agent_reporting": "Rapports d'agent",
    "ai_employee": " Employé AI ",
    "all": "Tous",
    "allow_subaccounts_to_cancel_their_subscription": "Autorisez les sous-comptes à annuler leur abonnement",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Permettez aux sous-comptes de passer à un forfait supérieur",
    "allowed_format": "Format autorisé :",
    "am": "AM",
    "announcements_click_to_open_in_new_tab": "Annonces - cliquez pour ouvrir dans un nouvel onglet",
    "answers": "Réponses",
    "app_name": "Nom de l'application",
    "appointments": "Rendez-vous",
    "apps": " applications",
    "ask_ai": "Ask AI",
    "ask_anything": "Demandez n'importe quoi…",
    "assigned_to_another_user": "(Attribué à un autre utilisateur)",
    "at_least_one_location_is_required": "Au moins un emplacement est requis.",
    "attach_snapshot": "Joindre un instantané",
    "attribution_reporting": "Rapports d'attribution",
    "authorized_representative": "Représentant autorisé",
    "automation_type": "Type d'automatisation",
    "available_hours": "Heures disponibles",
    "avg_memoryinstance": "Mémoire moyenne/Instance",
    "back": "Retour",
    "base_url": "URL de base",
    "between_10_kb_and_5_mb": " Entre 10 Ko et 5 Mo",
    "birthday_sms": "SMS d'anniversaire",
    "birthday_sms_with_image": "SMS d'Anniversaire avec Image",
    "blogging": "Bloguer",
    "bounced": "A rebondi",
    "bulk_requests": "Demandes en masse",
    "business_email": "Courriel professionnel",
    "business_hours_configurations": "Configurations des heures d'ouverture",
    "business_industry": "Secteur d'activité",
    "business_information": "Renseignements sur l’entreprise",
    "business_logo": "Logo de l'entreprise",
    "business_niche": "Niche commerciale",
    "business_phone": "Téléphone de l'entreprise",
    "business_physical_address": "Adresse physique de l'entreprise",
    "business_regions_of_operations": "Régions d'activité",
    "business_registration_id_type": "Type d'identifiant d’enregistrement d’entreprise",
    "business_registration_number": "Numéro d’enregistrement de l’entreprise",
    "business_type": "Type d'entreprise",
    "business_website": "Site Web de l'entreprise",
    "busy": "Occupé",
    "buttons": {
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "deleteAll": "Supprimer tout",
      "view": "Voir",
      "close": "Fermer",
      "previous": "Précédent",
      "next": "Suivant",
      "clear": "Effacer",
      "save": "Enregistrer",
      "edit": "Modifier",
      "delete": "Supprimer",
      "reset": "Réinitialiser",
      "refresh": "Rafraîchir",
      "nextLoading": "Suivant...",
      "copied": "Copié",
      "notNow": "Pas maintenant",
      "send": "Envoyer",
      "send1": "Envoyer",
      "download": "Télécharger",
      "sendNow": "Envoyer maintenant",
      "saved": "Sauvegardé",
      "back": "Retour",
      "update": "Mise à jour",
      "add": "Ajouter",
      "submit": "Soumettre",
      "submitting": "Soumission en cours",
      "done": "Terminé",
      "manageUsers": "Gérer les utilisateurs",
      "no": "Non",
      "yes": "Oui"
    },
    "calendar": "Calendrier",
    "calendar_groups": "Groupes de calendriers",
    "call": "Appeler",
    "call_reporting": "Rapports d'appels",
    "call_tracking_is_disabled": "Le suivi des appels est désactivé.",
    "call_voicemail_settings": "Paramètres d'appel et de messagerie vocale",
    "calls": " appels",
    "campaign": "Campagne",
    "campaigns": "Campagnes",
    "cancel": " Annuler ",
    "cancel_subscription": "Annuler l'abonnement",
    "cancelled": "Annulé",
    "certificates": "Certificats",
    "change": "Changement",
    "changed_data": "Données modifiées",
    "charge": " Frais",
    "charged_to_customer": "Facturé au client",
    "chat": "Clavardage",
    "chat_user": "Utilisateur du clavardage",
    "chat_widget_icon": "Icône du widget de clavardage",
    "chats_will_be_saved_for_2_days": "Les clavardages seront sauvegardées pendant 2 jours",
    "check": "vérifier",
    "check_number_validity_before_first_sms_block_incom": "Vérifiez la validité du numéro avant d'envoyer le premier SMS, bloquez les appels indésirables entrants et recherchez les noms des appelants inconnus avant de répondre au téléphone. Des frais supplémentaires s'appliquent.",
    "cinque_terre": "Cinque Terre",
    "city": "Ville",
    "clear_history": "Effacer l'historique",
    "click_here": "Cliquez ici",
    "click_on_create_new_snapshot_to_add_one": " Cliquez sur Créer un nouvel instantané pour en ajouter un.",
    "click_to_access_the_highlevel_welcome_course": "Cliquez pour accéder au cours de bienvenue HighLevel.",
    "click_to_upgrade": "Cliquez pour mettre à niveau.",
    "clicked": "Cliqué",
    "clio": "Clio",
    "cloning": "Clonage",
    "close_debugger": "Fermer le débogueur",
    "close_whatsapp_template_creator": "Fermer le créateur de modèles WhatsApp",
    "collection": "Collection",
    "columns": "Colonnes",
    "coming_soon": "Bientôt disponible",
    "company_email_": "Courriel de l'entreprise (",
    "complete_component_data": "Données complètes des composants",
    "complete_event_data": "Données complètes de l'événement",
    "complete_query_data": "Données complètes de la requête",
    "completed": "Terminé",
    "complimentary_credits": "Crédits gratuits",
    "component": "Composant",
    "component_name": "Nom du composant",
    "component_type": "Type de Composant",
    "components": " composants",
    "condition": "Condition",
    "confirm": "CONFIRMER",
    "confirmation_message": "Message de confirmation",
    "confirmed": "Confirmé",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Contactez un administrateur certifié - cliquez pour ouvrir dans un nouvel onglet",
    "connect_with_us_start_live_chat": "Communiquez avec nous - démarrez le clavardage en direct",
    "connect_your_stripe_account": "connectez votre compte Stripe ",
    "connect_zoom": "Connectez-vous à Zoom.",
    "consider_leaving_it_blank_should_you_choose_to_use": "Vous pouvez laisser ce champ vide si vous choisissez d'utiliser le lieu de réunion préconfiguré.",
    "contact": "Contact",
    "contact_support": "contactez le service d'assistance",
    "contact_us_call_highlevel_at_18887324197": "Contactez-nous - appelez HighLevel au +1(888)732-4197",
    "contacts": "Contacts",
    "content_ai": "Content AI",
    "controls": "Contrôles",
    "conversations": "Conversations",
    "copied": "Copié",
    "cost_borne_by_you": " coût supporté par vous",
    "count": "Nombre",
    "country": "Pays",
    "createNewFolder": "Créer un nouveau dossier",
    "credit_balance": "SOLDE DE CRÉDIT",
    "current_location_id": "Identifiant d’emplacement actuel",
    "custom": "Personnalisé",
    "custom_email": "Courriel personnalisé",
    "custom_niche": "Niche personnalisée",
    "customer_notifications": "Notifications aux clients",
    "customize": "Personnaliser",
    "customize_chat_widget": "Personnaliser le widget de clavardage",
    "dashboard_stats": "Statistiques du tableau de bord",
    "data_keys": "Clés de données",
    "date": "Date",
    "days": "Jours",
    "dedicated_ip": "IP dédiée ",
    "default": "Par défaut",
    "default_snapshots": "Instantanés par défaut",
    "delete": "Supprimer",
    "deleted": "supprimé",
    "delivered": "Livré",
    "description": "Description",
    "details": "Détails",
    "disable_gbp_messaging_not_recommended": "Désactiver la messagerie GBP (non recommandé)",
    "disable_tracking": "Désactiver le suivi",
    "disabled": "Handicapés",
    "dismiss": "Rejeter",
    "display_name": "Nom d'affichage",
    "do_not_delete": "ne supprimez pas",
    "do_something": "FAIRE QUELQUE CHOSE",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Souhaitez-vous conserver le même ou en créer un nouveau?",
    "download_application_icon": "Télécharger l'icône de l'application",
    "draft": "Ébauche",
    "dropdown_icon": "icône de la liste déroulante",
    "duplicate": "Dupliquer",
    "duration": "Durée",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Balise de contournement Eliza (optionnelle)",
    "eliza_is_required": "Eliza est requis.",
    "eliza_service": "Service Eliza",
    "email": "Courriel",
    "email_resell_settings": "Paramètres de revente de courriels",
    "email_sending": "Envoi de courriels",
    "email_signature": "Signature de courriel",
    "enable": "Activer",
    "enable_beta": " Activer Bêta",
    "enable_company_automation": "Activer l'automatisation de l'entreprise",
    "enable_disable_deprecated_features": "Activer/Désactiver les fonctionnalités obsolètes",
    "enable_gbp_call_tracking": " Activer le suivi des appels GBP ",
    "enable_gbp_messaging": "activer la messagerie GBP",
    "enable_signature_on_all_outgoing_messages": "Activer la signature pour tous les messages sortants",
    "enabled": "Activé",
    "notEnabled": "Non activé",
    "enter_a_logical_name": "Entrez un nom logique",
    "enter_the_exact_business_address_as_it_appears_in_": "Veuillez saisir l’adresse exacte de l’entreprise telle qu’elle apparaît dans la liste EIN.",
    "enter_the_exact_legal_business_name_as_registered_": "Saisissez le nom commercial légal exact, tel qu'il est enregistré avec l'EIN.",
    "enter_the_full_street_address_as_it_appears_in_the": "Veuillez saisir l'adresse complète de la rue telle qu'elle apparaît dans la liste des numéros d'identification d'employeur (EIN).",
    "enter_user_email": "Saisissez le courriel de l’utilisateur",
    "enter_user_phone_number": "Saisissez le numéro de téléphone de l'utilisateur.",
    "enter_your_business_registration_id_type": "Saisissez le type d'identifiant d'enregistrement de votre entreprise",
    "enter_your_business_vertical_eg_travel": "Entrez votre secteur d'activité (par exemple : Voyages)",
    "error_code": "Code d'erreur",
    "error_code_chart": "Graphique du code d'erreur",
    "error_while_copying_api_key": "Erreur lors de la copie de la clé API !",
    "event": "Événement",
    "event_bus_listeners": "Auditeurs Event Bus",
    "events": " événements",
    "everything_in": "Tout dans ",
    "exact": "Exact",
    "execute_this_action_if_the_current_time_falls_in_t": "Exécutez cette action si l'heure actuelle se situe dans cette fenêtre, sinon attendez la fenêtre suivante pour exécuter cette action.",
    "extension": "Extension",
    "facebook": "Facebook",
    "facebook_ads": "Publicités Facebook",
    "facebook_ads_reporting": "Rapports sur les publicités Facebook",
    "facebook_adsets": "Facebook AdSets",
    "facebook_campaigns": "Campagnes Facebook",
    "facebook_icon": "Icône Facebook",
    "facebook_page": "Page Facebook",
    "feature_image": "image en vedette",
    "features": "Caractéristiques :",
    "feedback": "Rétroaction : ",
    "file_path": "Chemin d'accès au fichier",
    "firestore_listeners": "Auditeurs Firestore",
    "forms": "Formulaires",
    "free": "Gratuit",
    "fri": "Vendredi",
    "friendly_business_name": "Nom convivial de l'entreprise",
    "from": " de ",
    "funnels": "Entonnoirs",
    "gbp_call_tracking": "Suivi des appels GBP",
    "gbp_configuration": "Configuration GBP",
    "general": "Général",
    "general_information": "Informations générales",
    "generating_link_please_wait": "Génération du lien, veuillez patienter...",
    "google_ads_adgroups": "Groupes d'annonces Google Ads",
    "google_ads_ads": "Publicités Google Ads",
    "google_ads_campaigns": "Campagnes Google Ads",
    "google_ads_keywords": "Mots-clés Google Ads",
    "google_business_messaging": "Messagerie Google Business",
    "google_business_profile": "Profil Google Business",
    "google_my_business_icon": "Icône Google Mon entreprise",
    "hello": "Bonjour ",
    "here": "ici",
    "hhmm_a": "hh:mm A",
    "hi": "Bonjour ",
    "hide": "Cacher",
    "highlevel_events_click_to_open_in_new_tab": "Événements Highlevel – cliquez pour ouvrir dans un nouvel onglet",
    "how_can_i_help_you_today": "Comment puis-je vous aider aujourd'hui ?",
    "how_did_the_call_go": "Comment s'est passé l'appel?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "Comment calculer le coût de mon courriel? Cliquez sur l'icône pour en savoir plus.",
    "how_does_it_work": "Fonctionnement",
    "htmlElement": "Élément HTML (TODO) :",
    "html_element_todo": "Élément HTML (À FAIRE) : ",
    "id": "ID : ",
    "if": "Si",
    "if_activated_the_sender_information_will_be_automa": "Si cette option est activée, les détails de l'expéditeur seront automatiquement ajoutés au premier message SMS de tout envoi en masse afin d'assurer la conformité et d'augmenter les taux de livraison.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Si cette option est activée, nous insérerons des liens de désabonnement dans le pied de page de vos courriels, afin que les destinataires puissent se désabonner sans que le courriel ne soit considéré comme une plainte / un pourriel.",
    "ignore_this_update": "Ignorez cette mise à jour",
    "image": "image",
    "image_turned_on": "Image activée",
    "imported_date": "Date d'importation",
    "imported_snapshots": "Instantanés importés",
    "inbound": "Entrant",
    "inbound_number": "Numéro entrant",
    "incoming_call_timeout": "Délai d'attente pour les appels entrants",
    "instance_id": "ID d’Instance",
    "instances": "Instances : ",
    "instructions_mentioned_in_this_page": "les instructions mentionnées sur cette page",
    "internal": "Interne",
    "intro_message": "Message d'introduction",
    "intro_question": "Question d'Introduction",
    "invalid": "Invalide",
    "invoicing": "Facturation",
    "is_scheduled_for_deletion_on": " est programmé pour suppression sur ",
    "job_position": "Poste d’emploi",
    "job_title": "Titre du poste",
    "join_our_facebook_group_click_to_open_in_new_tab": "Joignez-vous à notre groupe Facebook – cliquez pour ouvrir dans un nouvel onglet",
    "jpg_or_png": " JPG ou PNG ",
    "just_one_sec": "Une petite seconde…",
    "key_sizes": "Tailles des clés",
    "label": "étiquette",
    "labels": {
      "sortDirection": "Direction du tri",
      "tableStyling": "Style du tableau",
      "loadingMore": "Chargement en cours...",
      "loading": "Chargement…",
      "filter": "Filtrer",
      "search": "Recherche en cours…",
      "sortBy": "Trier par",
      "perPage": "Par page",
      "date": "Date",
      "time": "Heure",
      "readMore": "En savoir plus",
      "day": "Jour",
      "slot": "Créneau",
      "template": "Modèle",
      "city": "Ville",
      "country": "Pays",
      "state": "État",
      "customerName": "Nom du client",
      "friendlyName": "Nom amical",
      "required": "* obligatoire",
      "addressLine1": "Adresse, ligne 1",
      "addressLine2": "Adresse, ligne 2",
      "postalCode": "Code postal",
      "searchUsers": "Rechercher des utilisateurs",
      "unknown": "Inconnu",
      "businessName": "Nom de l'entreprise"
    },
    "last_updated": "Dernière mise à jour",
    "launchpad_icon": "Icône de la plateforme de lancement",
    "lead": "Prospect",
    "leadconnector": "LeadConnector",
    "learn_how": "(Apprendre comment?)",
    "legal_business_name": "Nom légal de l’entreprise",
    "limit_updated_from": " limite mise à jour à partir de ",
    "listeners": " auditeurs",
    "loading_your_conversation_history": "Chargement de votre historique de conversation...",
    "location": "Emplacement",
    "locations": " emplacements",
    "logical_name": "Nom logique",
    "logical_name_is_required": "Un nom logique est requis.",
    "logo": "Logo",
    "mailgun": "MailGun",
    "making_calls": "Passer des appels",
    "manage_custom_email": "Gérer le courriel personnalisé",
    "marketing": "Marketing",
    "maximize": "Maximiser",
    "me_": "Moi (",
    "member_since": "Membre depuis",
    "membership": "Abonnement",
    "memory_analysis": "Analyse de la mémoire",
    "memory_api_not_available": "L'API mémoire n'est pas disponible.",
    "message": "Message",
    "minimize": "Réduire",
    "minimum_must_be": " Le minimum doit être ",
    "miscellaneous_charges": "Frais divers",
    "missed_call_text_back": "Message texte suite à un appel manqué",
    "missed_text_back_call_message": "Message de rappel d'appel manqué",
    "model": "Modèle",
    "module": "Module",
    "modules": " modules",
    "mon": "Lundi",
    "month": "/mois",
    "monthly": "mensuel",
    "more_emails_in_thread": " plus de courriels dans le fil de discussion",
    "mount_count": "Nombre de montages",
    "mount_time": "Temps de montage",
    "moved_to_calendar_settings": "Déplacé vers les paramètres du calendrier",
    "multiple_locations_using_same_twilio_account": "Plusieurs emplacements utilisant le même compte Twilio",
    "must_be_in_range_of_0": " Doit être dans la plage de 0 à",
    "must_be_less_than_monthly_plan_12": " Doit être inférieur au forfait mensuel * 12 ",
    "my_business_is": "Mon entreprise est ",
    "my_snapshots": "Mes instantanés",
    "name": "Nom",
    "name_of_other_registration_id_type": "Nom d'un autre type d'Id d'enregistrement",
    "newFolder": "Nouveau dossier",
    "new_task_update": "Mise à jour de la nouvelle tâche!",
    "next": "Suivant",
    "no_answer": "Aucune réponse",
    "no_bigger_than_25mb": "ne doit pas dépasser 2,5 Mo",
    "no_customer_selected": "Aucun client sélectionné",
    "no_error_data_found": "Aucune donnée d'erreur trouvée",
    "no_payment_method_available": "Aucun mode de paiement disponible",
    "no_provider_found": "Aucun fournisseur n'a été trouvé",
    "no_snapshots_found": "Aucune capture d'écran trouvée!",
    "noshow": "Absent",
    "not": "Pas",
    "not_now": "Pas maintenant",
    "not_saved": "Non enregistré",
    "notes": "Notes",
    "notifications": "Notifications",
    "now": "Maintenant",
    "numbers_and": " nombre(s) et ",
    "objective": "Objectif :",
    "of": "de",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Tutoriels vidéo d'intégration – cliquez pour ouvrir dans un nouvel onglet",
    "online_listings": "Inscriptions en ligne",
    "only_assigned_data": "Uniquement les données attribuées",
    "open_performance_debugger": "Ouvrir le débogueur de performances",
    "opened": "Ouvert",
    "opportunities": "Opportunités",
    "options": {
      "ascending": "Croissant",
      "descending": "Décroissant",
      "none": "-- Aucun --"
    },
    "or_drag_and_drop": "ou glisser-déposer",
    "outbound": "Sortant",
    "pagination": "Pagination",
    "pass_body_content_here": " Passez le contenu du corps ici ",
    "password": "Mot de passe",
    "paused": "En pause",
    "payment_links": "Liens de paiement",
    "payment_methods": "Modes de paiement",
    "payment_refund": "Remboursement de paiement",
    "payment_settings_navigation": "Navigation des paramètres de paiement",
    "payments": "Paiements",
    "payments_integration": "Intégration des paiements",
    "pending": "En attente",
    "per_page": "Par page",
    "percentage": "Pourcentage",
    "permanently_delete_this_email": "Supprimez définitivement ce courriel",
    "personal_logo": "Logo personnel",
    "phone": "Téléphone",
    "phone_number_with_country_code": "Numéro de téléphone (avec indicatif de pays)",
    "pick_a_niche": "Sélectionnez une niche",
    "pick_a_snapshot": "Choisir un instantané",
    "pick_business_industry": "Sélectionnez le secteur d’activité",
    "pick_business_registration_id_type": "Sélectionnez le type d'ID d'enregistrement de l'entreprise",
    "pick_business_type": "Sélectionnez le type d’entreprise",
    "pick_job_position": "Sélectionnez un poste",
    "plans_pricing": "Forfaits et tarifications",
    "please_enter_a_value_greater_than_20": "Veuillez entrer une valeur supérieure à 20.",
    "pm": "PM",
    "points": "Points",
    "postalzip_code": "Code postal",
    "previous": "Précédent",
    "privacy_policy_url": "URL de la politique de confidentialité",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "L'URL de la politique de confidentialité sera affichée dans les informations de votre agent Google.",
    "process_your_payment": "Traiter votre paiement",
    "profile_picture": "Photo de profil",
    "profit": "Profit",
    "prospecting": " Prospection ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Fournissez des instantanés prédéfinis aux nouveaux comptes.",
    "queries": " requêtes",
    "questions": "Questions",
    "quick_actions_icon": "Icône des actions rapides",
    "re_generate_key": "Régénérer la clé",
    "read_only": "Lecture Seule",
    "receipts_settings": "Paramètres des reçus",
    "receiving_calls": "Réception d'appels",
    "recent_events": "Événements récents",
    "recommended": "Recommandé",
    "recommended_resolution": "Résolution recommandée :",
    "reconnect": "Reconnecter ",
    "record_payment": "Enregistrer le paiement",
    "registered": " inscrit.",
    "renameFolder": "Renommer un dossier",
    "replied": "A reçuu une réponse",
    "representative_email": "Courriel du représentant",
    "resell_settings": " Paramètres de revente",
    "reset": "Réinitialiser",
    "resolve_now": "Résoudre maintenant",
    "resource_counts": "Nombre de Ressources",
    "restore": "Restaurer",
    "results": "Résultats",
    "reviews": "Commentaires",
    "rollover_unused_credits_to_next_month": "Report des crédits non utilisés sur le mois suivant",
    "row": " rangée",
    "runNow": "Exécutez maintenant",
    "sample_data": "(Exemple de données)",
    "sat": "Samedi",
    "save": "Sauvegarder",
    "save_missed_call_text_settings": "Enregistrer les paramètres de texte pour les appels manqués",
    "save_staging_url": "Enregistrer l'URL de préproduction",
    "saved": "Sauvegardé",
    "saving": "Enregistrement en cours…",
    "search": "Rechercher",
    "search_active_apps": "Recherchez des applications actives...",
    "search_components": "Rechercher des composants...",
    "search_customer": "Rechercher un client",
    "search_email": "Rechercher un courriel",
    "search_history": "Historique des recherches…",
    "search_icon": "icône de recherche",
    "search_listeners": "Rechercher des auditeurs…",
    "search_modules": "Rechercher des modules…",
    "search_queries": "Requêtes de recherche...",
    "see_this_review_on_gbp": "Consulter cet avis sur GBP ",
    "segments": " segments",
    "select": "Sélectionner",
    "select_a_snapshot": "Sélectionner un instantané",
    "monetary": "MONÉTAIRE",
    "pleaseSelectAValue": "Veuillez sélectionner une valeur",
    "select_account": "Sélectionnez un compte",
    "select_an_account": "Sélectionnez un compte",
    "select_eliza_bypass_tag": "Sélectionnez l'étiquette Eliza Bypass",
    "select_phone_number": "Sélectionner un numéro de téléphone",
    "select_send_to_eliza_tag": "Sélectionnez Envoyer à la balise Eliza",
    "select_snapshot": " Sélectionner un instantané",
    "select_upto": "Sélectionnez jusqu'à ",
    "selected": "Sélectionné : ",
    "send": "Envoyer",
    "send_to_eliza_tag_optional": "Envoyer à la balise Eliza (facultatif) ",
    "seo": " SEO ",
    "settings": "Réglages",
    "setup_pending": "Configuration en attente",
    "share": "Partager",
    "shared_snapshots": "Instantanés partagés",
    "shared_type": "Type partagé",
    "shipping_and_delivery": "Expédition et livraison",
    "shipping_origin": "Origine de l’expédition",
    "show": "Afficher",
    "showed": "Présent",
    "signin_with_single_signon": "Connexion avec authentification unique",
    "size": "Taille",
    "sms_message_sent_to_customer": "Message SMS envoyé au client",
    "snapshot_date": "Date de l'instantané",
    "snapshot_name": "Nom de l'instantané",
    "social_planner": "Planificateur social",
    "sortBy": "Trier par",
    "sortOptions": {
      "createdDate": "Date de création"
    },
    "source": "Source",
    "sources": "Sources :",
    "spent": "Dépensé",
    "staging_url_settings_for_db_event": "Paramètres de l'URL de préproduction (pour l'événement Db)",
    "state": "État",
    "state_prov_region_": "État / Province / Région *",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alaska",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "Californie",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "District de Columbia",
      "florida": "Floride",
      "georgia": "Géorgie",
      "hawaii": "Hawaï",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Louisiane",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "New Hampshire",
      "new_jersey": "New Jersey",
      "new_mexico": "Nouveau-Mexique",
      "new_york": "New York",
      "north_carolina": "Caroline du Nord",
      "north_dakota": "Dakota du Nord",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pennsylvanie",
      "rhode_island": "Rhode Island",
      "south_carolina": "Caroline du Sud",
      "south_dakota": "Dakota du Sud",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virginie",
      "washington": "Washington",
      "west_virginia": "Virginie-Occidentale",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "Aucun enregistrement trouvé",
      "noEntriesToShow": "Aucune entrée à afficher",
      "unsuccessful": "Échec",
      "pending": "En attente",
      "noUsersFound": "Aucun utilisateur trouvé"
    },
    "status": "Statut",
    "stop_delete_operation": "Arrêter l'opération de suppression",
    "street_address": "Adresse municipale",
    "street_address_as_it_appears_in_the_ein_listing": "Adresse de la rue telle qu'elle apparaît dans la liste EIN",
    "stripe_icon": "Icône Stripe",
    "stripe_integration": "Intégration Stripe",
    "stripe_secret_key": "Clé secrète Stripe",
    "subscriptions": "Abonnements",
    "sun": "Dimanche",
    "surveys": "Sondages",
    "suspend_subaccount_when_their_saas_subscription_fa": "Suspendez le sous-compte lorsque son abonnement SaaS échoue.",
    "switchAccount": "Changer de compte",
    "switch_off_sections_below_to_disable": "Désélectionnez les sections ci-dessous pour les désactiver.",
    "tags": "Balises",
    "tax_settings": "Paramètres fiscaux",
    "team_management": "Gestion du groupe",
    "team_notifications": "Notifications d'équipe",
    "template": "Modèle",
    "terms_and_conditions": "Conditions générales",
    "test_mobile_no": "Numéro de mobile de test",
    "text_messages": "Messages texte",
    "the_proposed_size_is_350px_180px": "La taille proposée est de 350 px × 180 px",
    "the_proposed_size_is_512512px": "La taille proposée est de 512*512 px",
    "the_selected_language_will_be_used_by_the_system_a": "La langue sélectionnée sera utilisée par le système comme langue par défaut.",
    "the_welcome_message_automatically_appears_after_a_": "Le message de bienvenue apparaît automatiquement après qu’un utilisateur commence une nouvelle conversation.",
    "these_are_margins_that_are_billed_to_your_clients_": "Il s'agit de marges facturées à vos clients sur la ",
    "this_data_will_be_used_for_future_compliance_regis": "Ces données seront utilisées pour l'enregistrement de conformité futur.",
    "this_is_my_twilio_use_same": "Ceci est mon Twilio, veuillez utiliser le même",
    "this_is_visible_to_both_agency_and_location": "Ceci est visible à la fois par l'agence et l'emplacement",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Ce nom sera visible pour les prospects qui clavarderont avec votre entreprise.",
    "this_setting_is_applicable_with_only_team_calendar": "Ce paramètre s’applique uniquement aux calendriers d’équipe.",
    "this_stripe_customer_is_already_connected_to_anoth": "Ce client Stripe est déjà relié à un autre sous-compte.",
    "thu": "Jeudi",
    "tiktok": "Tiktok",
    "time_signed": " Heure signée : ",
    "time_zone_": "Fuseau horaire *",
    "timestamp": "Horodatage",
    "title": "Titre",
    "to_resolve_this_problem_follow_the": "Pour résoudre ce problème, suivez les ",
    "token": "Jeton :",
    "total": "Total : ",
    "trigger_link": "Lien de déclenchement",
    "triggers": "Déclencheurs",
    "tue": "Mardi",
    "twilio": "Twilio",
    "twilio_setup_pending": "Configuration de Twilio en attente",
    "type": "Type",
    "type_campaign_objective": "Tapez l'objectif de la campagne",
    "type_message": "Tapez un message",
    "unsavedChangesWarning": "Vos modifications ne seront pas enregistrées. Êtes-vous certain de vouloir quitter ?",
    "unsaved_changes": "Modifications non enregistrées",
    "unsubscribed": "Désabonné",
    "unsuccessful": "Échec",
    "update_business_profile_details": "Mettre à jour les informations du profil d'entreprise",
    "update_is_inprogress_visit_integrations_page_to_fi": "La mise à jour est en cours. Veuillez consulter la page des intégrations pour en savoir plus.",
    "update_url": "Mettre à jour l'URL",
    "updated_date": "Date de mise à jour",
    "updates": " mises à jour",
    "updating": "Mise à jour en cours…",
    "upgrade_to_agency_pro": "Passez à Agency Pro ",
    "upload": "Téléverser",
    "upload_a_file": "Téléverser un fichier",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Utilisez ceci pour Zapier et l'intégration API.",
    "user_email": "courriel de l'utilisateur",
    "user_permissions": "Autorisations des utilisateurs",
    "user_role": "Rôle de l'utilisateur",
    "user_type": "Type d'utilisateur",
    "valid": "Valide",
    "verification_status": "Statut de vérification",
    "verify": "Vérifier",
    "verify_email_using_otp": "Vérifiez votre adresse courriel à l'aide d'un mot de passe à usage unique.",
    "view_less": " Voir moins ",
    "visiblehidden": "Visible/Masqué",
    "visit_our_help_center_click_to_open_in_new_tab": "Consultez notre Centre d'aide – cliquez pour ouvrir dans un nouvel onglet",
    "voicemail": "Boîte vocale",
    "wave_integration": "Intégration Wave",
    "we_have_found_some_errors_in_your_contact_fields_c": "Nous avons trouvé une ou des erreurs dans vos champs de contact. Cliquez sur le dossier pour les afficher et les corriger.",
    "websites": "Sites Web",
    "wed": "Mercredi",
    "welcome_message": "Message d'accueil",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "Icône WhatsApp",
    "when": "Quand",
    "when_selected_calls_will_be_routed_to_your_mobile_": "Lorsque sélectionnés, les appels seront acheminés vers votre application mobile. (compatible avec iOS et Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "Lorsque cette option est sélectionnée, les appels sont acheminés vers votre application Web.",
    "which_business_do_you_want_to_link_to_this_locatio": "Quelle entreprise voulez-vous lier à cet emplacement?",
    "widget_code": "Code du widget",
    "will_give_you_about": " vous donnera environ",
    "wordpress": "WordPress",
    "wordpress_icon": "Icône WordPress",
    "workflows": "Flux de travail",
    "xero_integration": "Intégration Xero",
    "you_need_to_complete_few_easy_steps_to_delete_this": "Vous devez suivre quelques étapes simples pour supprimer cet emplacement.",
    "you_are_not_authorized_to_perform_this_action_only": "Vous n’êtes pas autorisé à effectuer cette action. Seuls les administrateurs de l'agence peuvent supprimer des sous-comptes.",
    "your_email_cost": "Le coût de votre courriel",
    "your_facebook_page_has_been_integrated_however_the": "Votre page Facebook a été intégrée. Cependant, les fonctionnalités suivantes ne fonctionneront pas, car LeadConnector n'a pas les autorisations requises : ",
    "your_outlook_connection_has_expired_please_disconn": "Votre connexion Outlook a expiré. Veuillez vous déconnecter et vous reconnecter avec le compte pour établir la connexion.",
    "zip_code": "Code postal",
    "zoom_connected_please_close_this_modal": "Zoom connecté, veuillez fermer cette fenêtre modale.",
    "hidden": "Caché",
    "messageDetails": "Détails du message",
    "openOptions": "Options disponibles",
    "progress": "Progrès",
    "close": "Fermer",
    "loading": "Chargement",
    "fullName": "Nom complet",
    "languages": "Langues",
    "phoneNumber": "Numéro de téléphone",
    "phoneNumberWithCountry": "Numéro de téléphone avec indicatif de pays",
    "sendMessage": "Envoyer un message",
    "services": "Services",
    "servicesProvided": "Services fournis",
    "pleaseProvideAValid": "Veuillez fournir un numéro de téléphone valide.",
    "copy": "Copier",
    "editApiKey": "Modifier la clé API",
    "confirmPay": "Confirmer et payer",
    "contactUs": "Contactez nous",
    "decline": "Refuser",
    "deleteSubaccount": "Supprimer le sous-compte",
    "disabled1": "désactivé",
    "purchaseSummary": "Résumé des achats",
    "subscriptionPlan": "Forfait d'abonnement",
    "businessName": "Nom de l'entreprise",
    "chooseOne": "Sélectionnez-en un….",
    "stateProvRegion": "État/Province/Région",
    "streetAddress": "Adresse civique",
    "timeZone": "Fuseau horaire",
    "website": "Site Web",
    "zipPostalCode": "Code postal",
    "apiKey": "Clé API",
    "createdAt": "Créé à",
    "deleteAllLocationApi": "Supprimer toutes les clés API de l'emplacement",
    "deleteApiKey": "Supprimer la clé API",
    "generatedBy": "Généré par",
    "lastUsedAt": "Dernière utilisation le",
    "pageNavigation": "Navigation dans la page",
    "somethingWentWrong": "Une erreur s'est produite!",
    "clickHere": "Cliquez ici",
    "emailRebillingActive": "Refacturation par courriel activée",
    "saasSubscriptionActive": "L'abonnement SaaS est actif.",
    "scheduledForDeletion": "Suppression prévue",
    "twilioRebillingActive": "Refacturation Twilio activée",
    "iAcknowledgeThisIs": "Je reconnais qu'il s'agit d'un sous-compte valide et j'ai vérifié le cas d'utilisation consistant à envoyer plus de {limit} {type}/jour.",
    "iAcknowledgeThisIs1": "Je reconnais qu'il s'agit d'un sous-compte valide et j'ai vérifié le cas d'utilisation des envois, ce qui m'a permis d'ajuster la limite quotidienne de SMS.",
    "emailSentByLocation": "Courriels envoyés par le site Web depuis le début de la journée.",
    "goToSmsLimit": "Accéder aux paramètres de limite de SMS",
    "toIncreaseTheLimit": "Pour augmenter la limite, contactez l'équipe d'assistance.",
    "newLimitOfLimit": "La nouvelle limite de {limit} n'est pas valide. Veuillez fournir une valeur entre {min} et {max}.",
    "typeLimitUpdatedSuccessfully": "La limite de {type} a bien été mise à jour",
    "locationsCurrentLimitIs": "La limite actuelle de l'emplacement est de {current}. Vous ne pouvez mettre à jour la limite qu'entre {min} et {max} à parti d'ici. Pour toute mise à jour de limite au-delà de {maxAllowed}, veuillez communiquer avec le groupe d'assistance.",
    "notNow": "Pas maintenant",
    "smsSentByLocation": "SMS envoyés par emplacement jusqu'à présent aujourd'hui.",
    "youHaveSuccessfullyUpdated": "Vous avez bien mis à jour la limite.",
    "willAutoUnlockIn": "Se déverrouille automatiquement dans",
    "contactType": "Type de contact",
    "createdBy": "Créé par :",
    "createdOn": "Créé le :",
    "dateOfBirth": "Date de naissance",
    "emailAddress": "Adresse courriel",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "twilioLookupMarkedThis": "Twilio Lookup a marqué ce numéro de téléphone comme non valide.",
    "twilioLookupStatedThis": "Twilio Lookup a indiqué qu'il s'agit d'un numéro {type}, il ne recevra donc pas de SMS.",
    "accountSnapshot": "Instantané du compte",
    "auditLogs": "Journaux d'audit",
    "account": "Compte",
    "selectAccount": "Sélectionner un compte",
    "facebookUrl": "URL Facebook",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "URL Twitter",
    "youtubeUrl": "URL YouTube",
    "text": "Texte",
    "allTagsLinkedTo": "Tous les mots-clés liés aux contacts sélectionnés doivent être supprimés.",
    "automation": "Automatisation",
    "bulkOperation": "Opération en masse",
    "campaign1": "Campagne",
    "created": "Créé",
    "dateTime": "Date et heure",
    "description1": "Description",
    "drip": "Goutte à goutte",
    "edit": "Modifier",
    "someStatsAreNot": "Certaines statistiques ne sont pas disponibles si le fournisseur est SMTP. La précision des statistiques dépend du domaine du destinataire.",
    "error": "Erreur",
    "from1": "De",
    "immediately": "Immédiatement",
    "pause": "Pause",
    "processed": "Traité",
    "queued": "En file d'attente",
    "restored": "Restauré",
    "resume": "Reprendre",
    "sent": "Envoyé",
    "scheduled": "Prévu",
    "success": "Succès",
    "templateName": "Nom du modèle",
    "total1": "Total",
    "totalAttempted": "Nombre total de tentatives",
    "user": "Utilisateur",
    "viewDetails": "Voir les détails",
    "workflow": "Flux de travail",
    "company": "Entreprise",
    "note": "Note",
    "perPage": "par page",
    "showing": "Affichage",
    "task": "Tâche",
    "tasks": "Tâches",
    "customFields": "Champs personnalisés",
    "dueDate": "Date d’échéance",
    "tryNow": "Essayez maintenant!",
    "archive": "Archives",
    "markAsRead": "Marquer comme lu",
    "markAsUnread": "Marquer comme non lu",
    "youNeedToAdd": "Vous devez ajouter un calendrier pour commencer à planifier des rendez-vous.",
    "additionalNotes": "Remarques supplémentaires",
    "appointmentStatus": "Statut du rendez-vous",
    "appointmentTitle": "Titre du rendez-vous",
    "contactName": "Nom du contact",
    "contactTimezoneUsedFor": "Fuseau horaire du contact (utilisé pour les rappels)",
    "day": "Jour",
    "editAppointment": "Modifier le rendez-vous",
    "nameRequired": "Nom obligatoire",
    "slotRequired": "Créneau obligatoire",
    "teamMemberIsRequired": "Un membre de l'équipe est obligatoire.",
    "meetingLocation": "Lieu de la réunion",
    "pickTeamMember": "Sélectionnez un membre de l'équipe.",
    "phoneNumbers": "Numéros de téléphone",
    "roundRobin": "Tour de table",
    "selectCalendar": "Sélectionnez un calendrier.",
    "selectTeamMember": "Sélectionnez un membre de l'équipe.",
    "actionRequired": "Action requise",
    "scheduleAppointment": "Planifier un rendez-vous",
    "considerLeavingItBlank": "Laissez ce champ vide si vous choisissez d'utiliser le titre du rendez-vous préconfiguré.",
    "assignedTo": "Attribué à",
    "download": "Télécharger",
    "loadingTranscription": "Chargement de la transcription…",
    "mute": "Mode Silencieux",
    "playpause": "Lecture/Pause",
    "playbackSpeed": "Vitesse de lecture",
    "remove": "Supprimer",
    "stop": "Arrêter",
    "timePlayedTotalTime": "Temps joué : Temps total",
    "viewTranscript": "Voir la transcription",
    "below": "ci-dessous",
    "calls1": "Appels",
    "liveChat": "Live Chat",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Conversation de clavardage assignée",
    "youAreChoosingNot": "Vous choisissez de ne pas supprimer ni fermer le sous-compte LC Phone, ce qui signifie que vous serez toujours facturé(e) pour toute l'utilisation, indépendamment du fait que l'emplacement soit facturé ou non.",
    "thingsAreJustGetting": "Ce n'est que le début, explorons comment GHL peut vous aider à développer votre entreprise.\nEn attendant, vous pouvez continuer à envoyer des messages autant que vous le souhaitez",
    "wohooConversationsAreFlowing": "Super! Les conversations sont fluides maintenant.",
    "conversationBegan": "Conversation a commencée",
    "fetchOlderMessages": "Récupérer les anciens messages",
    "inboundDndHasBeen": "La fonction DND entrant a été activée pour ce contact.",
    "internalComment": "Commentaire interne",
    "confirmByTyping": "Confirmez en tapant via",
    "iConfirmToDisconnect": "Je confirme la déconnexion et la fermeture du compte LC Phone pour cet emplacement. J'ai conscience que cela signifie que tous les numéros et toutes les campagnes A2P seront supprimés et ne pourront pas être récupérés.",
    "iConfirmThatI": "Je confirme que j’en ai discuté avec mon client et que j’ai l’autorité pour prendre cette mesure",
    "connect": "Connecte-toi",
    "disputeThisReview": "Contester cet avis",
    "dndIsActiveFor": "La fonction DND est active pour les appels.",
    "off": "DÉSACTIVÉ",
    "done": "Terminé",
    "downloadFile": "Télécharger le fichier",
    "AddAccount": "+ Ajouter un compte",
    "attachFile": "Joindre un document",
    "clickHereToAdd": "Cliquez ici pour en ajouter un.",
    "customerName": "Nom du client",
    "customerPhone": "Téléphone du client",
    "orEnterAMessage": "Ou saisissez un message",
    "fromEmail": "À partir d'un courriel",
    "fromName": "Nom de l’expéditeur",
    "youDontHaveAny": "Vous n'avez pas encore de modèles.",
    "requestPayment": "Demander un paiement",
    "schedule": "Programmation",
    "selectATemplate": "Sélectionnez un modèle",
    "sendNow": "Envoyer maintenant",
    "smtpProvidersHasSome": "Les fournisseurs SMTP présentent certaines limitations. Cliquez ici pour en savoir plus.",
    "subject": "Objet",
    "useATemplateSnippet": "Utilisez un modèle (extrait)",
    "deliveredtotalDelivered": "{delivered}/{total} envoyé(s)",
    "countMoreEmailsIn": "{count} autres courriels dans le fil",
    "primary": "(Principal)",
    "reply": "Réponse",
    "respond": "Répondre",
    "retry": "Réessayer",
    "to": "À :",
    "fbCommentReplyDm": "Réponse au commentaire FB – DM",
    "fbMessage": "Message FB",
    "theseAttachmentsMayNot": "Ces pièces jointes pourraient ne plus être prises en charge.",
    "urlCannotBeFound": "L’URL est introuvable",
    "activity": "Activité",
    "filters": "Filtres",
    "goToPost": "Accéder à la publication",
    "inboundCall": "Appel entrant",
    "instagramDm": "DM Instagram",
    "internalChat": "Clavardage interne",
    "search2": "Recherche...",
    "starred": "Étoilé",
    "leftAVoicemail": "A laissé un message vocal",
    "manual": "Manuel",
    "mergeFields": "Fusionner les champs",
    "addToDocuments": "Ajouter aux fichiers",
    "failedToAddAttachments": "Échec de l’ajout des pièces jointes aux fichiers",
    "attachmentsAddedToDocuments": "Les pièces jointes ont bien été ajoutées aux documents.",
    "newCommentOnPagename": "Nouveau commentaire sur la publication {pageName}.",
    "outboundCall": "Appel sortant",
    "replyAsDm": "Répondre en tant que DM",
    "replyingAsAPrivate": "La réponse en tant que DM privé n'est pas disponible pour les commentaires datant de plus de 7 jours.",
    "reportFeedbackForAi": "Signaler des commentaires pour l’IA",
    "storyMention": "Mention de l’histoire",
    "storyReply": "Réponse à l’histoire",
    "bulkRequest": "Demande en masse",
    "eventsAreCurrentlyCaptured": "Les événements ne sont actuellement saisis que pour l'adresse courriel du contact.",
    "failed": "Échec",
    "gbpMessage": "Message GBP",
    "pageName": "Nom de la page",
    "unknown": "Inconnu",
    "typeAMessage": "Tapez un message.",
    "new": "Nouveau",
    "newAppointmentBookedBy": "Nouveau rendez-vous réservé par",
    "customerNameRequired": "Le nom du client est obligatoire.",
    "messageIsRequired": "Le message est obligatoire.",
    "pickATemplateTo": "Choisissez un modèle à utiliser.",
    "newMessage": "Nouveau message",
    "newTask": "Nouvelle tâche",
    "toMakeACall": "Pour passer un appel, veuillez saisir un numéro de téléphone dans ce champ.",
    "primary1": "Principal",
    "provider": "Fournisseur",
    "refresh": "Rafraîchir",
    "resetPassword": "Réinitialiser le mot de passe",
    "thisReviewHasAlready": "Cet avis a déjà été publié sur {network}. Voulez-vous vraiment le republier?",
    "seeThisReviewOn": "Consulter cet avis sur GBP",
    "reviewResponse": "Réponse à l'avis",
    "searchUsers": "Rechercher des utilisateurs",
    "sendEmail": "Envoyer un courriel",
    "sending": "Envoi en cours…",
    "thisSubaccountHasPhonenumberco": "Ce sous-compte a {phoneNumberCount} numéros et {campaignsCount} campagne(s) A2P. La suppression de ce compte entraînera toujours des frais si le compte LC Phone System n'est pas déconnecté et fermé.",
    "thisSubaccountDoesNot": "Ce sous-compte n'a pas de numéros ni de campagnes A2P. La mise en pause de ce compte ne vous occasionnera pas de frais, mais nous vous conseillons de déconnecter et de fermer le compte LC Phone.",
    "summary": "Résumé",
    "unassigned": "Non assigné",
    "viewSubmission": "Afficher la soumission",
    "contactSupport": "Communiquer avec le service d'assistance",
    "create": "Créer",
    "illDoThisLater": "Je le ferai plus tard.",
    "enterBusinessName": "Saisissez le nom de l'entreprise.",
    "firstNameOfThe": "Prénom du propriétaire de l'entreprise",
    "mobileBusinessPhone": "Téléphone cellulaire / de l'entreprise",
    "iDontHaveA": "Je n'ai pas de site Web.",
    "clientName": "Nom du client",
    "letUsSetupYour": "Laissez-nous configurer votre propre compte ou votre premier client.",
    "clientNameIsRequired": "Le nom du client est obligatoire.",
    "pleaseEnterAValid": "Veuillez saisir une adresse courriel valide",
    "emailAddressIsRequired": "L'adresse courriel est obligatoire.",
    "firstNameIsRequired": "Le prénom est obligatoire",
    "lastNameIsRequired": "Le nom de famille est obligatoire.",
    "phoneNumberIsRequired": "Le numéro de téléphone est obligatoire.",
    "copyOfName": "Copie de {name}",
    "goToDashboard": "Accéder au tableau de bord",
    "permissionsNotEnabled": "Autorisations non activées!",
    "createAndSellCustom": "Créez et vendez des produits personnalisés avec le parachutage d'impression à la demande.",
    "viewApp": "Voir l'appli",
    "seamlessFulfillmentRealtimeShi": "Exécution sans faille et tarifs d'expéditions en temps réel pour vos boutiques de commerce électronique",
    "learnMore": "En savoir plus",
    "activateFormMapping": "Activer le mappage de formulaire",
    "avatarName": "Nom de l'avatar",
    "formFields": "Champs de formulaire",
    "formName": "Nom du Formulaire",
    "mapFields": "Mapper les champs",
    "update": "Mise à jour",
    "pauseSubaccount": "Mettre en attente le sous-compte",
    "pausing": "En pause…",
    "subaccount": "sous-compte",
    "howItWorks": "Comment ça fonctionne",
    "uponCompletingThisAction": "Une fois cette action terminée, la demande de transfert sera envoyée à l'agence destinataire ({relNo}). Le sous-compte sera transféré dès qu'il aura été accepté. Veuillez noter que cette action est irréversible.",
    "ejectSubaccount": "Éjecter le sous-compte",
    "newAgencyCreationMail": "Un courriel de création de nouvelle agence a été envoyé à l'utilisateur sélectionné. L'utilisateur peut créer une nouvelle agence en cliquant sur le lien envoyé dans le courriel.",
    "unableToTransferSubaccount": "Impossible de transférer le sous-compte à cette agence.",
    "nominateAccountOwnerFor": "Nommez le propriétaire du compte pour le nouveau compte.",
    "pleaseConfirmOwnershipWill": "Veuillez confirmer que la propriété sera transférée à",
    "scheduledDate": "Date prévue",
    "thisDateIsBased": "Cette date est basée sur le fuseau horaire de cette entreprise, qui est {timezone}.",
    "campaignName": "Nom de la campagne",
    "copyCampaign": "Copier la campagne",
    "endTime": "Heure de fin",
    "event10xEmail4": "Événement : 10X courriel 4 (Distribution de la liste) ",
    "10xEmail1Reviews": "10X courriel 1 (Révisions)",
    "fromAddress": "De l'adresse",
    "leadValue": "Valeur du prospect",
    "option1": "Option 1",
    "option2": "Option 2",
    "option3": "Option 3",
    "preview": "Aperçu",
    "selectCampaign": "Sélectionnez la campagne.",
    "startTime": "Heure de début",
    "time": "Heure",
    "users": "Utilisateurs",
    "noRecordsFound": "Aucun enregistrement trouvé",
    "pageDetail": "Détails de la page",
    "selectAll": "Sélectionner tout",
    "submission": "Soumission",
    "addProduct": "Ajouter un produit",
    "visitors": "visiteurs",
    "By": " par",
    "conversions": "Taux de conversion ",
    "liveReviews": "Avis en direct",
    "liveVisitors": "Visiteurs en direct",
    "pageVisits": "Visites de page",
    "stream": "Diffusion",
    "addOneOrMore": "Ajoutez une ou plusieurs URL de pages ou copiez-les directement depuis votre navigateur Web.",
    "WeWillAutomatically": " Nous suivrons automatiquement les visiteurs de votre site Web en temps réel. ",
    "connectYourLocationsFacebook": "Connectez le compte Facebook de votre emplacement.",
    "connected": "Connecté!",
    "Contains": " contient ",
    "expression": "Expression",
    "facebookAccount": "Compte Facebook",
    "wowYouDontNeed": "Waouh! Vous n'avez rien à configurer ici, vous pouvez continuer.",
    "Regex": " regex ",
    "selectUrlMatchType": "Sélectionnez le type de correspondance d'URL.",
    "Simple": " simple ",
    "LivePreview": " Aperçu en direct",
    "seconds": "secondes",
    "launch": "Lancement ",
    "decorativeVector1": "Vecteur décoratif 1",
    "showingFromToTo": "Afficher les entrées {from} à {to} sur {total}",
    "cloneProduct": "Dupliquer le produit",
    "connectFacebookInstagram": "Connecter Facebook et Instagram",
    "connectPage": "Connectez la page !",
    "everythingIn": "Tout dans",
    "agentChat25": "Clavardage avec un agent (~ 2 à 5 min d'attente)",
    "aiSupportChat": "Clavardage d'assistance par IA",
    "startChat": "commencer le clavardage",
    "locations1": "emplacements",
    "phone1": "téléphone",
    "slack": "Slack",
    "segments1": "segments",
    "areYouSureYou": "Êtes-vous sûr de vouloir supprimer ce dossier?",
    "verified": "Vérifié",
    "highlevelPrice": "Prix HighLevel",
    "howDoesItWork": "Comment ça fonctionne?",
    "payNow": "Payer maintenant",
    "priceMustBeMore": "Le prix doit être supérieur ou égal au prix HighLevel.",
    "saving2": "Sauvegarde en cours",
    "yourPrice": "Votre prix",
    "yourProfit": "Votre marge",
    "youNeedToComplete": "Vous devez suivre quelques étapes simples pour désactiver le mode SaaS pour cet emplacement",
    "youAreNotAuthorized": "Vous n’êtes pas autorisé à effectuer cette action. Seuls les administrateurs de l'agence peuvent l'effectuer.",
    "disableSaasModeFor": "Désactiver le mode SaaS pour {name}",
    "companyBilling": "Facturation de l'entreprise",
    "bccEmailsCommaDelimited": "Courriels CCi (séparés par des virgules)",
    "unableToDeleteMailgun": "Impossible de supprimer le compte Mailgun, veuillez contacter le service d'assistance.",
    "forwardingAddress": "Adresse de renvoi",
    "forwardingAddressesCommaDelimi": "Adresses de renvoi (séparées par des virgules)",
    "amount": "Montant",
    "billingDate": "Date de facturation",
    "debugWalletTransactionsTotal": "Transactions du portefeuille DEBUG, total : {count}",
    "detailedTransactions": "Transactions détaillées",
    "transactionsOnlyAfter26th": "Seules les transactions postérieures au 26 avril 2022 sont répertoriées et disponibles à l'exportation",
    "someRecordsMayTake": "La mise à jour de certaines données peut prendre jusqu'à 24 heures.",
    "totalBalance": "Montant total",
    "walletTransactions": "Transactions du portefeuille",
    "walletTransactionsAllDate": "Transactions du portefeuille – Toutes – {date}",
    "enterMessage": "Saisissez un message.",
    "applyThisChangeTo": "Appliquez ce changement à tous les sous-comptes.",
    "characters": "Caractère",
    "iConfirmThatI1": "Je confirme que j’en ai discuté avec mon client et que j’ai son approbation.",
    "iConfirmThatI2": "Je confirme que je veillerai à ce que tous les messages SMS envoyés à partir de ce compte soient conformes à la politique actuelle.",
    "theContentsOfThis": "Le contenu de ce message sera automatiquement ajouté au premier SMS envoyé par le biais des messages en masse.",
    "iConfirmThatSms": "Je confirme que les messages SMS ne seront envoyés qu'aux contacts qui ont choisi de recevoir des SMS.",
    "quickTip": "Astuce rapide",
    "messageWillBeAppended": "Le message sera ajouté au premier SMS d'une conversation s'il ne contient pas de clause de désabonnement.",
    "readMore": "Lire la suite",
    "noncompliantActivityMayLead": "Toute activité non conforme peut entraîner la suspension des fonctionnalités vocales et de SMS de votre compte.",
    "typeConfirmBelowTo": "Tapez « Confirmer » ci-dessous pour continuer.",
    "products": "Produits",
    "chooseCountry": "Sélectionner le Pays...",
    "email2": "Courriel*",
    "firstName1": "Prénom*",
    "lastName1": "Nom de famille*",
    "brandDetails": "Détails de la marque",
    "brandName": "Nom de la marque*",
    "useEitherLegalName": "Utilisez soit le nom légal de l’organisation qui envoie les messages, soit votre propre nom si cette marque n’est pas pour une organisation.",
    "businessIndustry": "Secteur d'activité*",
    "chooseVertical": "Choisissez un secteur d’activité…",
    "mobileNumberForOtp": "Numéro de cellulaire pour la vérification par mot de passe unique (avec indicatif de pays)*",
    "pleaseProvideAMobile": "Veuillez fournir un numéro de cellulaire auquel vous avez accès afin de confirmer la vérification OTP. Seuls les numéros américains/canadiens seront acceptés. Vous ne pouvez pas utiliser un numéro de téléphone CPaaS tel que celui obtenu auprès de LeadConnector. Vous ne pouvez pas utiliser le même numéro de cellulaire pour enregistrer plus de 3 marques de propriétaire unique. Cette limite est gérée par TCR.",
    "increasedDeliveryRate": "Augmentation du taux de livraison",
    "sendUpto3000Segments": "Envoyez jusqu'à 3 000 segments par jour",
    "businessDetails": "Détails de l'entreprise",
    "thereWasSomeIssue": "Un problème est survenu lors de la soumission du profil.",
    "yourProfileSubmissionFailed": "La soumission de votre profil a échoué.",
    "endUserConsent": "Consentement de l'utilisateur final",
    "minLength40Characters": "Longueur minimale : 40 caractères. Longueur maximale : 2 096 caractères.",
    "closeExamples": "Fermer les exemples",
    "sampleMessage1": "Exemple de message n° 1*",
    "seeExamples": "Voir des exemples",
    "enterCampaignDetails": "Saisissez les détails de la campagne.",
    "youWillReceiveAn": "Vous recevrez un message OTP sur le numéro de téléphone mobile que vous avez fourni afin de vérifier votre identité auprès de TCR. Veuillez répondre « Oui » dans les 24 heures suivant la réception du SMS.",
    "brandNameIsRequired": "Le nom de la marque est obligatoire.",
    "businessVerticalIsRequired": "Le secteur d'affaires est obligatoire.",
    "mobileNumberIsRequired": "Le numéro de cellulaire est obligatoire.",
    "hideDetail": "Cacher les détails",
    "showDetail": "Afficher les détails",
    "people": "personne",
    "person": "personne",
    "after": "après",
    "before": "avant",
    "hour": "heure",
    "hours": "heures",
    "minute": "minute",
    "minutes": "minutes",
    "triggerLinksEmbeddedIn": "Pourcentage des liens de déclenchement (intégrés dans le message) ayant reçu un clic par rapport aux messages envoyés",
    "addNewEvent": "Ajouter un nouvel événement",
    "addTask": "Ajouter une tâche",
    "manualCall": "Appel manuel",
    "manualSms": "SMS manuel",
    "messenger": "Messenger",
    "wait": "Attendre",
    "webhook": "Webhook",
    "about": "À propos",
    "accessRestricted": "Accès limité",
    "addPartner": "Ajouter un partenaire",
    "addPartnerForm": "Ajouter un formulaire de partenaire",
    "affiliatePortal": "Portail d'Affiliation",
    "badges": "Insignes",
    "aBriefBio": "Une brève biographie",
    "dashboard": "Tableau de bord",
    "experience": "Expérience",
    "industryServed": "Industrie desservie",
    "instagramAccount": "Compte Instagram",
    "invoiceHistory": "Historique des factures",
    "englishGermanHindi": "Anglais, Allemand, Hindi",
    "linkToWebsite": "lien vers le site Web",
    "linkedinAccount": "Compte LinkedIn",
    "locationId": "Id d’emplacement",
    "partnerName": "Nom du partenaire",
    "partnerStatus": "Statut de partenaire",
    "paymentDetails": "Détails du paiement",
    "paymentHistory": "Historique de paiement",
    "profilePhoto": "Photo de profil",
    "profilePhotoUrl": "url de la photo de profil",
    "promoterReports": "Rapports des promoteurs",
    "searchPartner": "Rechercher des partenaires",
    "twitterAccount": "Compte Twitter",
    "updatePartner": "Mettre à jour le partenaire",
    "updatePartnerForm": "Mise à jour du formulaire de partenaire",
    "yearOfExperience": "années d'expérience",
    "youtubeAccount": "Compte YouTube",
    "serviceProvided": "Service fourni",
    "controlTheSubaccountSettings": "Contrôler les paramètres du sous-compte",
    "generalInfo": "Informations générales",
    "okay": "D'accord",
    "proceed": "Poursuivre",
    "addCard": "Ajouter une carte",
    "makeThisCardPrimary": "Définir comme carte principale",
    "nameOnCard": "Nom sur la carte",
    "chargedToCustomer": "Facturé au client",
    "clientBillingPage": "Page de facturation client",
    "companyStripeIntegrationPage": "Page d'intégration Stripe de l'entreprise",
    "enableRebilling": "Activer la refacturation",
    "enabling": "Activation en cours…",
    "forMoreDetails": "pour plus de détails.",
    "youreOnTheFreelancer": "Vous êtes sur le forfait Freelancer (pigiste) qui vous limite à 1,05x de majoration.",
    "minimumAmountShouldBe": "Le montant minimal doit être compris entre ${min} et ${max}.",
    "beforeEnablingThisFeature1": "Avant d'activer cette fonctionnalité, veuillez connecter votre compte Stripe sur le",
    "planToSetYour": "prévoyez de définir des marges plus élevées.",
    "rebillAmount": "Montant de refacturation",
    "supportDoc": "documentation à l'appui",
    "10WillGiveYou": "10 $ vous donneront environ",
    "minimumMustBeBetween": "Le minimum doit être compris entre 0,0001 et 0,005",
    "sorryYouCannotRebillAtTheMarkup": "Désolé ! Vous ne pouvez pas refacturer avec la marge du plan Freelancer, veuillez",
    "modifyingTheseSettingsWillChange": "La modification de ces paramètres modifiera le coût supporté par vos clients à l'avenir.",
    "pleaseDoNotModifyThese": "Veuillez ne pas les modifier si vous ne maîtrisez pas l'effet de cette décision.",
    "theseSettingsWillApply": "Ces paramètres s'appliqueront à vos nouveaux clients à l'avenir.",
    "congratulationsYourDedicatedIp": "Félicitations! La valeur de revente de votre IP dédiée a bien été enregistrée.",
    "youHaveAgreedToProvide": "Vous avez accepté de fournir des IP dédiées directement à un sous-compte. L'agence prendra en charge les frais pour le sous-compte.",
    "youHaveDiscontinuedToProvide": "Vous avez cessé de fournir des IP dédiées directement à un sous-compte. L'agence ne couvrira plus les frais au nom du sous-compte.",
    "oopsSomethingWentWrongAndWeCouldnt": "Oups! Un problème est survenu, et nous n'avons pas pu enregistrer votre configuration de revente d'IP dédiée. Veuillez réessayer plus tard.",
    "pleaseAgreeToTheTerms": "Veuillez accepter les conditions.",
    "errorWhileFetchingDomains": "Une erreur s'est produite lors de la récupération des domaines.",
    "sameStripeCustomerProfileCantBeMapped": "Le même profil client Stripe ne peut pas être associé à plus d'un sous-compte.",
    "pleasePickADifferentStripeCustomer": "Veuillez choisir un autre profil client Stripe ou utiliser l'option « Partager un lien » afin que nous puissions créer un nouveau profil client Stripe pour ce sous-compte.",
    "clickNextToChooseAPlan": "Cliquez sur « Suivant » pour choisir un plan et créer un nouvel abonnement.",
    "youDontHaveAnyActiveSubscriptions": "Vous n'avez pas d'abonnements actifs",
    "youCanEitherSelectAnExistingSubscription": "Vous pouvez soit sélectionner un abonnement existant, soit créer un nouvel abonnement à l'étape suivante.",
    "useCommasToSeparateMultipleEmails": "Utilisez des virgules pour séparer plusieurs courriels.",
    "useCommasToSeparateMultiplePhoneNumbers": "Utilisez des virgules pour séparer plusieurs numéros de téléphone.",
    "noUserFoundInThisLocation": "Aucun utilisateur n'a été trouvé à cet endroit",
    "noPhoneNumberAttached": "Aucun numéro de téléphone n'est joint.",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Veuillez utiliser le lien suivant pour ajouter votre mode de paiement.",
    "allowDuplicateContact": "Autoriser la duplication d'un contact",
    "allowDuplicateOpportunity": "Autoriser la duplication d'une opportunité",
    "mergeFacebookContactsByName": "Fusionner des contacts Facebook par nom",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Seuls les messages entrants provenant de Facebook seront fusionnés s'ils correspondent au nom d'un contact existant. Les noms sont sensibles à la casse.",
    "disableContactTimezone": "Désactivez le fuseau horaire du contact.",
    "markEmailsAsInvalidDueToHardBounce": "Marquez les courriels comme non valides en raison d'un rebond définitif.",
    "contactsEmailsWillBeMarkedAsInvalid": "Les courriels du contact seront marqués comme Invalide automatiquement lorsqu'ils sont rejetés définitivement. Les actions de courriel dans les automatisations seront ignorées pour les contacts ayant des courriels invalides.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Recueillez des renseignements sur des numéros de téléphone inconnus.",
    "makeSmsCompliantByAddingAnOptOutMessage": "Rendez les SMS conformes en ajoutant un message de désabonnement.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Si cette option est activée, le message de désabonnement sera automatiquement ajouté au premier message SMS envoyé par le biais de messages en masse afin d'assurer la conformité et d'augmenter les taux de livraison.",
    "platformLanguage": "Langue de la plateforme",
    "outboundCommunicationLanguageForCustomValues": "Langue de communication sortante pour les valeurs personnalisées",
    "updateInformation": "Mettre à jour les renseignements",
    "upgradeToTheAgency": "Mettre à niveau vers Agency Pro",
    "yourCost": "Vos coûts",
    "addACalendarTo": "Ajouter un calendrier pour commencer à prendre des rendez-vous.",
    "addselectAContactTo": "Ajoutez/sélectionnez un contact pour planifier des rendez-vous.",
    "appointmentSlotIsNot": "Aucun créneau de rendez-vous n'a pas encore été sélectionné",
    "loading1": "Chargement en cours…",
    "teamMemberIsRequired1": "Un membre de l'équipe est requis.",
    "currentPlan": "Forfait actuel",
    "features1": "Fonctionnalités",
    "upgrade": "Mettre à niveau",
    "viewLess": "Voir moins",
    "viewMoreCount": "Afficher plus (+{count})",
    "cardNumber": "Numéro de carte",
    "expiryDate": "Date d'expiration",
    "paymentMethods": "Modes de paiement",
    "primaryCard": "Carte principale",
    "removeCurrentCard": "Supprimer la carte actuelle",
    "AddBalance": "+ Ajouter un montant",
    "complimentaryCredits": "Crédits gratuits :",
    "expiringOnDate": "Expiration le {date}",
    "apiVersion": "Version de l'API",
    "application": "Application",
    "ipAddress": "Adresse IP",
    "related": "Lié",
    "request": "Demande",
    "yourAccountIncludingAll": "Votre compte, y compris toute activité sortante comme les messages et courriels programmés, sera immédiatement bloqué.",
    "yourAccountIncludingAll1": "Votre compte, y compris toute activité sortante comme les messages et courriels programmés, sera immédiatement en pause.",
    "nextBillingDateDate": "Prochaine date de facturation : {date}",
    "scheduledForCancellation": "Prévu pour être annulé",
    "abandoned": "Abandonné",
    "add1": "Ajouter",
    "addOpportunity": "Ajouter une opportunité --",
    "addOpportunityName": "Ajouter le nom de l'opportunité",
    "Task": "+ Tâche",
    "bookupdateAppointment": "Prendre/Mettre à jour un rendez-vous",
    "companyName": "Nom de l’entreprise",
    "areYouSureYou1": "Voulez-vous vraiment supprimer cette opportunité?",
    "contactInfo": "Coordonnées",
    "editOpportunity": "Modifier l'opportunité --",
    "enterValue": "Saisissez une valeur.",
    "goToContactDetail": "Aller à la page des détails du contact",
    "leads": "Prospects",
    "lost": "Perdu",
    "nameIsRequired": "Le nom est obligatoire.",
    "youreNotAllowedTo": "Vous n’avez pas le droit de changer le nom du client!! Vérifiez votre permission auprès de l’administration de l’agence.",
    "open": "Ouvrir",
    "opportunity": "Opportunité",
    "opportunityAlreadyExistsIn": "Une opportunité existe déjà dans ce flux.",
    "opportunityInfo": "Infos sur l'opportunité",
    "opportunityName": "Nom de l'opportunité",
    "opportunitySource": "Source de l'opportunité",
    "owner": "Propriétaire",
    "pipeline": "Flux",
    "removeOwner": "Supprimer le propriétaire",
    "selectPipeline": "Sélectionner un flux",
    "selectStage": "Sélectionnez l'étape",
    "stage": "Étape",
    "countTasks": "{count} tâches",
    "won": "Réussi",
    "and": "et ",
    "addASubscription": "Ajouter un abonnement",
    "noSaasPlanEnabled": "Aucun forfait SaaS n'est activé.",
    "per": "par",
    "assignTo": "Attribuer à",
    "assignedTo1": "Attribué à :",
    "areYouSureYou2": "Voulez-vous vraiment supprimer cette tâche?",
    "due": "En attente :",
    "dueDateIsRequired": "La date d’échéance est requise.",
    "dueIn": "Échéance",
    "dueToday": "Dû aujourd'hui",
    "late": "En retard",
    "notAssigned": "Non attribué",
    "taskDescription": "Description de la tâche",
    "taskTitle": "Titre de la tâche",
    "annually": "annuellement",
    "attachments": "Pièce(s) jointe(s)",
    "areYouSureYou3": "Voulez-vous vraiment supprimer cette demande groupée?",
    "startImmediately": "Commencez immédiatement",
    "customers": "Clients",
    "tag": "Mot clé",
    "pickType": "Sélectionner le type",
    "whoShouldItRun": "Pour qui devrait-il s'exécuter?",
    "addBulkRequest": "Ajouter une demande groupée",
    "editBulkRequest": "Modifier la demande en masse",
    "scheduledDateIsRequired": "La date de programmation est obligatoire.",
    "newCampaignName": "Nouveau nom de campagne",
    "areYouSureYou4": "Voulez-vous vraiment supprimer cette campagne ?",
    "moveToFolder": "Déplacer vers le dossier",
    "pleaseRename": "veuillez renommer",
    "removeFromFolder": "Retirer du dossier",
    "photoPreview": "aperçu de la photo",
    "pleaseWait": "Veuillez patienter….",
    "customValues": "Valeurs personnalisées",
    "whatActionShouldWe": "Quelle action devons-nous entreprendre?",
    "entitynameName": "Nom {entityName}",
    "useLcEmail": "Utiliser le courriel LC",
    "21Jun2018": "21 juin 2018",
    "930Am": "9 h 30",
    "Via": " via ",
    "createdTrackingNumbers": "Numéros de suivi créés",
    "iUnderstandImBuyingadding": "Je comprends que j’achète ou ajoute {count} nouveaux numéros de téléphone.",
    "forwardCallsTo": "Renvoyer les appels vers",
    "numberName": "Nom du numéro",
    "numberPoolName": "Nom du pool de numéros",
    "numberToSwap": "Numéro à échanger",
    "sameAsForwardingNumber": "Identique au numéro de renvoi",
    "callFromSource": "Appel provenant de [Source].",
    "callRecording": "Enregistrement des appels",
    "84Complete": "84 % complétés",
    "thisCallWillBe": "Cet appel sera enregistré à des fins d'assurance qualité.",
    "whisperMessage": "Message chuchoté",
    "allExceptDirect": "Tous sauf direct",
    "allExceptDirectOrganic": "Tous sauf direct et organique",
    "allSearch": "Toutes les recherches",
    "allVisitorsRecommended": "Tous les visiteurs (recommandé)",
    "bing": "Bing",
    "direct": "Direct",
    "visitorsWithoutAReferring": "Visiteurs sans site Web référent",
    "for": "pour",
    "google": "Google",
    "landingPageOrUrl": "Paramètre de page de destination ou d'URL",
    "organic": "Organique",
    "paid": "Payé",
    "pickOneYouCan": "Choisissez-en un - vous pouvez toujours changer cela plus tard.",
    "ppcSearch": "Recherche au coût par clic (PPC)",
    "visitorsFromGoogleBing": "Visiteurs provenant des recherches au coût par clic (PPC) de Google, Bing et Yahoo",
    "referringPage": "Page de référence",
    "visitorsFrom": "Visiteurs provenant de",
    "visitorsFromGoogleAds": "Visiteurs provenant de Google Ads",
    "visitorsWhoAreReferred": "Visiteurs qui sont référés par",
    "visitorsWhoLandOn": "Les visiteurs qui se rendent sur",
    "whichVisitorsDoYou": "Quels visiteurs souhaitez-vous suivre?",
    "yahoo": "Yahoo",
    "17Complete": "17 % terminé",
    "callTimeoutS": "Temps de pause entre les appels (s)",
    "callWhisper": "Appel chuchoté",
    "disableVoicemailDetect": "Désactiver la détection de la boîte vocale",
    "eventName": "Nom de l'événement",
    "timeoutSeconds": "Délai d'attente (secondes)",
    "editCall": "Modifier l'appel",
    "callWillPatchInstantly": "L'appel sera transféré instantanément, nous n'écouterons pas pour voir si la messagerie vocale a répondu du côté du prospect. Cela signifie que la campagne sera marquée comme ayant reçu une réponse même si la boîte vocale a été activée.",
    "thisIsTheMessage": "C'est le message que vous souhaitez que la personne qui décroche le téléphone entende; vous pouvez utiliser des variables personnalisées pour le personnaliser.",
    "pleaseCheckTheLinks": "Veuillez vérifier les liens pour lesquels vous avez une valeur personnalisée. Il y a « %20 » en trop entre les {{ et les custom_values.",
    "anErrorOcurredPlease": "Une erreur s'est produite, veuillez réessayer.",
    "pleaseInsertATo": "Veuillez insérer une adresse de destination.",
    "pickEmailTemplate": "Sélectionnez un modèle de courriel.",
    "sendTest": "Envoyer le test",
    "composeEmail": "Saisissez un courriel.",
    "composeEmailTemplate": "Saisissez un modèle de courriel.",
    "toAddress": "Adresse du destinataire",
    "addFileThroughUrl": "Ajouter un fichier via son URL",
    "appCharacters": "Caractères de l'application :",
    "approximateCost": "Coût approximatif :",
    "estimatedCostForUs": "Coût estimé pour les SMS entre les États-Unis uniquement.",
    "mobilePhoneNumber": "Numéro de téléphone cellulaire",
    "numSegments": "Nombre de segments",
    "pickMessageTemplate": "Sélectionnez le modèle de message.",
    "pleaseProvideAPhone": "Veuillez fournir un numéro de téléphone pour envoyer le test.",
    "composeEventtype": "Saisissez {eventType}.",
    "composeEventtypeTextTemplate": "Saisissez le modèle de texte {eventType}.",
    "unsupportedSmsContentType": "Type de contenu SMS non pris en charge : {fileType}",
    "countOfTheProvided": "{count} des URL jointes {plural} ne sont pas des images. Cela peut causer des erreurs au sein de Twilio. Voulez-vous enregistrer quand même?",
    "dropFileHereOr": "Déposez le fichier ici ou cliquez pour le téléverser.",
    "ifYouHaveAdditional": "Si vous avez d'autres questions, veuillez consulter la FAQ sur la suppression de la boîte vocale dans la section d'aide.",
    "editVoicemail": "Modifier la boîte vocale",
    "selectAMp3Or": "Sélectionnez un fichier mp3 ou wav; nous ne prenons pas en charge d'autres formats.",
    "voicemailFile": "Fichier de boîte vocale",
    "warningVoicemailDropsAre": "Avertissement : les envois de messages vocaux sont un système de dernier recours et fonctionnent dans environ 70 % des cas.",
    "youNeedToPick": "Vous devez sélectionner au moins 1 jour",
    "editWait": "Modifier l'attente",
    "url": "URL",
    "customTime": "Temps personnalisé",
    "executeThisActionIf": "Exécutez cette action si l'heure actuelle se situe dans cette fenêtre; si l'heure actuelle est en dehors de cette fenêtre, ignorez cette étape et passez à l'action suivante.",
    "pickDays": "Sélectionnez les jours.",
    "pickTime": "Sélectionnez l'heure",
    "noRecordsFound1": "Aucun enregistrement trouvé.",
    "formAnalyze": "Statistiques de formulaire",
    "totalSubmission": "Nombre total de soumissions",
    "forgotPassword": "Mot de passe oublié?",
    "orContinueWith": "Ou continuer avec",
    "signIn": "Se connecter",
    "signIntoYourAccount": "Connectez-vous à votre compte",
    "thePasswordYouPicked": "Le mot de passe que vous avez sélectionné",
    "yourEmailAddress": "Votre adresse courriel",
    "newEmailFrom": "Nouveau courriel de",
    "newMessageFrom": "Nouveau message de",
    "hasLeftANew": "a laissé un nouveau avis.",
    "repliedToTheReview": "a répondu à l'avis.",
    "loaded": "Chargé",
    "snapshot": "Instantané",
    "appointment": "Rendez-vous",
    "appointmentDueInMinutes": "Rendez-vous prévu dans {minutes} min pour {contactName}",
    "appointmentReminder": "Rappel de rendez-vous",
    "completedCount": "Terminé : {count}",
    "conversation": "Clavardage",
    "facebookReview": "Avis Facebook",
    "failedCount": "Échec : {count}",
    "googleReview": "Avis Google",
    "internalChatMessage": "Message de clavardage interne",
    "usernameMentionedYouIn": "{userName} vous a mentionné dans une conversation avec {contactName}.",
    "newAppointmentAssigned": "Nouveau rendez-vous assigné",
    "aNewAppointmentWith": "Un nouveau rendez-vous avec {contactName} vous a été attribué.",
    "newAppointmentBooked": "Nouveau rendez-vous planifié",
    "youHaveNewAppointment": "Vous avez un nouveau rendez-vous planifié avec {contactName}",
    "newCall": "Nouvel appel",
    "aNewChatWith": "Un nouveau clavardage avec {contactName} vous a été attribué.",
    "newEmail": "Nouveau courriel",
    "newMention": "Nouvelle mention",
    "newReviewReceivedFrom": "Nouvel avis reçu de {contactName}",
    "aNewTypeIs": "Un nouveau {type} a été envoyé par {contactName}",
    "notification": {
      "noRecentActivity": "Aucune activité récente"
    },
    "subAccount": "Sous-compte",
    "subaccount1": "Sous-compte :",
    "titleOnDateAt": "{title} le {date} à {time} pour {contactName}",
    "titleDueInDuetime": "{title} est dû en {dueTime} {unitOfTime} pour {contactName}",
    "taskReminder": "Rappel de tâche",
    "youHaveCountTasks": "Vous avez {count} tâches à effectuer aujourd'hui.",
    "youHaveCountTasks1": "Vous avez {count} tâches en retard à ce jour.",
    "droppedVoicemailTo": "Boîte vocale abandonnée à",
    "errorWhileCloningProduct": "Une erreur s'est produite lors de la duplication du produit.",
    "productName": "Nom du produit",
    "selectLocations": "Sélectionnez les emplacements.",
    "selectUptoMaxselectablelocatio": "Sélectionnez jusqu'à {maxSelectableLocations} .emplacements",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ {count} de plus",
    "emails": "Courriels",
    "accountNotification": "Notification de compte",
    "customerCare": "Service à la clientèle",
    "deliveryNotification": "Notification de livraison",
    "fraudAlertMessaging": "Messagerie d’alerte fraude",
    "higherEducation": "Éducation supérieure",
    "lowVolumeMixedRecommended": "Faible volume mixte (recommandé)",
    "mixed": "Mixte",
    "pollingAndVoting": "Sondage et vote",
    "publicServiceAnnouncement": "Annonce de service public",
    "securityAlert": "Alerte de sécurité",
    "mixedRecommended": "Mixte (recommandé)",
    "australiaCompanyNumberFrom": "Australie : Numéro d'entreprise d'ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Canada : Numéro d'entreprise canadien (NE)",
    "indiaCorporateIdentityNumber": "Inde : Numéro d'identité d'entreprise",
    "greatBritainCompanyNumber": "Grande-Bretagne : Numéro d’entreprise",
    "usaEmployerIdentificationNumbe": "États-Unis : Numéro d’identification de l’employeur (EIN)",
    "other": "Autre",
    "israelRegistrationNumber": "Israël : Numéro d'enregistrement",
    "estoniaVatNumber": "Estonie : Numéro de TVA",
    "cooperative": "Coopérative",
    "corporation": "Entreprise",
    "limitedLiabilityCompanyOr": "Société à responsabilité limitée ou entreprise individuelle",
    "nonprofitCorporation": "Entreprise à but non lucratif",
    "partnership": "Partenariat",
    "ceo": "PDG",
    "cfo": "DIRECTEUR FINANCIER",
    "director": "Directeur",
    "generalCounsel": "Conseiller juridique",
    "onlineTrainingEducation": "Formation et éducation en ligne",
    "financialServices": "Services financiers",
    "fitnessLifestyle": "Conditionnement physique et mode de vie",
    "healthMedical": "Santé et médecine",
    "homeServices": "Services à domicile",
    "legalServices": "Services juridiques",
    "marketingAdvertising": "Marketing et publicité",
    "others": "Autres",
    "realEstate": "Immobilier",
    "restaurants": "Restaurants",
    "retailEcommerce": "Commerce de détail et commerce électronique",
    "yourInformationHasBeen": "Vos renseignements ont été soumis avec succès.",
    "somethingWentWrong1": "Une erreur s'est produite.",
    "newPassword": "Nouveau mot de passe",
    "proceedToLogin": "Procédez à la connexion",
    "anyTime": "à tout moment.",
    "callUsHighlevelSupport": "Appelez le service d'assistance HighLevel au numéro",
    "troubleLoggingIn": "Vous avez des difficultés à vous connecter?",
    "sendSecurityCode": "Envoyer le code de sécurité",
    "sendCodeToEmail": "Envoyer le code par courriel",
    "verifySecurityCode": "Vérifier le code de sécurité",
    "privacyPolicy": "Politique de confidentialité",
    "businessProfile": "Profil d'entreprise",
    "reserveWithGoogleIntegration": "Réservez avec l’intégration Google",
    "friendlyName": "Nom amical",
    "updateCallerId": "Mise à jour de l'identification de l'appelant",
    "internationalFormat": "Format international",
    "localFormat": "Format local",
    "poolNumbers": "Numéros du pool",
    "swappingNumbers": "Échange de numéros",
    "selectField": "Sélectionner le champ",
    "surveyAnalyze": "Statistiques de sondage",
    "locationIsRequired": "L'emplacement est obligatoire.",
    "newSurveyName": "Nouveau nom du sondage",
    "copySurvey": "Copier le sondage",
    "primaryCalendar": "Calendrier principal",
    "cloneEntityname": "Dupliquer {entityName}",
    "youHaveSuccessfullySubmitted": "Vous avez soumis des documents avec succès.",
    "addCustomValue": "Ajouter une valeur personnalisée",
    "value": "Valeur",
    "youHaveSuccessfullyDeleted": "Vous avez supprimé le lot avec succès.",
    "bundleDeletedSuccessfully": "Lot supprimé avec succès",
    "thereIsAnIssue": "Il y a un problème avec un de vos documents justificatifs. Veuillez consulter les documents justificatifs ainsi que la ou les raison(s) de rejet.",
    "connect1": "Connectez-vous!",
    "itSeemsEitherThe": "Il semble que la connexion Google soit interrompue ou qu'elle ne parvienne pas à établir une connexion à l'emplacement actuel. Veuillez vérifier les paramètres d'intégration et réintégrer si la connexion existe déjà.",
    "selectPage": "Sélectionnez une page.",
    "somethingWentWrongPlease": "Une erreur s'est produite, veuillez réessayer.",
    "accept": "Accepter",
    "moreThan1Phone": "Plus d'un numéro de téléphone autorisé",
    "byContinuingToUse": "En continuant d'utiliser la plateforme HighLevel, vous acceptez ces nouvelles {termsLink} et {privacyLink}.",
    "byContinuingToUse1": "En continuant à utiliser la plateforme HighLevel, vous acceptez ces nouvelles",
    "termsOfService": "Conditions d'utilisation",
    "weHaveUpdatedOur": "Nous avons mis à jour nos conditions d'utilisation et notre politique de confidentialité, n'hésitez pas à les consulter.",
    "newTriggerName": "Nouveau nom de déclencheur",
    "triggerName": "Nom du déclencheur",
    "disableDndForSpecific": "Désactiver DND pour des canaux spécifiques",
    "selectAdAccount": "Sélectionnez un compte publicitaire.",
    "selectAppointmentStatus": "Sélectionnez le statut du rendez-vous",
    "below1": "ci-dessous.",
    "Required": "* obligatoire",
    "whenYouGetA": "Lorsque vous recevez un nouvel avis, nous le publions automatiquement sur votre page Facebook. N'oubliez pas que la meilleure pratique consiste à ne pas publier plus de trois avis par jour sur votre compte.",
    "skip": "Ignorer",
    "copyShareLink": "Copier le lien de partage",
    "agencyRelationshipNumbers": "Numéros de relation de l'agence",
    "alteast1AgencyRelationship": "Au moins un numéro de relation d'agence est obligatoire.",
    "alteast1SubaccountId": "Au moins un id de sous-compte est obligatoire.",
    "somethingWentWrongWhile": "Une erreur s'est produite lors de l'enregistrement, veuillez réessayer plus tard!",
    "5PerPage": "5 par page",
    "10PerPage": "10 par page",
    "amountMustGreaterOr": "Le montant doit être supérieur ou égal à 1 dollar AUD.",
    "regions": {
      "africa": "Afrique",
      "asia_pacific": "Asie/Pacifique",
      "europe": "Europe",
      "latin_america": "Amérique latine",
      "usa_and_canada": "États-Unis et Canada",
      "asia": "Asie",
      "latinAmerica": "Amérique latine",
      "usaCanada": "États-Unis et Canada"
    },
    "expandIcon": "►",
    "noEntriesToShow": "Aucune entrée à afficher",
    "clear": "Effacer",
    "filter": "Filtre",
    "test": "Essai",
    "createNewTwilioSubAccountText": "Vous devrez créer un nouveau compte Twilio, mettre à jour les identifiants de ce compte dans les paramètres Twilio et déplacer les numéros de téléphone avant d'activer la refacturation.",
    "viewing": "Affichage",
    "makeSmsCompliantByAddingASenderInformation": "Rendez les SMS conformes en ajoutant des renseignements sur l'expéditeur.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Mettez le courriel en conformité en ajoutant un lien de désabonnement dans votre courriel.",
    "enableMissedCallTextBack": "Activer le renvoi de texte des appels manqués",
    "productInventory": "Inventaire de produits",
    "viewProductVariants": "Voir les Variantes de Produits",
    "smtpSettings": "Paramètres SMTP",
    "locationOPMTrafficStatis": "Statistiques de trafic de l'emplacement OPM",
    "locationGPMTrafficStatis": "Statistiques de trafic de l'emplacement GPM",
    "blacklistMonitorReports": "Rapports de surveillance de la liste noire",
    "twoFactorAuthentication": "Authentification à deux facteurs (2FA)",
    "recent": "Récent",
    "noPermission": "Vous n'avez pas la permission de gérer les modèles pour ce produit. Redirection vers le tableau de bord.",
    "tasksNowHave": "Les tâches ont maintenant",
    "option": "Option",
    "facebookAdsReporting": "Rapports sur les publicités Facebook",
    "googleAdsReporting": "Rapports Google Ads",
    "adsDatePicker": "Sélecteur de date pour les publicités",
    "feedbackSubmitBtn": "Bouton de soumission de la rétroaction",
    "ifYouThinkMistakePleaseContact": "Si vous pensez qu'il s'agit d'une erreur, veuillez communiquer avec",
    "forResolution": "pour résoudre le problème.",
    "live": "En direct",
    "payouts": "Paiements",
    "greatChoice": "Excellent choix!",
    "toNavigate": "pour naviguer",
    "teams": "Équipes",
    "role": "Rôle",
    "searchAccounts": "Rechercher des Comptes",
    "searchByNameEmailPhone": "Recherche par nom, courriel ou numéro de téléphone",
    "addEmployee": "Ajouter Employé",
    "removeFromLocation": "Retirer de l’emplacement",
    "knowMore": "En savoir plus",
    "usingNumberPool": "Utilisation du pool de numéros",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Réviseur",
    "cancel1": "Annuler",
    "delete1": "Supprimer",
    "call1": "Appeler",
    "message1": "Message",
    "name1": "Nom",
    "voicemail1": "Boîte vocale",
    "title1": "Titre",
    "choose_one": "Sélectionnez-en un",
    "select_page": "Sélectionner une page",
    "confirm1": "Confirme",
    "conversations1": "Conversations",
    "copied1": "Copié",
    "timeOfDay": {
      "am": "AM",
      "pm": "PM"
    },
    "back1": "Retour",
    "details1": "Détails",
    "month1": "/ mois",
    "select1": "Sélectionner",
    "share1": "Partager",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Rapports de surveillance de la liste noire",
      "domainPurchase": "Achat de domaines"
    },
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer {name}?",
    "clicked1": "Cliqué",
    "delivered1": "Livré",
    "invalid1": "Invalide",
    "open_options": "Options disponibles",
    "_add_account": "Ajouter un compte",
    "setTimezoneWarning": "Veuillez définir le fuseau horaire pour votre emplacement afin d'obtenir les créneaux disponibles appropriés.",
    "save1": "Enregistrer",
    "action1": "Action",
    "actions1": "Actions",
    "all1": "Tout",
    "previous1": "Précédent",
    "results1": "Résultat",
    "next1": "Suivant",
    "payments1": "Paiements",
    "settings1": "Paramètres",
    "total_js_heap": "Tas de mémoire JS total",
    "table": {
      "pagination": {
        "previous": "Précédent",
        "next": "Suivant"
      },
      "rowsSelected": "{count} lignes sélectionnées",
      "cantRearrange": "{type} ne peut pas être réarrangé"
    },
    "ivrCall": "Appel IVR",
    "sms": "SMS",
    "username": "Nom d'utilisateur",
    "stay": "Rester",
    "placeholders": {
      "selectCountry": "Sélectionnez votre pays",
      "nameOfBusiness": "Nom de l'entreprise",
      "line1": "Ligne 1",
      "line2": "Ligne 2",
      "enterState": "Saisissez le pays",
      "enterCity": "Saisissez la ville",
      "enterPostalCode": "Entrez le code postal",
      "chooseCountry": "Sélectionner le Pays..."
    },
    "addressLine1": "Adresse, ligne 1",
    "addressLine2": "Adresse, ligne 2",
    "postalCode": "Code postal",
    "nameOfBusiness": "Nom de l'entreprise",
    "dispute_this_review": "Contester cet avis",
    "story_mention": "Mention de l’histoire",
    "story_reply": "Réponse à l’histoire",
    "no": "Non",
    "yes": "Oui",
    "annual": "annuel",
    "plan": "Forfait",
    "errors": {
      "somethingWrong": "Une erreur s'est produite"
    },
    "zero": "0",
    "perMonth": "par mois",
    "emailCheckLinks": "Veuillez vérifier les liens où vous avez une valeur personnalisée. Il y a « 20 % » supplémentaire entre le {{ et le custom_values.",
    "fileSizeTooLarge": "La taille du fichier est supérieure à 5 Mo",
    "fileSizeTooLargeDescription": "Le fichier que vous essayez de téléverser est trop volumineux. Veuillez essayer avec un fichier de taille plus petite",
    "minMaxLength40Characters2048Characters": "Longueur minimale : 40 caractères. Longueur maximale : 2048 caractères.",
    "sampleMessage2": "Exemple de message n° 2*",
    "pleaseSelectWorkflow": "Veuillez sélectionner un flux de travail",
    "childrens": "Enfants",
    "brandAndCampaignRegistration": "L'enregistrement de la marque et de la campagne sera facturé 20,95 $ une seule fois. Des frais supplémentaires pouvant atteindre 2,25 $ par mois s'appliqueront conformément aux règles du TCR.",
    "einRequiredForRegistration": "EIN obligatoire pour l’enregistrement",
    "changed_props": "Propriétés modifiées",
    "total_memory": "Mémoire totale",
    "total_store_size": "Taille totale du magasin",
    "total_watchers": "Nombre total d'observateurs",
    "update_count": "Nombre de mises à jour"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Actions en masse",
      "clickHere": "Cliquez ici pour voir la liste des actions en masse.",
      "mergedMessage": "Cette page a été fusionnée avec la liste des actions en masse.",
      "title": "Demandes de contact"
    }
  },
  "conversations": {
    "noConversationsFound": "Aucune conversation {status} n'a été trouvée",
    "create_new": "Créer un nouveau message​",
    "validations": {
      "minCharsRequired": "Min 3 caractères obligatoires",
      "twoMoreCharsRequired": "2 caractères supplémentaires requis",
      "oneMoreCharRequired": "1 caractère supplémentaire requis"
    },
    "sortLabels": {
      "latestAllMessages": "Le plus récent – Tous les messages",
      "oldestAllMessages": "Le plus ancien – Tous les messages",
      "latestManualMessages": "Le plus récent – Messages manuels",
      "oldestManualMessages": "Le plus ancien – Messages manuels",
      "latestAll": "Le plus récent – Tous",
      "oldestAll": "Le plus ancien – Tous",
      "latestManual": "Le plus récent – Manuel",
      "oldestManual": "Le plus ancien – Manuel",
      "highToLow": "{name} (de haut en bas)",
      "manualMessagesTooltip": "L'option de tri sera applicable aux messages publiés le 18 mai 2023."
    },
    "deleteConversation": {
      "title": "Confirmation",
      "confirmWithName": "Voulez-vous vraiment supprimer définitivement la conversation avec {name}? Cela ne pourra pas être annulé.",
      "confirmWithoutName": "Voulez-vous vraiment supprimer cette conversation de façon permanente? Cela ne pourra pas être annulé."
    },
    "makeCall": {
      "enterPhoneNumber": "Pour passer un appel, veuillez saisir un numéro de téléphone dans ce champ.",
      "invalidPhoneNumber": "Twilio Lookup a marqué ce numéro de téléphone comme non valide."
    },
    "actions": {
      "markAsStarred": "Marquer comme favori",
      "unarchive": "Désarchiver",
      "unmarkAsStarred": "Supprimer du favori"
    },
    "send": {
      "perMonthPerIp": "/mois/IP",
      "perIp": "/IP",
      "replyingTo": "En réponse à",
      "requestClientsPaymentDetails": "Demander les détails de paiement du client",
      "saasModeCreditCardRequired": "Le mode SaaS nécessite qu'une carte de crédit soit enregistrée dans le dossier du client.",
      "please": "Veuillez",
      "firstBeforeEnablingSaaS": "d'abord avant d'activer le mode SaaS.",
      "shareALink": "Partagez un lien",
      "shareLinkInstructions": "Partagez un lien avec votre client pour recueillir ses détails de paiement.",
      "requestViaEmail": "Demande par courriel",
      "twilioRebillingDescription": "Refacturez les coûts de Twilio ({twilioCopy}) à vos clients et incluez une majoration.",
      "seeHow": "Découvrez comment",
      "phoneRebillingCardInfoRequired": "La refacturation téléphonique nécessite que les informations de carte soient enregistrées pour le client.",
      "clientsCompanyBillingPage": "page de facturation de l'entreprise du client",
      "ifYouPayForTwilioKeepUsing": "Si vous payez pour Twilio, continuez à utiliser le même compte Twilio.",
      "ifClientPaysForTwilioCreateNew": "Si le client paie pour Twilio, créez un nouveau compte Twilio.",
      "learnHow": "Apprenez comment",
      "createNewTwilioAccountInstructions": "Créez un nouveau compte Twilio pour cet emplacement",
      "learnHowToMovePhoneNumbers": "Apprenez à changer de numéros de téléphone.",
      "thisIsMyClientsTwilioCreateNew": "Ceci est le Twilio de mon client, veuillez créer un nouveau compte",
      "featureUnderDevelopment": "Cette fonctionnalité est en cours de développement.",
      "emailRebillingDescription": "Refacturez les coûts des courriels à vos clients et incluez une majoration.",
      "emailRebillingCardInfoRequired": "La refacturation par courriel nécessite que les informations de carte soient enregistrées pour le client.",
      "emailRebillingMarginsDescription": "Il s'agit de marges facturées à vos clients en sus des coûts de courriels.",
      "provider": "Fournisseur",
      "morePlanCustomizationsAvailable": "Davantage de personnalisations de forfaits disponibles",
      "plansAndPricing": "Forfaits et tarifications",
      "connectYourStripeAccountFirst": "Connectez d'abord votre compte Stripe",
      "createRecommendedPlansOnStripe": "Créez des forfaits recommandés sur Stripe.",
      "createdPlanInStripe": "Forfait créé dans Stripe",
      "customizeYourSaasPlans": "Personnalisez vos plans SaaS",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "Vous pouvez proposer des forfaits recommandés ou créer les vôtres.",
      "trialPeriod": "Période d'essai",
      "enterNumberOfDaysForTrial": "Entrez le nombre de jours pour l'essai",
      "nameCantBeEmpty": "Le champ du nom ne peut pas être vide.",
      "showStripeProductDetails": "Afficher les Détails du Produit Stripe",
      "addEmail": "Ajouter un courriel",
      "resetMountCounts": "Réinitialiser le nombre de montages",
      "connectReconnectGoogleForGbp": "Connectez ou reconnectez Google pour GBP",
      "downloadFile": "Télécharger le fichier",
      "showOnlySlowQueries": "Afficher uniquement les requêtes lentes",
      "gmbMessagingAvailable": "La messagerie GMB est maintenant disponible",
      "reconnectGbpPageToEnable": "Reconnectez votre page GBP pour activer la messagerie",
      "failedPaymentsCheckBilling": "Détection d'échecs de paiement. Veuillez vérifier votre facturation.",
      "onlyAgencyAdminsCanSeeWarning": "Seuls les administrateurs de l'agence peuvent voir cet avertissement.",
      "filter": "Filtrer",
      "stopDeleteOperation": "Arrêter l'opération de suppression",
      "summary": "Résumé",
      "enableTracking": "Activer le suivi",
      "exportAll": "Exporter tout",
      "newConversationStarted": "Nouvelle conversation démarrée",
      "startNewConversation": "Commencer une nouvelle conversation",
      "subAccountScheduledForDeletion": "Sous-compte programmé pour suppression",
      "deleteSubAccountOnScheduledTime": "Supprimez le sous-compte à l'heure prévue",
      "componentUpdatesDebuggerAlpha": "Débogueur de mises à jour de composants (Alpha)",
      "componentUpdateTrackingDisabled": "Le suivi de la mise à jour des composants est désactivé",
      "deleteSubAccount": "Supprimer le sous-compte",
      "subAccountHasNumbersAndCampaigns": "Ce sous-compte a {phoneNumberCount} numéro(s) de téléphone et {campaignsCount} campagne(s).",
      "subAccountNoNumbersOrCampaigns": "Ce sous-compte ne possède aucun numéro de téléphone ni aucune campagne.",
      "areYouSureDeleteSubAccount": "Voulez-vous vraiment supprimer ce sous-compte?",
      "confirmDiscussedWithClient": "Je confirme que j'ai discuté de cela avec mon client",
      "understandActionIrreversible": "Je comprends que cette action est irréversible",
      "confirmDisconnectCloseLcPhone": "Je confirme que je souhaite déconnecter et fermer le compte LC Phone",
      "choosingNotDeleteLcPhoneWarning": "Avertissement : Si vous choisissez de ne pas supprimer le compte LC Phone, vous continuerez à être facturé pour les numéros de téléphone associés à ce sous-compte.",
      "deleteAccount": "Supprimer le compte",
      "send": "Envoyer",
      "typeMessage": "Tapez un message",
      "requestPayment": "Demander un paiement",
      "reply": "Réponse",
      "retry": "Réessayer",
      "analyzeMemory": "Analyser la Mémoire",
      "memoryAnalysisApproximate": "🚧 L'analyse de la mémoire est approximative et n'est pas précise à 100 %.",
      "subAccountScheduledForDeletionItWillBeDeleted": "Ce sous-compte a été prévu pour la suppression. Il sera supprimé via",
      "youCanChangeYourMindBeforeThisTime": "Vous pouvez faire un changement d’avis avant cette heure.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Ignorer",
          "cannotIdentifyContact": "Impossible d’identifier le contact et son emplacement.",
          "contactNotSelected": "Le contact n'est pas sélectionné.",
          "messageRequired": "Assurez-vous d'avoir saisi un message ou sélectionné un modèle.",
          "noPhoneNumber": "Le contact n'a pas de numéro de téléphone.",
          "genericError": "{message}",
          "stayPrompt": "Rester"
        },
        "scheduledSuccess": "Courriel planifié avec succès",
        "confirmDelete": "Êtes-vous sûr de vouloir supprimer {name}?"
      },
      "clear": "Effacer",
      "edit": "Modifier",
      "sendNow": "Envoyer maintenant",
      "schedule": "Calendrier",
      "useTemplate": "Utilisez un modèle (extrait)",
      "mergeFields": "Fusionner les champs",
      "customVariablesError": "Il y a des problèmes dans vos variables personnalisées, veuillez les corriger avant de les envoyer.",
      "sendLater": "Envoyer plus tard",
      "scheduledFor": "Prévu pour {date}",
      "call": "Appeler",
      "leftVoicemail": "A laissé un message vocal",
      "pleaseSelectCampaign": "Veuillez sélectionner une campagne",
      "whatsapp": {
        "no24HourMessage": "Vous ne pouvez envoyer des messages modèles qu'en dehors de la fenêtre de 24 heures. Veuillez sélectionner un modèle à envoyer."
      },
      "attachFile": "Joindre un document",
      "email": {
        "fromEmail": "À partir d'un courriel",
        "fromName": "De nom",
        "smtpWarning": "Les fournisseurs SMTP présentent certaines limitations. Cliquez ici pour en savoir plus.",
        "subject": "Sujet",
        "errors": {
          "cannotIdentifyContact": "Impossible d’identifier le contact et son emplacement.",
          "contactNotSelected": "Le contact n'a pas été sélectionné.",
          "genericError": "{message}",
          "bodyRequired": "Le courriel nécessite l'envoi d'un corps de texte.",
          "noEmailAddress": "Le contact n’a pas d’adresse courriel."
        },
        "scheduledSuccess": "Courriel planifié avec succès"
      },
      "addCalendarToSchedule": "Vous devez ajouter un calendrier pour commencer à planifier des rendez-vous.",
      "slotRequired": "Créneau obligatoire",
      "teamMemberRequired": "Un membre de l'équipe est obligatoire."
    },
    "added": "ajouté",
    "loadMore": "Charger plus",
    "admin": "Administrateur",
    "aiEmployee": {
      "popupBlockedAlert": "Vous avez désactivé la fenêtre contextuelle. Veuillez activer les fenêtres contextuelles pour ce site afin d'être automatiquement redirigé vers un appel Zoom. Veuillez cliquer sur « Rejoindre maintenant » pour être redirigé directement vers un appel Zoom."
    },
    "alsoCloseAssociatedSubAccount": "Également étroitement associé",
    "analyzeMemory": "Analyser la mémoire",
    "announcements": "Annonces",
    "apply": "Appliquer",
    "appointment": {
      "pickDay": "Sélectionner un jour",
      "pickSlot": "Sélectionner un créneau de rendez-vous",
      "selectDate": "Sélectionner une date",
      "selectSlot": "Sélectionner un créneau",
      "slot": "Créneau",
      "day": "Jour"
    },
    "areYouReallySureDeleteSubAccount": "Voulez-vous vraiment supprimer ce sous-compte?",
    "areYouSureDeleteSubAccount": "Voulez-vous vraiment supprimer ce sous-compte?",
    "assignedContactOwner": "Attribué (propriétaire du {contact})",
    "assignedToMe": "Attribué à moi",
    "audio": {
      "browserNotSupported": "Votre navigateur ne prend pas en charge l’élément audio.",
      "loadingTranscription": "Chargement de la transcription...",
      "viewTranscript": "Voir la transcription",
      "stop": "Arrêter",
      "playPause": "Lecture/Pause",
      "timePlayed": "Temps joué : Temps total",
      "mute": "Silencieux",
      "playbackSpeed": "Vitesse de lecture",
      "download": "Télécharger",
      "remove": "Supprimer"
    },
    "automated": "Automatisé",
    "avatar": {
      "aiGenerated": "Ce message a été généré par Conversation AI.",
      "messengerAutomation": "Automatisation de Messenger",
      "workflowGenerated": "Ce message a été généré par l'action de flux de travail Conversation AI.",
      "messageByAI": "Ce message a été généré par Conversation AI",
      "messageByWorkflow": "Ce message a été généré par l'action de flux de travail Conversation AI",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Rejoignez la communauté qui connaît la plus forte croissance.",
    "callHighlevelAt": "Appelez HighLevel au +1(888)732-4197",
    "callQueueTooltip": "Cet appel est dans la file d'attente d'appels de l'utilisateur en attente d'être passé.",
    "callTranscript": "Transcription d'appel",
    "clearFilters": "Effacer les filtres",
    "clientsCompanyBillingPage": "Page de facturation de l'entreprise du client",
    "closeChat": "Fermer le clavardage",
    "closeConversation": "Fermez la conversation",
    "component": {
      "dismissMessage": "REJETER CE MESSAGE",
      "unblock": "Débloquer",
      "inboundDndActive": "La fonction DND entrant a été activée pour ce contact",
      "fetchOlderMessages": "Récupérer les messages plus anciens",
      "conversationBegan": "Le clavardage a commencé",
      "celebrationTitle": "Super ! Les conversations sont fluides maintenant !",
      "celebrationBody": "Ce n'est que le début, explorons comment GHL peut vous aider à développer votre entreprise.\nEn attendant, vous pouvez continuer à envoyer des messages autant que vous le souhaitez"
    },
    "componentUpdateTrackingDisabled": "Le suivi des mises à jour des composants est actuellement désactivé",
    "componentUpdatesDebuggerAlpha": "🚧 Débogueur de mises à jour de composants (Alpha) - Travail en cours",
    "confirmDelete": "Supprimer la ou les conversations?",
    "confirmDeleteTextLine11": "Voulez-vous vraiment supprimer cette conversation? Cette action est irréversible.",
    "confirmDeleteTextLine12": "conversations sélectionnées",
    "confirmDeleteTextLine21": "Cette action est irréversible. Voulez-vous quand même continuer?",
    "confirmDisconnectedAllIntegrations": "Je confirme que j'ai déconnecté toutes les intégrations comme twilio, mailgun, gmb, domains, facebook, zoom etc.",
    "confirmStoppedAllAutomations": "Je confirme que j'ai arrêté tous les automatismes dans ce sous-compte",
    "connectReconnectGoogleForGbp": "Connectez / Reconnectez votre compte Google pour obtenir la messagerie GBP!",
    "connectWithCertifiedAdmin": "Connectez-vous avec un administrateur certifié",
    "connectWithTeamForHelp": "Communiquez avec notre équipe pour obtenir de l'aide lors d'un appel vidéo en direct!",
    "connectWithUs": "Communiquez avec nous",
    "connectZoomAccount": "Connecter le compte Zoom",
    "contactEngagementScore": "Score d'engagement de {contact}",
    "dailyBrainstormingSessions": "Séances quotidiennes de remue-méninges avec Highlevel",
    "deleteAccount": "Supprimer le compte",
    "deleteSubAccountOnScheduledTime": "Supprimez le sous-compte à la date prévue.",
    "disableSaasMode": "Désactiver le mode SaaS",
    "dnd": {
      "configure": "CONFIGURER",
      "status": {
        "on": "Activé",
        "partial": "Partiel"
      }
    },
    "editAppointment": {
      "updateButton": "Mettre à jour le rendez-vous",
      "scheduleAppointment": "Planifier un rendez-vous",
      "editAppointment": "Modifier le rendez-vous",
      "calendar": "Calendrier",
      "selectCalendar": "Sélectionnez un calendrier",
      "roundRobin": "Tour de table",
      "pickTeamMember": "Choisir un membre de l'équipe",
      "selectTeamMember": "Sélectionner un membre de l'équipe",
      "teamMemberRequired": "Un membre de l'équipe est obligatoire.",
      "slotRequired": "Créneau obligatoire",
      "appointmentTitle": "Titre du rendez-vous",
      "appointmentTitleTooltip": "Envisagez de le laisser vide, si vous choisissez d’utiliser le titre du rendez-vous préconfiguré",
      "contactName": "Nom du contact",
      "name": "Nom",
      "nameRequired": "Nom obligatoire",
      "emailAddress": "Adresse courriel",
      "phoneNumber": "Numéro de téléphone",
      "phoneNumbers": "Numéros de téléphone",
      "dateOfBirth": "Date de naissance",
      "contactTimezone": "Fuseau horaire du contact (utilisé pour les rappels)",
      "chooseOne": "Choisissez-en un...",
      "meetingLocation": "Emplacement de réunion",
      "meetingLocationTooltip": "Envisagez de le laisser vide si vous choisissez d'utiliser le lieu de réunion préconfiguré",
      "status": "Statut",
      "appointmentStatus": "Statut du rendez-vous",
      "additionalNotes": "Notes supplémentaires",
      "notes": "Notes",
      "actionRequired": "Action requise",
      "confirmed": "Confirmé",
      "invalid": "Non valide",
      "cancelled": "Annulé",
      "showed": "Montré",
      "noShow": "Absent",
      "busy": "Occupé",
      "free": "Gratuit",
      "noCalendarMessage": "Vous devez ajouter un calendrier pour commencer à planifier des rendez-vous."
    },
    "email": {
      "errors": {
        "bodyRequired": "Le courriel doit avoir un corps de texte pour pouvoir être envoyé.",
        "cannotIdentifyContact": "Impossible d’identifier le contact et son emplacement.",
        "contactNotSelected": "Le contact n'a pas été sélectionné.",
        "noEmailAddress": "Le contact n'a pas d'adresse électronique."
      },
      "thread": {
        "failedToFetch": "La récupération du contenu du courriel a échoué.",
        "forward": "Envoyer"
      },
      "reply": "Répondre",
      "share": "Partager",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ Ajouter un compte",
      "respond": "Répondre",
      "retry": "Réessayer",
      "moreEmailsInThread": "{count} autres courriels dans le fil de discussion",
      "fromName": "Nom de l'expéditeur",
      "fromEmail": "Courriel de l'expéditeur",
      "subject": "Sujet",
      "attachFile": "Joindre un Document",
      "useTemplate": "Utilisez un modèle (extrait)",
      "requestPayment": "Demander un paiement",
      "clear": "Effacer",
      "sendNow": "Envoyez maintenant",
      "schedule": "Calendrier",
      "send": "Envoyer",
      "smtpWarning": "Les fournisseurs SMTP présentent certaines limitations. Cliquez ici pour en savoir plus.",
      "chooseOne": "Choisissez-en un...",
      "deliveredCount": "{delivered}/{total} envoyé",
      "typeMessage": "Tapez un message",
      "sendLater": "Envoyer plus tard",
      "scheduledFor": "Prévu pour {date}"
    },
    "emailRebillingCardInfoRequired": "Pour activer la refacturation par courriel, vous devez entrer les informations de carte de votre client sur",
    "emailRebillingDescription": "Cela vous permet de refacturer les coûts des courriels à vos clients et d'inclure une majoration.",
    "emailRebillingMarginsDescription": "Ce sont des marges facturées à vos clients en plus du coût des courriels que vous assumez.",
    "enableTracking": "Activer le suivi",
    "exploreHighlevelExperts": "Découvrez les spécialistes de HighLevel qui peuvent vous aider à configurer votre système, automatiser vos flux de travail ou personnaliser votre projet.",
    "exportAll": "Exporter tout",
    "facebook": {
      "errors": {
        "generalError": "Une erreur s'est produite. Veuillez réessayer ou vérifiez l'intégration Facebook. Message d'erreur :",
        "noFacebookId": "Le contact n'a pas d'id Facebook."
      }
    },
    "failedPaymentsCheckBilling": "Un ou plusieurs de vos paiements ont échoué. Veuillez vérifier votre historique de facturation.",
    "fbMessengerDM": "DM FB Messenger",
    "filters": {
      "above": "Plus de",
      "aiActionLogs": "Journaux des actions de l'IA",
      "inRange": "Dans l'intervalle",
      "invoice": "Facture",
      "messageDirectionTooltip": "Le filtre sera applicable aux messages publiés le 9 mai 2023.",
      "appointments": "Rendez-vous"
    },
    "followed": "Suivi par",
    "followedByMe": "Suivi par moi",
    "followedBySpecificUser": "Suivi par un utilisateur spécifique",
    "follower": "Suiveur",
    "followerAssignmentContact": "Suiveur (attribution de {contact})",
    "gbp": {
      "errors": {
        "generalError": "Une erreur s'est produite. Veuillez réessayer ou vérifiez l'intégration du Google Business Profile. Message d'erreur :",
        "noGBPId": "Le contact n’a pas d’id GBP."
      }
    },
    "gbpChatNoLongerAvailable": "Le clavardage de Google Business Profile n'est plus disponible.",
    "getAccessToHighlevelWelcomeCourse": "Accédez au cours de bienvenue HighLevel.",
    "getPriorityTroubleshooting": "Bénéficiez d'un dépannage prioritaire, de conseils de spécialistes et d'un accès direct à notre équipe technique par le biais de Slack.",
    "gmbMessagingAvailable": "La messagerie Google Business est disponible pour votre compte.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Évaluation :",
      "replyDate": "Date de réponse :",
      "replyFrom": "Réponse de :",
      "review": "Avis",
      "reviewDate": "Date d’avis :",
      "reviewFrom": "Avis de :"
    },
    "highlevelEvents": "Événements Highlevel",
    "igMessengerDM": "IG Messenger DM",
    "includeSignatureBeforeQuotedText": "Insérer cette signature avant le texte cité dans les réponses",
    "instagram": {
      "errors": {
        "generalError": "Une erreur s'est produite. Veuillez réessayer ou vérifiez l'intégration Instagram. Message d'erreur :",
        "noInstagramId": "Le contact n'a pas d'id Instagram."
      }
    },
    "joinOurFacebookGroup": "Rejoignez notre groupe Facebook.",
    "keepUpToDateWithLatestNews": "Restez informé(e) des nouveautés!",
    "lastMessageChannel": "Canal du dernier message",
    "lastMessageDirection": "Direction du dernier message",
    "lastOutboundMessageType": "Dernier type de message sortant",
    "learnHow": "Apprendre comment?",
    "leftComment": "a laissé un commentaire",
    "leftPanel": {
      "recents": "Récents",
      "unread": "Non lus",
      "createNewMessage": "Créer un nouveau message",
      "minCharsRequired": "Minimum 3 caractères obligatoires",
      "twoMoreCharsRequired": "2 caractères de plus obligatoires",
      "oneMoreCharRequired": "1 caractère de plus obligatoire"
    },
    "liveChat": {
      "endLiveChat": "Mettre fin au clavardage en direct",
      "errors": {
        "generalError": "Une erreur s'est produite. Veuillez réessayer ou vérifiez l'intégration Google My Business. Message d'erreur :"
      },
      "requestContact": "Demander un contact"
    },
    "live_chat_message": "Message Live Chat",
    "made": "fait",
    "memoryAnalysisApproximate": "🚧 L'analyse de la mémoire est approximative et n'est pas précise à 100–%.",
    "mentioned": "Mentionné sur",
    "mentions": "Mentions",
    "mentionsOfMe": "Mentions de moi",
    "mentionsOfSpecificUser": "Mentions d'un utilisateur spécifique",
    "message": {
      "replyAll": "Répondre à tous",
      "details": "Détails",
      "reply": "Répondre",
      "unsuccessful": "Échec",
      "pending": "En attente",
      "inboundCall": "Appel entrant",
      "outboundCall": "Appel sortant",
      "ivrCall": "Appel IVR",
      "leftVoicemail": "A laissé un message vocal",
      "storyReply": "Réponse à l’histoire",
      "storyMention": "Mention de l’histoire",
      "replyAsDM": "Répondre en tant que DM",
      "newCommentOnPost": "Nouveau commentaire sur la publication {pageName}.",
      "goToPost": "Accéder à la publication",
      "replyNotAvailable": "La Réponse en DM privé n'est pas disponible pour les rétroactions datant de plus de 7 jours.",
      "addToDocuments": "Ajouter aux fichiers",
      "attachmentsAddedSuccess": "Pièces jointes ajoutées aux fichiers avec succès",
      "attachmentsAddedFailed": "Échec de l’ajout des pièces jointes aux fichiers",
      "reportFeedbackForAI": "Signaler des commentaires pour l’IA",
      "sms": "SMS"
    },
    "messageDetails": {
      "bcc": "BCC",
      "cancelScheduleConfirm": "Voulez-vous vraiment annuler cette planification?",
      "cancelScheduledMessage": "Annuler le message prévu?",
      "cancelSend": "Annuler l'envoi",
      "cancelScheduledSuccess": "Le message planifié a été annulé avec succès",
      "cancelScheduledError": "Une erreur s'est produite lors de l'annulation du message programmé",
      "cc": "CC",
      "channel": "Canal",
      "createdBy": "Créé par",
      "direction": "Direction",
      "emailCampaign": "Campagne par courriel",
      "facebookMessage": "Message Facebook",
      "instagramMessage": "Message Instagram",
      "messageId": "ID de message",
      "messageIdLabel": "ID de message : ",
      "trigger": "Déclencheur",
      "unanswered": "Sans réponse",
      "yes": "Oui",
      "messageDetails": "Détails du message",
      "from": "De",
      "fromLabel": "De :",
      "to": "À",
      "toLabel": "À :",
      "unknown": "Inconnu",
      "unknownFrom": "Inconnu de",
      "unknownTo": "Inconnu à",
      "unknownDirection": "Direction inconnue",
      "dateUnknown": "Date inconnue",
      "emailFromUnknown": "Courriel d’un expéditeur inconnu",
      "smsFromUnknown": "SMS d’un expéditeur inconnu",
      "callFromUnknown": "Appel d'un numéro inconnu",
      "voicemailFromUnknown": "Message vocal d'un expéditeur inconnu",
      "emailToUnknown": "Courriel à un destinataire inconnu",
      "smsToUnknown": "SMS à Inconnu",
      "callToUnknown": "Appel à un inconnu",
      "voicemailToUnknown": "Message vocal à un numéro inconnu",
      "failed": "Échec",
      "datetime": "Date et heure",
      "manual": "Manuel",
      "automation": "Automatisation",
      "workflow": "Flux de travail",
      "campaign": "Campagne",
      "bulkRequest": "Demande en masse",
      "delivered": "Livré",
      "bounced": "A rebondi",
      "opened": "Ouvert",
      "sent": "Envoyé",
      "scheduled": "Prévu",
      "pageName": "Nom de la page",
      "gbpMessage": "Message GBP",
      "no": "Non",
      "eventsTrackedForContactOnly": "Les événements ne sont actuellement saisis que pour l'adresse courriel du contact.",
      "completed": "Terminé",
      "voicemail": "Boîte vocale",
      "busy": "Occupé",
      "pending": "En attente",
      "read": "Lu",
      "nativeIntegrations": "Intégrations natives",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "Courriel",
      "sms": "SMS",
      "phoneCall": "Appel téléphonique",
      "voiceMail": "Messagerie vocale",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Avis",
      "others": "Autres",
      "partialDetailsWarning": "Des détails partiels seront disponibles pour les messages envoyés avant le 15 juillet 2022.",
      "agencySystem": "Système d’agences",
      "reply": "Répondre"
    },
    "multiplePhone": {
      "chooseNumber": "Choisissez un numéro pour commencer la conversation :",
      "continue": "Continuer",
      "noPhones": "Aucun numéro de téléphone n'est disponible"
    },
    "myChat": "Mes conversations",
    "myInbox": "Ma boîte de réception",
    "newConversationStarted": "Nouvelle conversation commencée",
    "newMessage": {
      "title": "Nouveau message :",
      "errors": {
        "phoneRequired": "Le téléphone est obligatoire."
      }
    },
    "noConversationSelected": "Aucune conversation sélectionnée",
    "noResultsToShow": "Aucun résultat à afficher",
    "onboardingVideoTutorials": "Tutoriels vidéo d'intégration",
    "onlyAgencyAdminsCanSeeWarning": "Seuls les administrateurs de l'agence peuvent voir cet avertissement. Pour plus d'informations",
    "onlyVisibleToUsers": "Visible uniquement pour les utilisateurs",
    "perMonthPerIp": "/ Mois / IP",
    "phone": {
      "call": "Appelez {name}",
      "callingOptions": "{count} options d'appel",
      "phoneNumbers": "Numéros de téléphone",
      "callOptions": "{count} options d'appel",
      "dndActive": "La fonction DND est active pour les appels",
      "primary": "Principal"
    },
    "pleaseDisableSaasMode": "Veuillez désactiver le mode SaaS pour ce sous-compte.",
    "pleaseSelectCampaign": "Veuillez sélectionner une campagne.",
    "premiumSupport": "Support premium",
    "quickFilters": "Filtres rapides",
    "reconnectGbpPageToEnable": "Reconnectez votre page GBP pour l'activer.",
    "replyAsDMTooltip": "Répondez à ce commentaire par DM privé.",
    "replyingTo": "En réponse à",
    "resetMountCounts": "Réinitialiser le nombre de montages",
    "review": {
      "errors": {
        "generalError": "Une erreur s'est produite. Message d'erreur :",
        "googleIntegrationError": "Impossible de répondre à cet avis. Il semble qu'il y ait une erreur avec votre intégration Google. Veuillez vous reconnecter sous Paramètres -> Intégrations.",
        "noReviewId": "Le clavardage n'a pas d'id d'avis."
      },
      "reviewPostTo": "Avis publié sur {network}",
      "sharedOn": "Avis partagé sur {network}",
      "disputeReview": "Contester cet avis",
      "learnHow": "(Apprenez comment?)",
      "seeOnGBP": "Consulter cet avis sur GBP",
      "alreadyShared": "Cet avis a déjà été publié sur {network}. Voulez-vous vraiment le republier?"
    },
    "reviewId": "Examiner l’ID",
    "schedule": {
      "sendSchedule": "Envoyer la planification",
      "timezone": "Fuseau horaire ({heading})",
      "title": "Planifier votre {type}"
    },
    "scheduling": "Planification…",
    "seeHow": "Découvrir comment",
    "selectFilter": "Sélectionner un filtre",
    "selected": "sélectionné",
    "sendEmail": {
      "recipientPlaceholder": "recipient@exemple.com",
      "subject": "Sujet :",
      "subjectPlaceholder": "Objet du courriel",
      "to": "À :",
      "sending": "Envoi...",
      "sendButton": "Envoyer un courriel"
    },
    "setupAccountWithFreeTutorials": "Configurez votre compte à l'aide de tutoriels gratuits.",
    "showOnlySlowQueries": "Afficher uniquement les requêtes lentes (>{threshold}ms)",
    "sms": {
      "confirmSending": "Confirmer l'envoi du message",
      "editModal": {
        "compose": "Composer un SMS"
      },
      "errors": {
        "customVariablesIssue": "Il y a des problèmes dans vos variables personnalisées, veuillez les corriger avant l'envoi.",
        "messageOrTemplateRequired": "Assurez-vous d'avoir saisi un message ou sélectionné un modèle.",
        "noPhoneNumber": "Le contact n'a pas de numéro de téléphone."
      },
      "scheduledSuccessfully": "Le SMS a bien été planifié.",
      "sendAnyway": "Envoyer quand même",
      "spamWarning": "Votre contenu SMS peut inclure des références au cannabis, au SHAFT, à la vape ou à d'autres sujets interdits. L'envoi de ce type de contenu par SMS est strictement interdit et peut entraîner des restrictions de compte. Veuillez examiner attentivement votre contenu avant de continuer.",
      "send": "Envoyer"
    },
    "startNewConversation": "Début d'une nouvelle conversation",
    "subAccountAndDeleteAllPhoneNumbers": "sous-compte et supprimez tous les numéros de téléphone.",
    "subAccountScheduledForDeletion": "La suppression de ce sous-compte est programmée.",
    "subAccountScheduledForDeletionItWillBeDeleted": "La suppression de ce sous-compte a été programmée. Il sera supprimé via",
    "teamInbox": "Boîte de réception de l'équipe",
    "threshold": "Seuil",
    "understandActionIrreversible": "Je comprends que cette action est irréversible et que toutes les données contenues dans ce sous-compte seront perdues.",
    "unstarred": "Sans étoile",
    "use_a_template": "Utiliser un modèle",
    "userAvailability": "Disponibilité de l'utilisateur",
    "userCalendarConfiguration": "Configuration du calendrier utilisateur",
    "userInfo": "Information sur l'utilisateur",
    "userRoles": "Rôles d'utilisateur",
    "viewSupportTickets": "Consultez vos billets d'assistance, nos articles d'aide et nos FAQ utiles!",
    "visitOurHelpCenter": "Consultez notre centre d'aide",
    "welcomeCourse": "Cours de bienvenue",
    "whatsapp_logo": "WhatsApp Logo",
    "youCanChangeYourMindBeforeThisTime": "Vous pouvez changer d'avis avant cette heure.",
    "zoomAccount": "Compte Zoom",
    "deleteEmails": "Supprimer {count} courriel(s)",
    "fileAttachment": {
      "urlNotFound": "L’URL est introuvable",
      "unsupportedAttachment": "Ces pièces jointes pourraient ne plus être prises en charge.",
      "downloadFile": "Télécharger le fichier"
    },
    "composer": {
      "internalComment": "Commentaire interne"
    },
    "dropdown": {
      "openOptions": "Options ouvertes",
      "messageDetails": "Détails du message"
    },
    "respond": "Répondez",
    "selectTemplate": "Sélectionner un modèle",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "Vous avez désactivé la fenêtre contextuelle. Veuillez activer les fenêtres contextuelles pour ce site afin d'être automatiquement redirigé vers un appel Zoom. Veuillez cliquer sur « Rejoindre maintenant » pour être redirigé directement vers un appel Zoom.",
        "helpAndSupport": "Aide et soutien",
        "summerOfAI": "Été de l'AI"
      }
    },
    "celebration": {
      "dismiss": "Rejeter",
      "body": "Ce n'est que le début, explorons comment GHL peut vous aider à développer votre entreprise.\nEn attendant, vous pouvez continuer à envoyer des messages autant que vous le souhaitez",
      "title": "Super! Les conversations sont fluides maintenant"
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "article d’aide ici",
      "message": "Veuillez enregistrer les témoins tiers pour voir cette page correctement. Vous pouvez consulter notre",
      "ok": "OK",
      "title": "Les témoins tiers ne fonctionnent pas"
    }
  },
  "crash": {
    "message": "Nous sommes désolés, mais quelque chose d'inattendu s'est produit. Essayez de rafraîchir la page.",
    "refresh": "Rafraîchir la page",
    "title": "Oups! Un problème est survenu."
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Annulation de la suppression pour {name}",
      "confirmAbort": "Oui, annuler",
      "keepDeleting": "Non, continuez à supprimer",
      "message": "Voulez-vous vraiment annuler?",
      "scheduledForDeletion": "Cet emplacement sera supprimé le {date}",
      "title": "Annuler la suppression",
      "warning": "Veuillez noter : l’emplacement sera supprimé à la date prévue à moins que vous n’annuliez la suppression."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Déposez les fichiers ici pour les téléverser.",
      "uploadError": "Erreur réseau : impossible d'envoyer une requête à AWS. (Peut-être une erreur CORS)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "Ajouter un {entityName}",
      "clonedMessage": "{entityName} cloné. Passez à un compte sur lequel il a été cloné et trouvez-le sous l'onglet {entityName}.",
      "errorGettingDetails": "Il semble y avoir un échec lors de la récupération des détails de {entityName}. Veuillez vérifier l’URL ou réessayer.",
      "permissionError": "Erreur d’autorisation : Ceci est un entonnoir protégé et ne peut pas être généré ici."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "Logo de Google Calendar"
    },
    "printful": {
      "logo": "Logo Printful",
      "title": "Printful : Impression à la demande"
    },
    "printify": {
      "logo": "Logo Printify",
      "title": "Printify : Impression à la demande"
    },
    "shipStation": {
      "logo": "Logo ShipStation",
      "title": "ShipStation"
    },
    "shippo": {
      "logo": "Logo Shippo",
      "title": "Shippo : Intégration d'expédition"
    },
    "tikTok": {
      "accountNotConnected": "Compte non connecté",
      "accountNotConnectedMessage": "Votre compte n'est pas connecté au compte publicitaire TikTok. Intégration complète pour voir les formulaires et cartographier les champs.",
      "advertiserId": "ID de l'annonceur",
      "companyFields": "Domaines {companyName}",
      "editFields": "Modifier les champs",
      "errorSubscribing": "Erreur lors de l'abonnement à la page.",
      "formsNotAvailable": "Formulaires non disponibles",
      "mandatoryFieldsNote": "Note : Associez l'un des champs obligatoires ci-dessous pour recevoir des pistes dans votre compte avec succès. Champs : Prénom, Nom de famille, Courriel, Numéro de téléphone",
      "noFormsMessage": "Vous n'avez actuellement aucun formulaire de génération de prospects créé dans votre compte publicitaire TikTok. Visitez votre compte publicitaire TikTok et créez-en un pour commencer.",
      "pageId": "ID de page",
      "selectAdvertiserAccount": "Sélectionner un compte publicitaire"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Autre / Je ne sais pas",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "Vous devez compléter quelques étapes simples pour suspendre ce sous-compte."
    },
    "transfer": {
      "chooseDescription": "Sélectionner votre méthode de téléversement",
      "chooseMethod": "Téléverser ce sous-compte",
      "eject": {
        "description": "Gagnez 40 % de commission récurrente sur l’abonnement du nouveau compte.",
        "title": "Éjecter en tant que nouveau compte"
      },
      "modal": {
        "confirmDetails": "Veuillez enregistrer les détails avant de transférer",
        "confirmNomineePrefix": "Nommer un propriétaire pour",
        "confirmTransfer": "Confirmer le transfert",
        "consentText": "J’ai lu et compris le guide ci-dessus et j’approuve toutes les limitations",
        "ejectErrorTitle": "Impossible d’éjecter le sous-compte.",
        "ejectGenericError": "Le sous-compte que vous tentez d'éjecter ne peut pas être éjecté. Veuillez communiquer avec le service de soutien.",
        "ejectGuidelines": "Directives pour l'éjection de sous-compte",
        "ejectSubject": "L'éjection de sous-compte est soumise à l'acceptation par l'utilisateur de la demande de générer une nouvelle agence.",
        "ejectSuccessTitle": "Demande d'éjection de sous-compte envoyée à l'utilisateur sélectionné",
        "enterPassword": "Veuillez saisir votre mot de passe pour confirmer",
        "genericError": "Le sous-compte que vous essayez de transférer ne peut pas être transféré. Veuillez communiquer avec le service de soutien.",
        "guidelines": "Directives relatives au transfert de sous-comptes",
        "guidelinesConsent": "Veuillez lire et consentir",
        "hipaaDisclaimer": "Avertissement",
        "hipaaText": "Vous pourriez vouloir informer ce sous-compte qu'il bénéficie maintenant d'une couverture HIPAA, mais qu'il se peut qu'il n'ait pas la même couverture sous la vue de l'agence vers laquelle il est transféré.",
        "noUsersDescription": "Il n’y a aucun utilisateur associé à ce sous-compte. Veuillez ajouter un utilisateur de sous-compte et continuer.",
        "noUsersSearch": "Aucun utilisateur trouvé.",
        "noUsersTitle": "Aucun utilisateur trouvé",
        "nomineeInstructions": "Le candidat recevra un lien pour s'abonner à HighLevel.",
        "passwordError": "Mot de passe non valide",
        "passwordErrorDescription": "Le mot de passe que vous avez saisi est invalide. Veuillez réessayer.",
        "relationshipError": "Veuillez entrer le numéro de relation correct.",
        "relationshipNumber": "Numéro de relation de l’agence destinataire",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Demande de transfert",
        "seeAllRequests": "Voir toutes les demandes",
        "successMessage": "Le sous-compte sera transféré une fois que l'agence réceptrice aura accepté votre demande de transfert.",
        "successTitle": "Demande de transfert de sous-compte envoyée à l'agence réceptrice",
        "title": "Transférer un sous-compte",
        "transferSubject": "Le transfert de sous-compte est soumis à l’acceptation de l’agence de réception dans son compte.",
        "confirmNomineeSuffix": " à "
      },
      "transferExisting": {
        "description": "Téléverser la totalité de ce sous-compte vers un autre compte.",
        "title": "Transfert vers un compte existant"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Prochaine exécution",
      "title": "Demandes en masse"
    },
    "campaign": {
      "account": "Compte",
      "accountBuffer": "Tampon de compte",
      "accountBufferDescription": "Il n'y a pas de limite au nombre de destinataires ajoutés chaque jour à cette campagne (à partir d'une liste).",
      "accounts": "Comptes",
      "activity": "Activité",
      "acquire": "Hériter",
      "acquisitionDescription": "Les campagnes d'acquisition de clients vous aident à produire plus de prospects « chauds » prêts à s'engager.",
      "addEvent": "Ajouter un événement",
      "addUser": "Ajouter un utilisateur",
      "allMarket": "Tout le marché",
      "allowMultiple": "Autoriser plusieurs",
      "assignedToTooltip": "Quand cette campagne a débuté, ce contact a été assigné à cet utilisateur. Les modifications apportées à l'attribution du contact se répercuteront sur les évènements, mais ne changeront pas la valeur initiale.",
      "atLeastOneEvent": "Au moins un événement est obligatoire.",
      "automations": "Automatisations",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque à, id, nom nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod distinctio vero et quia omnis? Corps omnis, ipsa in, quae iste libero Moins, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur ! Qui ratione iure modi eos quaerat facere des désagréments. Quatre voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "A rebondi",
      "buffering": "Mise en mémoire tampon",
      "campaignActivity": "Activités de campagne",
      "campaignConfiguration": "Réglages de la campagne",
      "campaignConfigurationWarning": "Les réglages des campagnes affecte tous les marchés. Assurez-vous que vous devez modifier ces paramètres.",
      "campaignCreation": "Création de campagne",
      "campaignId": "Id de la campagne",
      "campaignStatusByRecipients": "Statut de la campagne par destinataire",
      "clickThroughRate": "Fréquence de clics",
      "clickedThrough": "Cliquez dessus",
      "conditionIfExplanation": "Exécutez cette campagne ou cet événement si l'heure actuelle se situe dans cette fenêtre, si l'heure actuelle se situe en dehors de cette fenêtre, ignorez la campagne ou l'événement et passez au suivant.",
      "conditionWhenExplanation": "Exécutez les événements de cette campagne lorsque l'heure actuelle se situe dans cette fenêtre, sinon attendez la fenêtre suivante pour exécuter les événements.",
      "createCampaign": " Créer une campagne",
      "ctr": "CTR",
      "customerAcquisition": "Acquisition de clients",
      "dateAdded": "Date ajoutée",
      "dateAddedTooltip": "Le jour et l’heure exacts à laquelle le contact a été ajouté à cette campagne. L’heure de départ du premier événement peut varier selon les réglages.",
      "deletedRestorePrompt": "Cette campagne a été supprimée. Voulez-vous la restaurer?",
      "delivered": "Livré",
      "deliveryRate": "Fréquence de livraison",
      "draftMode": "Mode ébauche",
      "draftModeDescription": "Cette campagne est une ébauche. Elle ne peut pas être utilisée tant qu'elle n'est pas publiée.",
      "dropped": "Abandonné",
      "emailActivity": "Activité courriel",
      "emailActivityFilterExample": "Activité de courriel : Clic effectué",
      "event": "Événement",
      "eventFilterExample": "Événement : 10X courriel 4 (Distribution de la liste)",
      "filters": "Filtres",
      "emailPerformanceByAccount": "Performance des courriels par compte",
      "emailsNotSentOnDays": "Les courriels ne seront pas envoyé le samedi et le dimanche.",
      "emailsSentOnDays": "Les courriels seront envoyés le lundi, mardi, mercredi, jeudi et vendredi.",
      "eventStartDate": "Date de début de l’événement",
      "exampleAddress": "801 7e Avenue Nord, Saskatoon, SK",
      "exampleCompanyName": "City Perks Coffehouse",
      "exampleDate": "8 mai 2017 à 13 h 27",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Assurez-vous que les statistiques ne datent pas de plus de 30 jours",
      "exampleEventName": "10X courriel 4 (Distribution de la liste)",
      "getMoreCustomers": "Attirez plus de clients",
      "inProgress": "En cours",
      "includedDays": "Jours Inclus",
      "internalSource": "Source Interne",
      "lastUpdate": "Dernière mise à jour",
      "leadValuePlaceholder": "Valeur du prospect en $",
      "loopDetected": "Cette campagne a été bloquée au statut ébauche car elle provoque un blocage. Pour activer cette campagne, veuillez contacter le soutien.",
      "market": "Marché",
      "moreDetails": "Plus de détails",
      "myCampaigns": "Mes Campagnes",
      "na": "S.O.",
      "newFolder": " Nouveau dossier",
      "nextCampaign": "Prochaine campagne",
      "nextExecutionTime": "Heure de la prochaine exécution",
      "opened": "Ouvert",
      "openRate": "Taux d’ouverture",
      "option2": "Option 2",
      "option3": "Option 3",
      "pageNavigation": "Modèle de navigation par page",
      "processed": "Traité",
      "published": "Publié",
      "recipient": "Destinataire",
      "recipients": "Destinataires",
      "sampleCampaign": "Exemple de campagne ",
      "scheduling": "Planification",
      "seeHotLeads": "Voir les pistes intéressantes",
      "selectDateRange": "Sélectionnez une plage de dates.",
      "selectTimeZone": "Sélectionnez le fuseau horaire",
      "separator": " / ",
      "showingCount": "Affichage de {current} sur {total}",
      "spamReport": "Rapport de pourriel",
      "startByAddingEvent": "Commencez par ajouter un événement à cette campagne.",
      "stopOnResponse": "Arrêter à la réponse",
      "stopped": "En pause",
      "time": "Heure",
      "timeConditionNote": "Note : Si la première étape des campagnes est réglée sur « Immédiatement », alors la condition de temps ne s’appliquerait pas à cette première étape.",
      "timeZoneDescription": "Ce réglage influencera l'heure à laquelle votre contenu sera envoyé.",
      "totalLeads": "Nombre total de pistes",
      "undeliverable": "Non livrable",
      "unsubscribe": "Se désabonner",
      "upNext": "Suivant",
      "utc": "UTC",
      "window": "Fenêtre"
    },
    "embed": {
      "copyLinkInstructions": "Copiez le lien ci-dessous et partagez-le facilement où vous voulez.",
      "embed": "Intégrer",
      "iframeEmbed": "Intégration Iframe",
      "integrateInstructions": "Utilisez les options suivantes pour intégrer votre formulaire personnalisé à votre site Web",
      "integrateYourForm": "Intégrez votre formulaire",
      "link": "Lien",
      "saveAndExit": "Enregistrer et quitter"
    },
    "jotbox": {
      "deleteSubmission": "Supprimer la soumission",
      "downloadPdf": "Télécharger le PDF",
      "ofSubmissions": " de {total} soumissions",
      "pages": "pages",
      "records": "enregistrements",
      "searchPlaceholder": "Rechercher par nom, courriel, téléphone et identifiant de contact",
      "selectYourForm": "Sélectionner votre formulaire",
      "timeSigned": "Heure de signature :",
      "totals": "Totaux :"
    },
    "survey": {
      "createNewSurvey": "Créer un nouveau sondage",
      "integrateYourSurvey": "Intégrez votre sondage",
      "noSurveysForAnalyze": "Vous n'avez pas encore de sondage. Veuillez d'abord générer un sondage pour voir les statistiques ici.",
      "noSurveysForSubmission": "Vous n'avez pas encore de sondage. Veuillez d'abord générer un sondage pour voir la soumission ici.",
      "noSurveysYet": "Vous n'avez pas encore de sondage.",
      "refreshData": "Actualiser les données",
      "searchSurveys": "Sondages de recherche",
      "surveyBuilder": "Générateur de sondages",
      "toCreateFirstSurvey": "pour créer votre premier sondage."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Produit cloné! Passez à un compte où il a été cloné et retrouvez-le sous l'onglet Adhésion > Produits.",
      "errorGettingDetails": "Il semble y avoir une erreur lors de l’obtention des détails du produit. Veuillez vérifier l’URL ou réessayer!"
    },
    "resetPassword": {
      "title": "Réinitialiser le mot de passe",
      "button": "Réinitialiser le mot de passe",
      "newPassword": "Nouveau mot de passe",
      "generateStrongPassword": "Générez un mot de passe fort.",
      "sendEmailNotification": "Envoyez une notification par courriel également.",
      "errorMessage": "Une erreur s’est produite lors de la réinitialisation du mot de passe. Veuillez réessayer.",
      "updating": "Mise à jour en cours…"
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ via",
      "combo": {
        "signedUp": "s'est inscrit à ProveSource au cours des dernières 24 heures",
        "verifiedBy": "vérifié par "
      },
      "conversions": {
        "recentlyBought": "a récemment acheté ceci",
        "timeAgo": "dans les 16 dernières minutes ",
        "visitorsCount": "50 visiteurs"
      },
      "pageVisits": {
        "description": "semblent avoir faim, aussi.",
        "timeAgo": "dans les 21 dernières minutes                        ",
        "title": "50 gourmets"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " ProofMessge",
        "rating": "évaluation 5 étoiles",
        "recently": "Récemment",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "s'est inscrit à ProveSource",
        "location": "(London, Royaume-Uni)",
        "name": "Mike ",
        "timeAgo": "Il y a 40 minutes                        "
      },
      "visitors": {
        "description": "amateurs de musique en ligne"
      }
    },
    "step1": {
      "combo": {
        "description": "Affichez le nombre total de personnes ayant effectué une action spécifique au cours des dernières 24 heures, 7 ou 30 jours.",
        "title": "Combo"
      },
      "conversions": {
        "description": "Créez une validation sociale en montrant combien de clients ont fait une action précise."
      },
      "liveReviews": {
        "description": "Montrez à vos visiteurs des avis 4+ étoiles en temps réel des 6 derniers mois."
      },
      "liveVisitors": {
        "beta": "Bêta",
        "description": "Montrez combien de visiteurs consultent actuellement votre site en temps réel."
      },
      "pageVisits": {
        "description": "Montrez à vos visiteurs qu’ils ne sont pas les seuls à la fête en mettant en avant les visites récentes de pages."
      },
      "stream": {
        "description": "Quoi de mieux que de mettre un visage sur cette preuve sociale? Montrez vos clients récents et leurs actions."
      }
    },
    "step2": {
      "captureDescription2": "Chaque URL de page doit comporter un champ de formulaire courriel",
      "captureDescription3": " et ProveSource installé. ",
      "comboType": "Type de combo",
      "connectAccounts": "Assurez-vous de connecter les comptes dont vous souhaitez obtenir des avis",
      "connectGoogleAccount": "Connectez le compte Google de votre emplacement",
      "formSubmissions": "Soumissions de formulaires",
      "googleAccount": "Compte Google",
      "howToTrack": "Comment suivre",
      "howToTrackDescription": "Comment devrions-nous suivre vos conversions?",
      "pageUrl": "URL de la page",
      "productPurchase": "Achat de produits",
      "trackAllUrls": "Suivez toutes les URL de page contenant l’expression suivante. ",
      "trackVisitors": "Suivre les visiteurs",
      "trackVisits": "Suivre les visiteurs",
      "urlTip": " Nous traitons http://, https://, www et non-www comme des versions distinctes de l'URL et de la page. ",
      "urlValidationError": "Vous devez inclure au moins une URL. Le lien URL est invalide. Assurez-vous d'inclure http:// ou https://",
      "userSignup": "Inscription de l'utilisateur",
      "visits": " Visites",
      "webhookDescription": "Contactez le point de terminaison suivant pour nous informer d'un événement ou d'une conversion qui s'est produit de votre côté et qui est lié à cette notification. Nous nous occuperons du reste.",
      "webhookRequest": "Demande de Webhook",
      "whatToTrack": "Qu’aimeriez-vous suivre?",
      "whereToCapture": "Où capturer",
      "whereToCaptureDescription": "Où capturez-vous les conversions?",
      "whichPagesToTrack": "Quelles pages souhaitez-vous que nous suivions?",
      "yourWebhookUrl": "Votre URL de Webhook"
    },
    "step3": {
      "allPages": " Toutes les pages",
      "displayOnAllPages": "Afficher sur toutes les URL de page contenant l'expression suivante: ",
      "whereToDisplay": "Où afficher",
      "whereToDisplayActivity": "Où souhaitez-vous que nous affichions cette activité?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "pour obtenir de jolies icônes (cliquez avec le bouton droit sur une icône -> Copier l'adresse de l'image)",
      "messageSettings": "Paramètres des messages",
      "messageText": "Texte du message",
      "referToVisitorsAs": "Faites référence aux visiteurs en tant que",
      "visitIcons8": "Visite"
    },
    "step5": {
      "allowUsersToClose": " Permettre aux utilisateurs de fermer la notification ",
      "behavior": "Comportement",
      "bottomLeft": "En bas à gauche",
      "bottomRight": "En bas à droite",
      "clickableNotification": " Notification cliquable ",
      "customizeDescription": "Modifiez les paramètres suivants pour contrôler le comportement et l’apparence de votre notification",
      "design": "Stylisme",
      "displayNotificationFor": "Afficher la notification pour",
      "displayRules": "Règles d'affichage",
      "hideOnMobileScreens": " Cacher sur les écrans Mobile ",
      "linkRelativeNote": " Si http:// est omis, le lien s’ouvrira relativement à la page affichée ",
      "minimumEventsToDisplay": "Nombre minimum d'événements à afficher",
      "notificationLink": "Lien de notification",
      "notificationPosition": "Position de notification",
      "openLinkInNewTab": "Ouvrir le lien dans le nouvel onglet",
      "selectPosition": "Sélectionnez une position",
      "showOnlyOncePerSession": " Afficher une seule fois par session ",
      "titleBackground": "Contexte du Titre",
      "titleColor": "Couleur du titre",
      "topLeft": "En haut à gauche",
      "topRight": "En haut à droite",
      "typeUrlHere": "Tapez l'URL ici"
    },
    "step6": {
      "identifyNotification": "Identifiez votre notification",
      "launchMessage": "Nous sommes sur le point de lancer, veuillez prendre place et attacher votre ceinture.",
      "notificationName": "Nom de la notification",
      "notificationNamePrompt": "Quel est le nom de votre notification?",
      "wellDone": "Bien fait."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Abonnement créé avec succès",
      "youCanNowSetupWordPress": "Vous pouvez maintenant configurer votre site WordPress",
      "subscriptionFailed": "Échec de l'abonnement",
      "resubscriptionSuccessful": "Réabonnement Réussi",
      "successfullyReactivated": "Votre abonnement WordPress a été réactivé avec succès",
      "reactiveSub": "Impossible de réactiver l’abonnement",
      "resubscriptionFailed": "Échec de la réinscription"
    },
    "v2": {
      "viewDetails": "Voir les détails",
      "chatConversationAssigned": "Conversation de clavardage assignée",
      "internalChat": "Clavardage interne",
      "newTask": "Nouvelle tâche",
      "appointmentReminder": "Rappel de rendez-vous",
      "facebookReview": "Avis Facebook",
      "googleReview": "Avis Google",
      "internalChatMessage": "Message de clavardage interne",
      "newAppointmentAssigned": "Nouveau rendez-vous assigné",
      "newAppointmentBooked": "Nouveau rendez-vous réservé",
      "newCall": "Nouvel appel",
      "newEmail": "Nouveau courriel",
      "newMention": "Nouvelle mention",
      "newReviewReceived": "Nouvel avis reçu de {contactName}",
      "taskReminder": "Rappel de tâches",
      "completed": "terminé",
      "failed": "échec",
      "subAccount": "Sous-compte",
      "newMessage": "Nouveau message",
      "newAppointmentBookedWith": "Nouveau rendez-vous pris avec {contactName}",
      "newAppointmentAssignedTo": "Nouveau rendez-vous assigné à {contactName}",
      "appointmentDueIn": "Rendez-vous prévu dans {minutes} minutes avec {contactName}",
      "newTypeReceived": "Nouveau {type} reçu de {contactName}",
      "newChatAssigned": "Nouvelle conversation assignée de {contactName}",
      "taskDueDate": "Tâche '{title}' à remettre le {date} à {time} pour {contactName}",
      "tasksDueToday": "{count} tâches dues aujourd'hui",
      "tasksOverdue": "{count} tâches en retard",
      "taskDueIn": "Tâche ' {title} ' à rendre dans {dueTime} {unitOfTime} pour {contactName}",
      "mentionedInConversation": "{userName} vous a mentionné dans une conversation avec {contactName}",
      "now": "maintenant"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Logo de l’entreprise"
      },
      "bestExperience": "meilleure expérience.",
      "optimizedFor": "Cette page est optimisée pour",
      "portraitMode": "mode portrait",
      "toGiveYou": "pour vous offrir la"
    }
  },
  "pagination": {
    "goToFirstPage": "Aller à la première page",
    "goToLastPage": "Aller à la dernière page",
    "goToNextPage": "Aller à la page suivante",
    "goToPreviousPage": "Aller à la page précédente",
    "itemsSelected": "{count} éléments sélectionnés",
    "showingEntries": "Afficher les entrées {from} à {to} sur {total}"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/ min",
    "_please_add_a_payment_method_for": "! Veuillez ajouter une méthode de paiement pour",
    "_segment": "/ segment",
    "ad_manager": "Gestionnaire d'annonces",
    "add": "[AJOUT :",
    "ai_employee": "Employé AI",
    "billing": {
      "incompleteBillingInfo": "Vous avez des informations de facturation incomplètes sur ce compte. Veuillez le mettre à jour immédiatement.",
      "updateNow": "Rafraîchir maintenant"
    },
    "charge": "Frais",
    "contactLimit": {
      "message": "Vous avez atteint la limite de votre forfait actuel pour ajouter {contact}. Pour continuer, veuillez améliorer votre forfait et débloquer une capacité supplémentaire.",
      "upgradeNow": "Mettre à niveau maintenant",
      "warningMessage": "Vous avez {current} contact(s) alors que votre calendrier ne permet que {limit}.",
      "warningTitle": "L'utilisation du compte a dépassé la limite. Veuillez mettre à niveau votre compte pour vous assurer qu’il continue de fonctionner sans interruption."
    },
    "cost_borne_by_you": "coût supporté par vous",
    "dedicated_ip": "IP dédiée",
    "electeditem": "electedItem",
    "feedback": "Rétroaction :",
    "hello": "Bonjour",
    "helpDrawer": {
      "aiSupportAssistant": "Assistant d'aide à l'IA",
      "clickToCopy": "Cliquez pour copier le numéro de relation",
      "clickToCopyToClipboard": "Cliquez pour copier le numéro de relation dans le presse-papiers",
      "companyRelationshipNumber": "Numéro de relation d’entreprise",
      "hiImHighly": "Bonjour, je m'appelle Highly!",
      "implementation": "Mise en œuvre",
      "joinImplementationVideo": "Rejoindre la mise en œuvre Appel vidéo",
      "joinTrialZoom": "Participez à un appel Zoom d’essai",
      "kickoff": "lancement",
      "needHelpChatVideo": "Besoin d'aide? Commencez une discussion ou un appel vidéo avec nous dès maintenant!",
      "openAIAssistant": "Assistant d'aide AI ouvert",
      "premium": "Premium",
      "priority": "Priorité",
      "raiseSupportTicket": "Ouvrez un ticket de support",
      "raiseTicket": "Ouvrir un ticket",
      "relationshipNumber": "Numéro de relation",
      "startAISupportChat": "Lancer le clavardage de support AI",
      "startAgentChatWait": "Démarrez le clavardage avec un agent avec un temps d'attente de 2 à 5 minutes",
      "startChatChoose": "Démarrer le clavardage - choisissez entre l'assistance AI ou le clavardage avec un agent",
      "startImplementationVideo": "Démarrer l’implémentation de l’appel vidéo",
      "startZoom": "Démarrer Zoom",
      "startZoomCall": "Lancer l’appel Zoom",
      "subtitle": "Que vous souhaitiez discuter avec nous, avec la communauté ou apprendre par vous-même, nous avons ce qu'il vous faut!",
      "title": "Aide et soutien",
      "trialExperience": "Expérience d'essai",
      "useButtonsBelow": "Utilisez n’importe lequel des boutons ci-dessous pour obtenir de l’aide!",
      "videoCallReward": "Participez à un appel vidéo pour configurer votre compte — et obtenez {amount} crédités sur votre portefeuille lorsque vous y assistez.",
      "videoCallType": "Rejoignez-moi pour un appel vidéo pour votre appel {type}.",
      "yourPremiumSupportSpecialist": "Votre professionnel du soutien {type}",
      "yourSpecialist": "Votre Professionnel {type}",
      "yourSupportSpecialist": "Votre spécialiste en soutien",
      "videoCall": "Appel vidéo",
      "active": "Actif",
      "announcementsAria": "Annonces - cliquez pour ouvrir dans un nouvel onglet",
      "chat": "Clavardage",
      "accessWelcomeCourseAria": "Cliquez pour accéder au cours de Bienvenue HighLevel",
      "clickToUpgrade": "Cliquez pour mettre à niveau",
      "connectCertifiedAdminAria": "Connectez-vous avec un administrateur certifié - cliquez pour ouvrir dans un nouvel onglet",
      "connectWithUsAria": "Connectez-vous avec nous – lancez le clavardage en direct",
      "contactUsAria": "Contactez-nous - appelez HighLevel au +1(888)732-4197",
      "copied": "Copié",
      "highlevelEventsAria": "Événements Highlevel - cliquez pour ouvrir dans un nouvel onglet",
      "joinFacebookGroupAria": "Rejoignez notre groupe Facebook - cliquez pour ouvrir dans un nouvel onglet",
      "onboardingVideoTutorialsAria": "Tutoriels vidéo d’intégration - cliquez pour ouvrir dans un nouvel onglet",
      "recommended": "Recommandé",
      "visitHelpCenterAria": "Visitez notre Centre d’aide - cliquez pour ouvrir dans un nouvel onglet",
      "contactUs": "Contactez nous",
      "agentChatWaitTime": "Clavardage avec un agent (~ 2 à 5 min d'attente)",
      "aiSupportChat": "Clavardage de support AI",
      "startChat": "Démarrer le clavardage",
      "announcements": "Annonces",
      "fastestGrowingCommunity": "Rejoignez la communauté qui connaît la plus forte croissance.",
      "callHighlevelPhone": "Appelez HighLevel au +1(888)732-4197",
      "connectCertifiedAdmin": "Connectez-vous avec un administrateur certifié",
      "connectTeamVideoCall": "Communiquez avec notre équipe pour obtenir de l'aide lors d'un appel vidéo en direct!",
      "connectWithUs": "Communiquez avec nous",
      "dailyBrainstormingSessions": "Sessions de brainstorming quotidiennes avec Highlevel",
      "certifiedAdminDescription": "Découvrez les experts de HighLevel qui peuvent vous aider à configurer votre système, automatiser vos flux de travail ou personnaliser votre projet.",
      "getAccessWelcomeCourse": "Accédez au cours de bienvenue HighLevel",
      "premiumSupportDescription": "Bénéficiez d'un dépannage prioritaire, de conseils d'experts et d'un accès direct à notre équipe technique par le biais de Slack.",
      "highlevelEvents": "Événements Highlevel",
      "joinFacebookGroup": "Rejoignez notre groupe Facebook",
      "onboardingVideoTutorials": "Tutoriels vidéo d'intégration",
      "premiumSupport": "Support Premium",
      "setupAccountFreeTutorials": "Configurez votre compte à l'aide de tutoriels gratuits",
      "viewSupportTicketsArticles": "Consultez vos tickets d'assistance, nos articles d'aide et nos FAQ utiles!",
      "visitHelpCenter": "Consultez notre centre d'aide",
      "welcomeCourse": "Cours de Bienvenue",
      "beta": "Bêta",
      "closeHelpSupportDrawer": "Fermer le tiroir Aide & Support",
      "upgradePlanToEnable": "Vous devez mettre à niveau votre plan pour activer cette fonctionnalité",
      "premiumSupportActive": "Votre support premium est actif",
      "premiumSupportClickUpgrade": "Soutien Premium - Cliquez pour mettre à jour votre forfait",
      "premiumSupportActiveAria": "Assistance Premium - Votre assistance premium est active",
      "keepUpToDateNews": "Restez à l'affût des dernières nouveautés et annonces!"
    },
    "hi": "Bonjour",
    "is_scheduled_for_deletion_on": "est programmé pour suppression le",
    "k": "K",
    "limit_updated_from": "limite mise à jour à partir de",
    "minimum_must_be": "Le minimum doit être",
    "more_emails_in_thread": "plus de courriels dans le fil de discussion",
    "multipleUsers": {
      "chooseAccount": "Sélectionnez un Compte pour continuer"
    },
    "must_be_in_range_of_0": "Doit être dans la plage de 0 à",
    "numbers_and": "nombre(s) et",
    "premiumSupport": {
      "assigningManager": "Attribution d'un gestionnaire de compte technique...",
      "bookCall": "Réserver un appel",
      "hiIm": "Bonjour, je suis {name}",
      "joinZoomNow": "Rejoignez un appel Zoom dès maintenant",
      "quickActions": "Actions de soutien rapide",
      "quickLinks": "Liens rapides",
      "raiseFeatureRequest": "Élever une demande de fonctionnalité",
      "slackChannelCreating": "Accrochez-vous — votre chaîne Premium Slack démarre! 🚀",
      "technicalAccountManager": "Gestionnaire de comptes techniques",
      "viewRoadmap": "Consulter la feuille de route des produits"
    },
    "prospecting": "Prospection",
    "reloadPopup": {
      "message": "Nous avons remarqué que vous n’avez pas rafraîchi la page depuis un moment. Veuillez recharger pour profiter de la meilleure expérience possible de l’application.",
      "refreshNow": "Rafraîchissez maintenant"
    },
    "resell_settings": "Paramètres de revente",
    "row": "rangée",
    "select_upto": "Sélectionnez jusqu'à",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Bénéficiez d'une assistance dédiée à l'heure qui vous convient.",
      "title": "Planifiez un appel avec le support de haut niveau"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Il s'agit de marges facturées à vos clients sur la",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Laissez-nous gérer Twilio pour vous sans tracas",
        "benefit2": "Notre équipe de soutien s’occupe de vos problèmes liés à Twilio",
        "button": "Faites-le pour moi",
        "drawback": "Payez {price} de plus pour le service à valeur ajoutée par rapport à si vous le faisiez vous-même",
        "title": "Nous le ferons pour vous"
      },
      "lowCreditsMessage": "Vous devez connecter un compte Twilio pour gérer les appels et textos, qui sont envoyés/reçus sur HighLevel.",
      "lowCreditsTitle": "Vous n’avez plus de crédits Twilio gratuits Twilio, mais nous sommes là pour vous soutenir!",
      "selfSetup": {
        "benefit1": "Gérez vos dépenses",
        "benefit2": "Ayez plus de contrôle sur votre service Twilio",
        "button": "Je vais me débrouiller",
        "drawback1": "Engagez quelqu’un pour gérer le service Twilio",
        "drawback2": "Contactez le support de Twilio quand quelque chose ne fonctionne pas.",
        "title": "Faites-le vous-même"
      },
      "wip": {
        "button": "Configurez Twilio maintenant",
        "fallback": "Pour l’instant, vous devrez gérer votre propre compte Twilio.",
        "message": "Merci de nous avoir choisis, mais nous travaillons toujours à développer cette fonctionnalité. Vous recevrez de nos nouvelles dès que nous pourrons déployer cela pour votre compte.",
        "title": "Nous y travaillons toujours!!"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Chargement de plus d'options...",
      "noElementsFound": "Oups! Aucun élément trouvé. Envisagez de modifier la requête de recherche.",
      "noLocationsFound": "Aucun emplacement trouvé. Essayez une autre recherche.",
      "typeToSearch": "Tapez pour chercher",
      "enterUserEmail": "Entrez le courriel de l’utilisateur"
    },
    "updating": "Mise à jour",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Utiliser le modèle"
    },
    "validEmail": {
      "andYouCan": "Et vous pouvez",
      "as": "comme",
      "canReverify": "Vous pouvez revérifier votre courriel",
      "emailIs": "Ce courriel est",
      "emailMarkedAs": "Ce courriel marqué comme",
      "markedAsInvalid": "Ce courriel est indiqué comme",
      "notVerified": "Non vérifié",
      "reverifyHere": "Revérifier ici",
      "verifyHere": "Vérifier ici"
    },
    "will_give_you_about": "vous donnera environ",
    "checkout": {
      "confirm": "Confirme",
      "cardInformation": "Information sur la carte",
      "cardNumberInvalid": "Votre numéro de carte est invalide.",
      "commitment": "engagement",
      "paymentConsent": "En confirmant, vous permettez à LeadConnector de facturer votre carte pour ce paiement.",
      "subscriptionConsent": "En confirmant votre abonnement, vous permettez à LeadConnector de facturer votre carte pour ce paiement et les paiements futurs pour cet abonnement",
      "endingIn": "se terminant par",
      "month": "mois",
      "pay": "Payer",
      "payWithCard": "payez par carte",
      "paymentBeingProcessed": "Le paiement est en cours de traitement. Veuillez ne pas recharger et ne pas appuyer sur le bouton retour",
      "proceedWithExistingCard": "Procédez avec la carte existante",
      "proceedWithNewCard": "Procédez avec une nouvelle carte",
      "purchase": "achat",
      "subscribe": "S'abonner",
      "subscribeTo": "S’abonner à",
      "pleaseUpdateCardDetails": "Veuillez mettre à jour les détails de la carte",
      "zip": "zip",
      "retry": "réessayer",
      "initialChargesProrated": "Les frais initiaux sont calculés au prorata et la facturation régulière commencera à partir de",
      "youWillBeChargedFor": "Des frais vous seront facturés.",
      "days": "jours",
      "rightNowForPeriodTill": "en ce moment pour la période jusqu’à la fin",
      "startGettingChargedFullAmount": "et commencerez à être facturé le montant total de",
      "perMonthStartingFrom": "/mois à partir de",
      "nameOnCard": "Nom sur la carte",
      "somethingWentWrong": "Quelque chose s'est mal passé",
      "errorImg": "img d'erreur",
      "networkError": "Erreur réseau, veuillez réessayer plus tard",
      "paymentCouldNotBeProcessed": "Le paiement n’a pas pu être traité. Veuillez réessayer d’ajouter une carte."
    },
    "deleteLocation": {
      "back": "Retour",
      "delete": "Supprimer",
      "completeStepsToDelete": "Vous devez compléter quelques étapes simples pour supprimer cet emplacement",
      "alsoCloseAssociated": "Également étroitement associé",
      "scheduling": "Planification….",
      "subAccountAndDeletePhoneNumbers": "sous-compte et supprimez tous les numéros de téléphone",
      "somethingWentWrongTryAgain": "Une erreur s'est produite... Veuillez réessayer plus tard",
      "deleteSubAccount": "Supprimer le sous-compte.",
      "scheduleForDeletion": "Planification pour suppression"
    },
    "productRebilling": {
      "enableRebilling": "Activer la refacturation",
      "ratesMayDifferUK": "Les taux peuvent varier selon la région. Les calculs présentés sont basés sur les taux pour le Royaume-Uni,",
      "examplePricingGpt4oMini": "Exemple de tarification - GPT-4o Mini",
      "input": "Entrée",
      "output": "Sortie",
      "supportDoc": "documentation à l'appui",
      "unsavedChanges": "Modifications non enregistrées",
      "to": "à",
      "chargedToCustomerLower": "Facturé au client",
      "model": "Modèle",
      "profit": "Profit",
      "saving": "Sauvegarde en cours….",
      "type": "Saisissez",
      "updating": "Mise à jour en cours….",
      "clickHere": "Cliquez ici",
      "chargedToCustomer": "Facturé au client",
      "enabling": "Activation en cours…",
      "forMoreDetails": "pour plus de détails.",
      "tenDollarsWillGive": "10 $ vous donneront environ",
      "yourCost": "Vos coûts",
      "seeHow": "Découvrez comment",
      "clientCompanyBillingPage": "Page de facturation de l'entreprise du client",
      "connectStripeToEnable": "Pour activer la refacturation, vous devez connecter Stripe sur",
      "companyStripeIntegrationPage": "la page d'intégration Stripe de l'entreprise",
      "enterClientCardInfo": "Pour activer la refacturation, vous devez saisir les informations de carte de votre client sur",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(pour 750–000 mots)",
      "words": "mots",
      "yourCostLower": "Votre coût",
      "and": "et",
      "or": "ou",
      "minimumMustBeBetween": "Le minimum doit être compris entre",
      "upgradeToAgencyPro": "passez à Agency Pro",
      "planToSetMargins": "planifier la fixation des marges"
    },
    "m": "m",
    "label": "Étiquette",
    "company_email_": "Courriel de l’entreprise (",
    "me_": "Moi (",
    "automation_type": "Type d’automatisation",
    "calendar_groups": "Groupes de calendriers",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "Aucun produit n'est disponible",
    "selectProduct": "Sélectionnez un produit"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Les messages {product} supplémentaires ne seront pas facturés pour ces emplacements. Pour refacturer le client, veuillez activer le mode SaaS et la fonction de refacturation.",
      "agreementPrefix": "J'accepte d'activer",
      "agreementSuffix": "pour ce client sans revendre et je reconnais que je serai facturé",
      "buildResellerOffer": "Créer votre offre de revente.",
      "deployDirectlyDescription": "Utilisez cette option si vous proposez {product} dans le cadre de votre offre ou si vous souhaitez facturer votre client à l'externe.",
      "deployPrefix": "Déployer",
      "directlySuffix": "Directement",
      "learnMore": "En savoir plus.",
      "offerPrefix": "Offre",
      "resellPrefix": "Revendre",
      "resellingPrefix": "Revente",
      "subscriptionRestriction": "Impossible de faire un changement de réglages car l'emplacement est déjà abonné.",
      "zero": "0",
      "highlevelPrice": "Prix HighLevel",
      "howDoesItWork": "Comment ça fonctionne?",
      "payNowButton": "Payer maintenant",
      "priceValidationError": "Le prix doit être supérieur ou égal au prix HighLevel.",
      "saving": "Sauvegarde en cours",
      "yourPrice": "Votre prix",
      "yourProfit": "Votre marge"
    },
    "whatsapp": {
      "inboundMessagesInfo": "La réception des messages entrants et les réponses via un texte libre dans la fenêtre de conversation sont gratuits. Il y aura des frais supplémentaires de passage pour les messages modèles sortants s’ils sont envoyés.",
      "whatsappLocation": "Emplacement WhatsApp"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Impossible d'opérer un changement de configuration, car l'emplacement est déjà abonné.",
        "offerPrefix": "Offre ",
        "poweredByPrefix": " (Propulsé par Search Atlas)",
        "toggleTooltipDisable": "Cette action désactivera l'outil SEO pour tous les sous-comptes.",
        "toggleTooltipEnable": "Cette action activera l'outil SEO pour tous les sous-comptes.",
        "resellPrefix": "Revendre ",
        "howDoesItWork": "Comment ça fonctionne?",
        "buildResellerOffer": "Créez votre offre de revente.",
        "yourPrice": "Votre prix",
        "highlevelPrice": "Prix HighLevel",
        "yourProfit": "Votre marge",
        "priceValidationError": "Le prix doit être supérieur ou égal au prix HighLevel.",
        "saving": "Sauvegarde en cours",
        "save": "Enregistrer",
        "deployPrefix": "Déployer ",
        "directlySuffix": "Directement",
        "deployDirectlyDescription": "Utilisez cette option si vous proposez un SEO dans le cadre de votre offre ou si vous souhaitez facturer votre client à l'externe.",
        "agreementPrefix": "J'accepte d'activer ",
        "agreementSuffix": " pour ce client sans revendre et je reconnais que je serai facturé(e).",
        "payNowButton": "Payer maintenant",
        "subscriptionCreating": "L'abonnement est en cours de création.<br/>Veuillez ne pas recharger et ne pas appuyer sur le bouton retour",
        "subscriptionCreated": "L'abonnement a bien été créé. Veuillez patienter…",
        "subscriptionError": "Impossible de créer un abonnement, veuillez communiquer avec le service d'assistance."
      },
      "adManager": {
        "subscriptionRestriction": "Impossible de modifier la configuration car l'emplacement est déjà abonné",
        "offerPrefix": "Offre ",
        "resellingPrefix": "Revente",
        "resellPrefix": "Revendre ",
        "howDoesItWork": "Comment ça fonctionne?",
        "bookACall": "Planifier un appel",
        "bookCallTooltip": "Planifiez un appel avec notre équipe pour en savoir plus sur Ad Manager.",
        "buildResellerOffer": "Créez votre offre de revente.",
        "yourPrice": "Votre prix",
        "highlevelPrice": "Prix HighLevel",
        "yourProfit": "Votre profit",
        "priceValidationError": "Le prix doit être supérieur ou égal au prix HighLevel.",
        "loading": "Chargement….",
        "save": "Enregistrer",
        "deployPrefix": "Déployer ",
        "directlySuffix": "Directement",
        "deployDirectlyDescription": "Utilisez cette option si vous proposez Gestionnaire d'annonces dans le cadre de votre offre ou si vous souhaitez facturer votre client à l'externe",
        "agreementPrefix": "J'accepte d'activer ",
        "agreementMiddle": " pour ce client sans revente et je reconnais que je serai facturé(e)",
        "agreementSuffix": " par mois",
        "stripeNotConnectedLocationWarning": "Stripe n'est pas connecté pour cet emplacement. Veuillez connecter Stripe pour activer cette fonctionnalité.",
        "stripeNotConnectedAgencyWarning": "Stripe n'est pas connecté pour cette agence. Veuillez connecter Stripe pour activer cette fonctionnalité.",
        "underSubAccountReselling": "par mois dans le cadre de la revente de sous-compte"
      },
      "dedicatedIp": {
        "description": "Cela vous permet de refacturer l'IP dédiée (utilisée pour l'envoi de courriels sortants) à vos clients et d'inclure une majoration.",
        "numberOfIps": "Nombre d'IP :",
        "yourCost": "Votre coût :",
        "chargedToCustomer": "Facturé au client :",
        "profit": "Marge :",
        "monthlyProfit": "Bénéfice mensuel :",
        "loading": "Chargement en cours…",
        "save": "Enregistrer",
        "revokeDedication": "Révoquer l'affectation",
        "revokeDescription": "Utilisez cette option pour arrêter d'offrir de nouvelles adresses IP dédiées à vos clients sans les facturer",
        "existingSubscriptionsNote": "Les abonnements IP actuels ne seront pas affectés.",
        "revoke": "Révoquer",
        "provideDirectlyTitle": "Fournir directement une adresse IP dédiée aux courriels",
        "provideDirectlyDescription": "Utilisez cette option pour donner une adresse IP dédiée à votre client sans le facturer.",
        "agreeToProvideText": "J'accepte d'offrir une adresse IP à ce client sans vente incitative.",
        "acknowledgeChargeText": "Je reconnais que mon compte sera facturé 59 $/mois/IP.",
        "agree": "J'accepte",
        "yourMonthlyCost": "Votre coût IP mensuel :",
        "monthlyChargeToCustomer": "Facturation mensuelle au client :",
        "resellingSettingsSuffix": " Paramètres de revente",
        "ipRebillingAmount": "Montant de la refacturation IP"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "J’enregistre que j’en ai discuté avec mon client et que j’ai obtenu leur approbation.",
        "confirmQuestion": "Voulez-vous vraiment désactiver le mode SaaS pour ce compte?",
        "dataLossAck": "Je reconnais que toutes les données de refacturation, les données d'abonnement SaaS et le registre des transactions seront perdues.",
        "disableSaas": "Désactiver SaaS",
        "irreversibleAck": "Je comprends que cette action est irréversible."
      },
      "confirmationModal": {
        "cancelSubscription": "Annuler également l'abonnement SaaS associé",
        "confirmDisable": "Confirmer la désactivation",
        "confirmQuestion": "Êtes-vous sûr de vouloir désactiver le mode SaaS?",
        "somethingWentWrong": "Une erreur s'est produite... Veuillez réessayer plus tard."
      },
      "processingModal": {
        "closeNow": "Fermer maintenant",
        "closeWindowInstructions": "Vous pouvez fermer cette fenêtre, nous vous informerons par courrier électronique lorsque le processus sera terminé.",
        "title": "Le SaaS sera bientôt désactivé pour cet emplacement.",
        "typicalTime": "Cela prend généralement 10 minutes ou moins."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Ajouter un champ personnalisé",
      "fieldKey": "Clé de champ",
      "fieldName": "Nom du champ",
      "idWillBeAdded": "L’ID sera ajouté après la création du motif de perte",
      "lostReasonID": "Id de la raison de la perte",
      "placeholder": "Substitut"
    },
    "locationMailGun": {
      "bccAddress": "Adresse BCC",
      "clearError": "Erreur claire",
      "deleteConfirmationMessage": "Cette action supprimera la connexion Mailgun.",
      "deleteConnection": "Supprimez la connexion",
      "domain": "Domaine",
      "domainsAvailable": "{count} disponible",
      "invalidApiKey": "Clé API invalide",
      "selectDomain": "Sélectionner un domaine"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Erreur lors de la récupération des détails de la transaction",
      "transactions": "Transactions"
    },
    "noShowSMS": {
      "smsWithImage": "SMS sans affichage avec image",
      "title": "Personnaliser le SMS d’évaluation"
    },
    "optOut": {
      "addKeywords": "Veuillez inclure l'un des mots-clés de désinscription suivants : ARRÊT, ARRÊTER, DÉSABONNER, ANNULER, FIN ou QUITTER.",
      "customizeTitle": "Personnaliser le message de désabonnement",
      "disableConfirm": "Êtes-vous sûr de vouloir désactiver le message de désinscription?",
      "disableOptOut": "Désactiver l'option de désabonnement",
      "disableTitle": "Désactiver le message de désinscription?",
      "optInConfirmClient": "Je confirme que je veillerai à ce que les SMS ne soient envoyés qu'aux contacts qui ont opté pour cette option.",
      "quickTipMessage": "Le message initial que vous envoyez à un individu doit inclure l'un des mots-clés de désinscription standard suivants : ARRÊT, ARRÊTER, DÉSABONNER, ANNULER, FIN ou QUITTER.",
      "reallyDisableConfirm": "Êtes-vous vraiment sûr de vouloir désactiver le message de désinscription?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "Corps de la requête POST",
        "requestQueryParameters": "Demander les paramètres de la requête",
        "responseBody": "Corps de la réponse"
      },
      "logs": "Journaux",
      "logsPage": {
        "clearAll": "Tout effacer",
        "loadMore": "En savoir plus",
        "price": "Prix",
        "product": "Produit",
        "tabsAriaLabel": "Onglets des journaux de paiement"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Ajoutez un texte général à",
      "beginning": "Commencement",
      "complianceConfirm": "Je confirme que je veillerai à ce que tous les messages SMS envoyés à partir de ce compte soient conformes à la politique actuelle",
      "customizeTitle": "Personnaliser le texte général",
      "disableConfirm": "Voulez-vous vraiment désactiver SenderID?",
      "disableSenderID": "Désactiver SenderID",
      "disableTitle": "Désactiver SenderID ?",
      "end": "Fin",
      "pleaseAdd": "Veuillez Inclure {text} comme mentionné dans l'astuce rapide.",
      "quickTipMessage": "Le message initial que vous envoyez à un individu doit inclure les informations d'identification de l'expéditeur. Veuillez ajouter {text} dans la boîte de texte générale.",
      "reallyDisableConfirm": "Voulez-vous vraiment désactiver SenderID?",
      "senderID": "ID de l'expéditeur"
    },
    "shopify": {
      "adminApiAccessToken": "Jeton d'accès à l'API d'administration",
      "apiTokenRequired": "Jeton d'accès API requis",
      "checkDocumentation": "Veuillez consulter cette documentation pour plus d'informations",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Jeton d'accès à l'API de l'application personnalisée",
      "deleteWarning": "La suppression de ceci supprimera la connexion actuelle.",
      "existStoreAlertTitle": "L'intégration de la boutique Shopify existe déjà",
      "integration": "Intégration Shopify",
      "integrationHealth": "Santé de l'intégration",
      "orders": "Commandes",
      "scopePermissionsWarning": "Veuillez vous assurer que votre application dispose des autorisations marquées d'une croix rouge",
      "scopes": "Portées",
      "scopesDescription": "Des autorisations sont nécessaires pour accéder aux informations Shopify. En raison des récentes modifications apportées à Shopify, la fonction read_customers est désormais nécessaire pour obtenir toutes les informations des clients, car les données clients sont protégées par Shopify.",
      "storeConnectedMessage": "La boutique Shopify est déjà connectée à un sous-compte {locationName}",
      "storeNameHelp": "Le nom de votre magasin se trouve à l’URL de votre compte Shopify -- après le https:// et avant .myshopify.",
      "storeNameLabel": "Nom de votre magasin Shopify",
      "storeNamePlaceholder": "nom du magasin",
      "storeNameRequired": "Le nom du magasin est obligatoire",
      "typeRemoveConfirm": "Tapez « REMOVE » pour confirmer",
      "webhooks": "Webhooks",
      "webhooksDescription": "Pour recevoir tous les événements provenant de Shopify, nous devons enregistrer ces webhooks Shopify pendant le processus d'intégration. Ces webhooks sont essentiels pour garantir le bon fonctionnement des fonctionnalités Shopify."
    },
    "slack": {
      "accountConnected": "compte connecté",
      "accountsConnected": "comptes connectés",
      "accountsList": "Liste de tous les comptes Slack",
      "added": "Ajouté {date}",
      "connectChannel": "Connectez votre canal Slack",
      "description": "Recevez des notifications instantanées sur votre canal Slack. Cliquez sur « Connecter » pour ajouter un canal Slack.",
      "manage": "Gérer",
      "manageAccounts": "Gérer les comptes Slack",
      "noIntegrations": "Aucune intégration Slack n'a été trouvée."
    },
    "smtpService": {
      "addFirstService": "Ajoutez votre premier service SMTP.",
      "addService": "Ajouter un service",
      "bccEmails": "Courriels BCC",
      "cannotDeleteDefaultProvider": "Vous ne pouvez pas supprimer le fournisseur par défaut.",
      "contactDeveloper": "Contactez le développeur de cette application.",
      "customProvider": "Fournisseur personnalisé",
      "defaultProvider": "Fournisseur par défaut",
      "defaultProviderUpdated": "Mise à jour du fournisseur par défaut avec succès!",
      "emailDomain": "Courriel / Domaine",
      "emailService": "Service de COURRIEL",
      "enableReplyTracking": "Activer le suivi des réponses",
      "forwardToAssignedUser": "Renvoyer à l'utilisateur assigné",
      "providerType": "Type de fournisseur",
      "smtpConnectionIssue": "Il y a un problème avec cette connexion SMTP. Veuillez reconnecter cette intégration.",
      "useLcEmailMessage": "Utilisez LC Email pour envoyer des courriels à votre agence et à vos clients."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Publication automatique activée",
      "dailyPostLimit": "Limite quotidienne de publications",
      "directoriesDescription": "Lorsque vous recevez un nouvel avis, nous le publions automatiquement sur plus de 80 annuaires en ligne qui contribuent automatiquement à développer votre marque et votre référencement.",
      "directoriesTitle": "80+ annuaires et sites Web",
      "fivePosts": "5 publications",
      "fiveStars": "5 étoiles",
      "fourPosts": "4 publications",
      "fourStars": "4 étoiles",
      "googlePlus": "Google +",
      "manageSettingsDescription": "Personnalisez la manière et le moment où vos avis sont automatiquement publiés sur chacun de vos réseaux sociaux.",
      "manageSettingsTitle": "Gérez vos paramètres de publication sur les réseaux sociaux",
      "postReviewsForRating": "Publiez des avis pour cette note d’étoiles ou plus.",
      "searchEngines": "Moteurs de recherche",
      "threePosts": "3 publications",
      "threeStars": "3 étoiles",
      "title": "Publication sur les réseaux sociaux"
    },
    "tags": {
      "addNewTag": "Ajouter une nouvelle étiquette",
      "allTags": "Toutes les étiquettes",
      "deletedTags": "Étiquettes supprimées",
      "here": "ici.",
      "newTag": "Nouvelle étiquette",
      "noTagsYet": "Aucune étiquette à afficher pour le moment",
      "searchTags": "Rechercher des étiquettes",
      "viewDeletedTags": "Vous pouvez afficher et restaurer les étiquettes supprimées sur la page Journaux d'audit"
    },
    "templateMessage": {
      "addEmailTemplate": "Ajouter un modèle de courriel (Extrait)",
      "addTemplate": "Ajouter un modèle (Extrait)",
      "addTextTemplate": "Ajouter un modèle de texte (Extrait)",
      "body": "Corps",
      "deleteTemplateConfirmation": "Voulez-vous vraiment supprimer ce modèle?",
      "templatesCount": "{count} modèles",
      "title": "Modèles de message (Extraits)"
    },
    "unsubscribe": {
      "content": "Contenu",
      "contentTooltip": "Le contenu de ce message sera automatiquement ajouté à tous les courriels.",
      "customizeTitle": "Personnaliser le contenu de désabonnement",
      "disableConfirm": "Êtes-vous certain de vouloir désactiver le lien de désabonnement du courriel?",
      "disableTitle": "Désactiver le lien de désabonnement?",
      "disableUnsubscribe": "Désactiver la fonction de désabonnement",
      "pleaseAddTag": "Veuillez ajouter la balise /*désabonner*/",
      "reallyDisableConfirm": "Êtes-vous vraiment certain de vouloir désactiver le lien de désabonnement du courriel?",
      "subscribedConfirm": "Je confirme que les courriels ne seront envoyés qu'aux contacts qui se sont abonnés pour recevoir des courriels.",
      "subscribedConfirmClient": "Je confirme que je veillerai à ce que les courriels ne soient envoyés qu'aux contacts qui se sont abonnés pour recevoir des courriels.",
      "suspensionWarning": "Toute activité non conforme peut entraîner la suspension des fonctions de courriel de votre compte.",
      "tagRequirement": "Le courriel initial que vous envoyez à un individu doit inclure la balise /*désabonné*/"
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "C’est le message vocal par défaut pour tous les numéros Twilio à cet emplacement, sauf s'il est personnalisé sous",
      "forwardCallsToWebApp": "Transférer les appels vers une application Web",
      "forwardCallsToMobileApp": "Transférer les appels vers une application mobile",
      "dedicatedNumberRequiredInfo": "Ceci n'est nécessaire que si l'utilisateur a besoin d'un numéro dédié. Ce n'est pas requis pour la messagerie vocale ou pour l'acheminement de l'appel vers l'utilisateur assigné.",
      "voicemailMessageInfo": "Ce message vocal sera diffusé à la place de celui de l'opérateur téléphonique. Nous recommandons un délai d'attente de 20 secondes ou moins.",
      "noTimeout": "Aucun délai d'attente",
      "10Secs": "10 secondes",
      "20Secs": "20 secondes",
      "voicemailMessageDuration": " Nous enregistrerons un message vocal si l'appel n'est pas pris avant ce délai.",
      "saveCallSettings": "Enregistrer les paramètres d'appel"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "Lorsque cette balise est présente sur le contact, ces messages ne seront PAS envoyés à Eliza.",
      "sendToElizaNote": "Par défaut, toutes les conversations seront livrées à Eliza. Si cette balise est configurée, <br />alors les nouvelles conversations seront envoyées à Eliza, seulement lorsque cette balise est présente sur un contact.<br /> Si les balises de contournement d'Eliza et d'envoi à Eliza sont configurées, alors seule la balise d'envoi à Eliza sera prise en compte.",
      "permissionNote": "Vos autorisations utilisateur ne sont pas activées pour cette page. <br />Veuillez parler à votre administrateur.",
      "addFAQ": "Ajouter une FAQ"
    },
    "locationSettings": {
      "ownCardWarning": "N’ajoutez pas votre propre carte aux sous-comptes !",
      "addClientCardWarning": "Veuillez ajouter la carte de votre client (sous-compte) et non la vôtre, car cette carte sera utilisée pour facturer votre client en votre nom.",
      "stripeConnectMissing": "Connexion Stripe manquante",
      "pleaseContactAgencyToAddPaymentMethods": "Veuillez contacter l’agence ({email}) pour ajouter des méthodes de paiement"
    },
    "integrations": {
      "connectWaveAccount": "Connectez le compte Wave de votre emplacement",
      "connectXeroAccount": "Connectez le compte Xero de votre emplacement"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "Le suivi des appels GBP est activé sur un autre sous-compte. Le suivi des appels peut être activé sur un seul sous-compte à la fois.",
      "gbpCallTrackingEnabledOnAnotherPage": "Le suivi des appels GBP est activé sur une autre page ({pageName}). Le suivi des appels peut être activé sur un seul sous-compte et une seule page par emplacement à la fois.",
      "gbpCallsProperlySetup": "Les appels GBP sont correctement configurés et les appels arrivent de",
      "tooManyEditsToPrimaryPhone": "Vous avez effectué trop de modifications sur le téléphone principal de cette entreprise. Veuillez réessayer plus tard.",
      "setupTwilioToStartCallTracking": "Configurez Twilio pour commencer le suivi des appels",
      "twoSecondaryNumbersSetupAlready": "Vous avez déjà configuré deux numéros secondaires, vous ne pouvez pas échanger le numéro",
      "yourAgentIDIs": "Votre identifiant d'agent est"
    },
    "numberPool": {
      "title": "Quoi suivre",
      "tracking": {
        "percentComplete": "34 % terminé",
        "searchLower": "rechercher"
      },
      "create": {
        "title": "Créer un numéro de suivi"
      }
    },
    "phoneNumbers": {
      "title": "Quoi suivre",
      "tracking": {
        "percentComplete": "34 % complété",
        "heading": "Créer un numéro de suivi"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Entrer une valeur",
      "selectOption": "* Sélectionner une option"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* Vous devez sélectionner au moins un {filterName}",
      "select": "Sélectionner {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "Horodatage"
    },
    "recordsNav": {
      "clickToReloadList": "Cliquer pour rafraîchir la liste"
    },
    "reviewRequestActions": {
      "emailReviewReq": "Demande de rétroaction par courriel",
      "smsReviewReq": "Demande de rétroaction par SMS",
      "whatsappReviewReq": "Demande de rétroaction par WhatsApp"
    },
    "smartListFilters": {
      "clearAllFilters": "Effacer tous les filtres",
      "noneFound": "aucun résultat trouvé",
      "saveChangesToList": "Enregistrer les modifications de filtre dans cette liste intelligente",
      "saveCombinationAsNew": "Sauvegarder la combinaison de filtres, colonnes et tri comme nouvelle liste intelligente",
      "saveCurrentAsNew": "Enregistrer les filtres actuels en tant que nouvelle liste intelligente",
      "searchAndAddFilter": "Rechercher et ajouter un filtre",
      "searching": "Recherche en cours...",
      "undoUnsavedChanges": "Annuler les modifications non enregistrées"
    },
    "smsStatsPanel": {
      "smsStats": "Statistiques SMS"
    },
    "manageDuplicates": "Gérer les doublons",
    "emailAction": {
      "attachFiles": "Joindre des fichiers",
      "customValues": "Valeurs personnalisées",
      "triggerLinks": "Liens de déclenchement"
    },
    "atLeastOneRequired": "* Au moins un {filterName} est requis",
    "arrayInput": {
      "searchPlaceholder": "Rechercher {filterName}",
      "searching": "Recherche en cours…."
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Une erreur s'est produite lors de la récupération des contenus de l'instantané.",
      "overwriteAll": "Remplacer tout",
      "skipAll": "Ignorer tout",
      "somethingWentWrongWhileFindingConflicts": "Une erreur s'est produite lors de la recherche de conflits.",
      "step": "Étape"
    },
    "confirmOverwrite": {
      "confirmButton": "Enregistrer la réécriture",
      "description": "Cette action est irréversible et peut convertir les réglages des campagnes, des pistes, des entonnoirs, etc. Veuillez enregistrer votre action en tapant ce qui suit dans le champ de saisie.",
      "title": "Voulez-vous vraiment écraser les données sélectionnées?"
    },
    "conflicts": {
      "noConflictsDetected": "Aucun conflit détecté",
      "overwrite": "Remplacer"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Ressources trouvées liées",
      "checkingConflicts": "Vérification des conflits",
      "chooseSnapshot": "Sélectionnez un instantané.",
      "copyingDataNotification": "Copie des données vers des emplacements sélectionnés. Veuillez patienter…",
      "linkedLocations": "Emplacements connectés",
      "noConflictsFound": "Aucun conflit trouvé",
      "notAuthorizedMessage": "Seuls les administrateurs de l'agence peuvent effectuer cette action.",
      "overwriteConflicts": "Conflits d'écrasement",
      "pickSnapshot": "Choisissez un instantané.",
      "response": "Réponse",
      "selectAssetsToPush": "Sélectionnez les ressources à transmettre.",
      "selectLocationsToUpdate": "Sélectionnez les emplacements à mettre à jour.",
      "snapshotNotAuthorized": "Cet instantané n'est pas autorisé pour cet emplacement",
      "snapshotNotSelected": "Instantané non sélectionné"
    },
    "share": {
      "agencyRestrictedLink": "Lien privé de l'agence",
      "deleteShareLink": "Supprimer le lien de partage",
      "editShareLink": "Modifier le lien de partage",
      "permanentLink": "Lien permanent",
      "subaccountRestrictedLink": "Lien privé du sous-compte"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Ajoutez une virgule (<span class='text-base font-bold'> , </span>) après chaque numéro de relation)",
      "addCommaAfterEachSubAccount": "(Ajoutez une virgule (<span class='text-base font-bold'> , </span>) après chaque id de sous-compte)",
      "atLeast1EmailRequired": "Au moins un courriel est obligatoire.",
      "emailShareLink": "Lien de partage par courriel",
      "enterOnePerLine": "(en saisir un par ligne)",
      "errorGettingLink": "Une erreur s'est produite lors de l'obtention du lien. Veuillez réessayer plus tard!",
      "getAgencyRestrictedLink": "Obtenir un lien privé de l'agence",
      "getLink": "Obtenir le lien",
      "getOneTimeLink": "Obtenir un lien de partage unique",
      "getPermanentLink": "Obtenir un lien permanent",
      "getSubAccountRestrictedLink": "Obtenir un lien privé du sous-compte",
      "shareType": "Type de partage",
      "title": "Partager l'instantané"
    },
    "snapshot": {
      "copySnapshotID": "Copier l'id de l'instantané",
      "deleteSnapshot": "Supprimez l'instantané",
      "editSnapshot": "Modifier l'instantané",
      "pushUpdate": "Mise à jour automatique vers les comptes liés",
      "refreshSnapshot": "Rafraîchir l'instantané"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(Ajoutez une virgule après chaque numéro de relation)",
      "addCommaAfterEachSubAccount": "(Ajoutez une virgule après chaque id de sous-compte)",
      "title": "Lien de partage mis à jour"
    }
  },
  "socialMedia": {
    "engagement": "Engagement",
    "potentialReach": "Portée Potentielle",
    "storiesCreated": "Histoires Créées",
    "recentPosts": "Articles récents",
    "notConnected": "Non connecté (Connectez-vous maintenant!)",
    "totalAudience": "Audience Totale",
    "activeAudience": "Audience Active",
    "socialMediaOverview": "Aperçu des Médias Sociaux"
  },
  "suspendModal": {
    "currentStatus": "État actuel de l’abonnement : En pause",
    "instructions": "Vous devez finir quelques étapes simples pour {action} ce sous-compte",
    "nextBillingDate": "Prochaine date de facturation :",
    "noKeepCharging": "Non, continuez à facturer le client.",
    "pauseSubscriptionQuestion": "Voulez-vous aussi mettre l'abonnement en attente avec le Sous-compte?",
    "resumeSubAccount": "Reprendre le sous-compte",
    "resuming": "Reprendre...",
    "saasSubscriptionActive": "Ce sous-compte dispose d’un abonnement SaaS actif.",
    "saasSubscriptionResumed": "L'abonnement SaaS de ce compte sera réactivé.",
    "yesPause": "Oui, suspendre l'abonnement"
  },
  "table": {
    "perPageOptions": {
      "5": "5 par page",
      "10": "10 par page",
      "15": "15 par page",
      "20": "20 par page",
      "25": "25 par page",
      "50": "50 par page",
      "100": "100 par page"
    },
    "filterPlaceholder": "Recherche en cours…",
    "emptyText": "Aucun enregistrement trouvé",
    "loading": "Chargement…",
    "showingEntries": "Afficher les entrées {from} à {to} sur {total}",
    "noEntriesToShow": "Aucune entrée à afficher"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Chargement des données de compte…",
      "toContinueWith": "pour continuer avec"
    },
    "switcherModal": {
      "comingSoon": "Bientôt disponible!",
      "multiLocationMessage": "Cette fonctionnalité est actuellement disponible uniquement pour des comptes individuels. Nous travaillons fort pour rendre cela bientôt disponible pour les comptes multi-emplacements."
    },
    "importedMessage": "{productName} importé! Accédez à la bibliothèque de modèles et trouvez-le sous l'onglet {productName}.",
    "permissionErrorMsg": "Cette option n'est offerte que sur les forfaits supérieurs. Passez à un forfait supérieur maintenant pour la débloquer.",
    "errors": {
      "sourceDeleted": "Erreur : le modèle source a été supprimé. Il n'est plus disponible. Veuillez vérifier le statut du modèle ou communiquer avec sa source pour obtenir de l'aide.",
      "sourceDraft": "Erreur : le modèle source a été déplacé vers les ébauches. Veuillez vérifier le statut du modèle ou communiquer avec sa source pour obtenir de l'aide.",
      "linkedDeleted": "Erreur : le modèle source, lié au modèle partagé, a été supprimé. Veuillez vérifier le statut du modèle ou communiquer avec sa source pour obtenir de l'aide.",
      "fetchError": "Une erreur semble se produire lors de l'obtention des détails de {productName}. Veuillez vérifier l’URL ou réessayer!",
      "sameAgency": "Impossible de partager le modèle au sein de la même agence"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "L'action d'ajout d'une étiquette de contact nécessite une étiquette.",
    "addNotesRequiresData": "L'action Ajouter des notes nécessite des données de notes.",
    "addTaskRequiresFields": "L'action d'ajouter une tâche nécessite un titre et une date d'échéance.",
    "addToCampaignRequiresCampaign": "L'action Ajouter à la campagne nécessite une campagne.",
    "addToCustomAudienceRequires": "L'action d'ajout à l'audience personnalisée nécessite un compte publicitaire et une audience personnalisée.",
    "addTrigger": "Ajouter un déclencheur",
    "anyAction": "N’importe quelle action",
    "anyCondition": "N’importe quelle condition",
    "brokenCustomVariables": "Certains champs contiennent des variables personnalisées défectueuses, veuillez les corriger avant de sauvegarder.",
    "conditionCannotBeEmpty": "La condition « {condition} » ne peut pas être vide",
    "confirmDeleteTrigger": "Êtes-vous sûr de vouloir supprimer ce déclencheur?",
    "customDateFieldRequired": "Un filtre de champ de date personnalisé est obligatoire pour le déclencheur de rappel de date personnalisé",
    "detailPage": {
      "chooseTriggerPlaceholder": "Choisissez un déclencheur",
      "lastUpdate": "Dernière mise à jour :",
      "loopIdentifiedWarning": "Ce déclencheur a été verrouillé au statut « Brouillon » car il provoque une boucle. Pour activer ce déclencheur, veuillez contacter le support.",
      "ruleNotActiveWarning": "Cette règle ne s’exécutera pas tant que vous ne l’aurez pas activée.",
      "triggerCreation": "Création de déclencheur :",
      "triggerDeletedPrompt": "Ce déclencheur a été supprimé! Souhaitez-vous le restaurer?",
      "triggerRunDailyTooltip": "Déclencheur exécuté à 8 h 00 AM tous les jours",
      "whatTriggersRule": "Qu'est-ce qui devrait déclencher cette règle?",
      "whichEventTriggersAutomation": "Quel événement devrait déclencher cette automatisation?"
    },
    "dndContactRequiresState": "L'action de contact DND nécessite que l'état DND soit défini.",
    "emptyConditionNotAllowed": "La condition vide n'est pas autorisé.",
    "emptyFieldNotAllowed": "Les champs vides ne sont pas autorisés.",
    "executeWebhookRequiresUrl": "L'action d'exécution du webhook nécessite une URL webhook.",
    "fieldCannotBeEmpty": "{field} ne peut pas être vide",
    "fillRequiredFields": "Veuillez remplir tous les champs obligatoires dans les actions.",
    "googleAdwordsRequiresConversion": "L’action Ajouter à Google Adwords nécessite une conversion.",
    "googleAnalyticsRequiresFields": "L'action d'ajout à Google Analytics nécessite un Id de suivi, un type d’action et une catégorie d’action",
    "membershipGrantOfferRequiresOffer": "L’action d’offre de subvention d’adhésion nécessite une offre.",
    "membershipRemoveOfferRequiresOffer": "L'action de suppression de l'adhésion nécessite une offre.",
    "newBasicRule": "Nouvelle règle de base",
    "opportunitiesRequirePipeline": "Les actions liées aux opportunités nécessitent que vous sélectionniez un flux.",
    "opportunityLoopWarning": "Ce déclencheur provoquera une boucle de création d’opportunités. Veuillez supprimer l'option « Autoriser les opportunités en double » ou modifier l'étape à laquelle vous faites référence.",
    "removeContactTagRequiresTag": "L'action de suppression d'une étiquette de contact nécessite une étiquette.",
    "removeFromCampaignRequiresCampaign": "L'action de suppression de la campagne nécessite une campagne.",
    "removeFromCustomAudienceRequires": "L'action de suppression d'une audience personnalisée nécessite un compte publicitaire et une audience personnalisée.",
    "rulesBasedOn": "règles basées sur",
    "selectUserForNotification": "Sélectionnez l'utilisateur pour envoyer la notification.",
    "sendEmailRequiresFields": "L’action d’envoyer un courriel nécessite les champs de, vers, l’objet et le message.",
    "sendNotificationRequiresFields": "L'action d'envoi de notification nécessite un titre, un corps et le type d'utilisateur pour envoyer la notification.",
    "sendSmsRequiresFields": "L'action d'envoyer un SMS nécessite un numéro et un message.",
    "stripeMinAmountUSD": "Le montant doit être supérieur ou égal à 50 cents USD.",
    "stripeRequiresFields": "L'action de facturation unique de Stripe nécessite l'Id du client, le montant et la devise",
    "thatWillFire": "qui va se déclencher",
    "triggerCannotBeEmpty": "Le déclencheur ne peut pas être vide",
    "updateContactFieldRequires": "Le champ « Mettre à jour les coordonnées » doit comporter au moins un champ défini."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Payez ${amount} et abonnez-vous.",
      "commitment": "Pas d’engagement, annulez à tout moment",
      "features": {
        "billedOnUsage": "Facturé en fonction de l'utilisation après dépassement de la limite.",
        "externalAI": "Exclut les activités du modèle d'IA externe, qui seront facturées séparément",
        "leadingPricing": "Des prix de premier plan dans l’industrie.",
        "monthlyPurchase": "Valable pour un achat par mois",
        "premiumActions": "S'applique aux activités et déclencheurs premium"
      },
      "planDetails": "Détails du forfait",
      "subscribeAndSave": "Abonnez-vous et économisez dès aujourd’hui!",
      "title": "${amount} pour {executions} exécutions par mois."
    }
  },
  "appointmentWidget": {
    "movedMessage": "Ce paramètre a été déplacé vers la page des calendriers.",
    "toNavigate": "ici pour naviguer. Cette page sera supprimée bientôt."
  },
  "attribution": {
    "description": "La première interaction est simplement le premier point de contact d'un utilisateur. Ainsi, si quelqu'un vous découvre d'abord via une publicité payante (PPC), ce canal recevra le crédit pour une conversion. De son côté, la dernière interaction est le dernier canal.",
    "firstInteraction": "Première interaction",
    "lastInteraction": "Dernière interaction",
    "title": "Attribution"
  },
  "campaign": {
    "addEvent": "Ajouter un événement",
    "a2p": {
      "address": {
        "chooseState": "Sélectionnez un État...",
        "city": "Ville*",
        "postalCode": "Code postal*",
        "streetAddress": "Adresse civique*",
        "streetAddressHelper": "Il doit s'agir d'une adresse valide liée à votre entreprise.",
        "title": "Adresse de l'entreprise"
      },
      "addressError": {
        "title": "La soumission de l'adresse a échoué."
      },
      "authorizedRep": {
        "jobPosition": "Poste*",
        "jobTitle": "Titre du poste*",
        "title": "Détails du représentant autorisé"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Marque à propriétaire unique",
          "point1": "Un seul numéro de téléphone est autorisé",
          "point2": "EIN/SSN/DUNS non obligatoire"
        },
        "solePropCampaign": {
          "heading": "Campagne de propriétaire unique",
          "point1": "Un seul numéro peut être associé à une campagne Sole Prop",
          "point2": "Une fois approuvé, votre numéro par défaut sera lié automatiquement.",
          "infoText": "Vous pouvez également mettre à jour le numéro après l'approbation",
          "warningText": "Un seul numéro peut être associé à une campagne de propriétaire unique. Une fois approuvé, votre numéro par défaut sera automatiquement associé. Vous pouvez également mettre à jour le numéro après approbation."
        },
        "solePropSubtitle": "Détails de la marque et de la campagne de propriétaire unique",
        "standardBrand": {
          "heading": "4,41 $ – une seule fois",
          "point1": "EIN/SSN/DUNS obligatoire",
          "point2": "Plus d'un numéro de téléphone autorisé"
        },
        "standardCampaign": {
          "heading": "16,54 $ – une seule fois",
          "point1": "Plus d'un numéro est autorisé à être lié à une campagne standard.",
          "point2": "EIN/SSN/DUNS obligatoire",
          "infoText": "Des frais supplémentaires pouvant aller jusqu'à 12 $ par mois s'appliqueront conformément aux règles du TCR."
        },
        "standardSubtitle": "Détails standards de la marque et de la campagne",
        "title": "Détails de la marque et de la campagne"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Coordonnées",
          "contactInfoSubtitle": "Cela peut être toute personne qui peut répondre à des questions sur cette marque, si nécessaire. Veuillez noter que vous ne pouvez pas réutiliser les mêmes coordonnées pour plusieurs marques. Chaque marque que vous créez doit avoir des coordonnées uniques.",
          "emailHelper": "N’utilisez pas le même courriel pour plus de cinq marques.",
          "phoneNumberHelper": "N'utilisez pas le même numéro de téléphone pour plus de 5 marques.",
          "profileName": "Nom de l’entreprise ou votre prénom et nom de famille*",
          "profileNameHelper": "Utilisez soit le nom légal de l’organisation qui envoie les messages, soit votre propre nom si cette marque n’est pas pour une organisation.",
          "nextLoading": "Suivant...",
          "invalidPhoneNumber": "Numéro de téléphone non valide",
          "phoneNumberWithCountryCode": "Numéro de téléphone (avec indicatif de pays)*",
          "phoneNumberRequired": "Le numéro de téléphone est obligatoire.",
          "emailRequired": "Le courriel est obligatoire.",
          "profileNameRequired": "Le nom du profil est obligatoire."
        },
        "standard": {
          "businessType": "Type d'entreprise*",
          "legalBusinessName": "Nom légal de l’entreprise*",
          "legalBusinessNameHelper": "Saisissez le nom exact de l'entreprise, tel qu'il est enregistré auprès du gouvernement et mentionné dans vos documents fiscaux (CP 575). P. ex., Leadconnector LLC plutôt que Leadconnector.",
          "regionsOfOperations": "Régions d'activité*",
          "registrationNumber": "Numéro d'enregistrement de l'entreprise*",
          "registrationNumberHelper": "Le numéro utilisé pour identifier votre entreprise. Dans le cas d'un numéro EIN américain, il doit s'agir d'un numéro à 9 chiffres, par exemple 12-3456789.",
          "registrationType": "Type d'Id d’enregistrement d’entreprise*",
          "website": "Site Web de l'entreprise*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Étape {currentStep} sur {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "Votre profil d'entreprise a été soumis avec succès.",
        "startA2P": "Commencez l'inscription A2P.",
        "title": "Profil d'entreprise soumis avec succès",
        "tooltips": {
          "agency": "Les utilisateurs d'agences peuvent commencer l'inscription A2P",
          "location": "Les utilisateurs de l'emplacement peuvent commencer l'inscription A2P"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Fermer l’exemple",
          "optInKeywords": "Mots-clés d'adhésion*",
          "optInKeywordsHelper": "Longueur maximale: 255 caractères.",
          "optInKeywordsPlaceholder": "Mots-clés séparés par virgule, exemple : ABONNEMENT, DÉMARRER.",
          "optInMessage": "Message d'adhésion*",
          "optInMessageInfo": "Doit contenir le nom de l'entreprise et le mot-clé de désinscription",
          "optInMessagePlaceholder": "Exemple : Vous avez accepté de recevoir des notifications et des SMS promotionnels de la part de company_name. Veuillez répondre ARRÊTER si vous souhaitez vous désabonner à l'avenir.",
          "placeholder": "Exemple : les utilisateurs finaux s'inscrivent en se rendant sur le site https://www.mycompany.com/book et en remplissant le formulaire avec leurs renseignements. Les utilisateurs cochent une case pour recevoir des notifications et des messages promotionnels de notre part afin de donner leur consentement. De plus, les utilisateurs finaux peuvent également envoyer COMMENCER par message texte au +1 (213) 725-2867.",
          "question": "Comment les utilisateurs finaux consentent-ils à recevoir des messages?*",
          "seeExample": "Voir l’exemple"
        },
        "messageDetails": {
          "embeddedLink": "Le message inclura un lien intégré.",
          "phoneNumbers": "Les messages incluront des numéros de téléphone.",
          "sampleMessage1Placeholder": "Exemple : Bonjour John! Ici Jane de company_name. Notre rendez-vous pour le 20 juillet à 11 h est confirmé. Veuillez appeler au +1(213) 725-2867 si vous devez reprogrammer. Répondez « ARRÊTER » pour vous désabonner.",
          "sampleMessage2Placeholder": "Exemple : Hé Brian! C'est Jane de company_name. Je constate que vous n'avez pas pu vous présenter à notre rendez-vous. Souhaitez-vous reprogrammer? - https://www.mycompany.com/book. Répondez STOP pour vous désabonner.",
          "sampleMessageInfo": "Doit inclure le nom du responsable, votre nom, le nom de l'entreprise et la clause de désinscription",
          "subtitle": "Ajouter des exemples de messages"
        },
        "useCaseDetails": {
          "explainInDetail": "Veuillez expliquer en détail.",
          "pickUseCase": "Sélectionnez le cas d'utilisation de la campagne.",
          "solePropLabel": "Entrepreneur individuel",
          "subtitle": "Saisissez les détails et la description de la campagne.",
          "useCase": "Cas d'utilisation de la campagne*",
          "useCaseDescription": "Description du cas d'utilisation*",
          "useCaseDescriptionPlaceholder": "Exemple : Cette campagne envoie des renseignements sur les rendez-vous, des messages de confirmation et de rappel à nos clients après qu'ils ont planifié un rendez-vous sur notre site Web et consenti à recevoir des SMS promotionnels et de notification de notre part."
        }
      },
      "einModal": {
        "disableNoEINText": "Seules les entreprises ayant une adresse valide aux États-Unis et au Canada sont autorisées à enregistrer la marque A2P sans identifiant fiscal.",
        "hasEIN": "Oui, l'entreprise que j'enregistre dispose d'un numéro d'identification fiscale (p. ex. EIN, CCN, etc.).",
        "infoText": "Vous trouverez votre numéro EIN américain sur votre formulaire CP 575.",
        "noEIN": "Non, l'entreprise que j'enregistre n'a pas de numéro d'Id fiscale (par ex. EIN, CCN, etc.).",
        "question": "L'entreprise que vous enregistrez dispose-t-elle d'un numéro d'Id fiscale (par ex., EIN, CCN, etc.)?*",
        "title": "Déterminer les besoins de la marque A2P"
      },
      "exampleModal": {
        "examples": "Exemples"
      },
      "otpError": {
        "message": "Il y a eu un problème lors de l’envoi du code OTP.",
        "title": "Impossible de renvoyer le mot de passe à usage unique (OTP)"
      },
      "otpSuccess": {
        "title": "Votre mot de passe à usage unique (OTP) a bien été envoyé."
      },
      "validation": {
        "cityRequired": "La ville est obligatoire.",
        "countryRequired": "Le pays est obligatoire.",
        "invalidMobileNumber": "Numéro de téléphone cellulaire non valide",
        "postalCodeRequired": "Le code postal est obligatoire.",
        "stateRequired": "L'État/la Province est obligatoire.",
        "streetAddressRequired": "L'adresse civique est obligatoire."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-about-iframe",
      "agencyOwner": "Propriétaire de l'agence",
      "agencyOwnerAndAdmins": "Propriétaire et administrateurs de l'agence",
      "contactAgencyOwner": "Si vous avez besoin d'aide, veuillez contacter votre",
      "firstPromoterAccessMessage": "Ce rapport FirstPromoter n'est accessible que par le(s)",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Aucun partenaire ne correspond à vos filtres. Cliquez",
      "paymentDetailsAccessMessage": "Cette section sur les détails de paiement n’est accessible et modifiable que par le(s)",
      "toApplyPartner": "pour demander à devenir partenaire."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "Doc"
      },
      "loading": "Chargement",
      "legalBusinessNameHelper": "Saisissez le nom exact de l'entreprise, tel qu'il est enregistré auprès du gouvernement et mentionné dans vos documents fiscaux (CP 575). Par ex. Leadconnector LLC plutôt que Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Cliquez sur <span class='font-semibold'>Ouvrir HighLevel</span> pour lancer l'application de bureau.<br>Ça ne fonctionne pas? Vous pouvez également <a href=\"/\" class='!text-blue-700 hover:underline'>utiliser HighLevel dans votre navigateur</a>.",
        "launchingTitle": "Lancement du bureau HighLevel",
        "launchButtonText": "Ouvrir HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Cliquez sur <span class='font-semibold'>Ouvrir LeadConnector</span> pour lancer l'application de bureau.<br>Ça ne fonctionne pas? Vous pouvez également <a href=\"/\" class='!text-blue-700 hover:underline'>utiliser LeadConnector dans votre navigateur</a>.",
        "launchingTitle": "Lancement du bureau LeadConnector",
        "launchButtonText": "Ouvrir LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Sélectionnez une action.",
        "destination": "Destination",
        "removeFromAllCampaigns": "Cette action retirera les prospects de toutes les campagnes sauf la campagne actuelle",
        "triggerLinks": "Liens de déclenchement"
      },
      "importTemplate": {
        "errorImporting": "Une erreur s'est produite lors de l’importation du modèle!",
        "importTemplate": "Importer un modèle",
        "importing": "Importation en cours",
        "title": "Importer le modèle {entityName}",
        "unnamedEntity": "Copie de {entityName} anonyme"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "ci-dessous",
          "confirmByTyping": "Veuillez confirmer en tapant",
          "confirmWord": "CONFIRMER",
          "existingNotMoved": "Si votre client utilise déjà Mailgun ou un serveur SMTP, ses paramètres ne seront pas transférés.",
          "notNow": "Pas maintenant",
          "pricingInfo": "LC Email est moins cher que Mailgun et le coût sera d'environ 0,68 $ pour 1 000 courriels.",
          "setAsDefault": "Définir LC Email comme fournisseur par défaut pour votre agence et les clients qui n'ont pas déjà Mailgun ou SMTP",
          "thisWill": "Voyez cela :",
          "title": "Vous migrez vers le courriel Lead Connector",
          "useLcEmail": "Utilisez LC Email"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Glisser-ou déposer des médias ici",
        "editPost": "Modifier la publication",
        "enterText": "Entrez le texte ici",
        "exampleComment": "Super!! J'ai hâte de voir ça!",
        "exampleName": "Essai technique",
        "hashtag1": "#mot-clic",
        "hashtag2": "#génial",
        "hashtag3": "#super",
        "imagePlaceholder": "img(02).png",
        "needReview": "Besoin d'un avis?",
        "network": "Réseau",
        "photo": "photo",
        "previewPost": "Aperçu de la publication",
        "selectNetwork": "Sélectionnez un réseau social.",
        "sizeExample": "245 ko",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "Vous avez créé un pool de {count} numéros pour suivre les visiteurs sur votre site web. <br />Vos appels seront transférés vers",
          "createdSingle": "Vous avez créé {count} numéro pour suivre les visiteurs sur votre site web. <br />Vos appels seront transférés vers",
          "percentComplete": "100 % terminé"
        },
        "create": {
          "correctErrors": "Corrigez ces erreurs!",
          "forwardHelp": "Indiquez-nous quel téléphone doit sonner lorsque le client appelle votre numéro de suivi. Il s'agit généralement de votre numéro de téléphone professionnel principal. Par exemple : 404-555-1212",
          "heading": "Pool de numéros et renvoi d’appels",
          "nameHelp": "Le « {name} » correspond à la référence de ce numéro de suivi dans votre compte. Choisissez un nom court et facile à retenir.",
          "newTrackingNumbers": "nouveaux numéros de suivi.",
          "nextTracking": "Suivant : options de suivi",
          "percentComplete": "50 % terminé",
          "pleaseConfirm": "Veuillez confirmer\t:",
          "poolSize": "Taille du pool",
          "poolSizeError": "Saisissez une taille de pool comprise entre 4 et 30 numéros pour le suivi.",
          "poolSizeHelp": "La taille de votre pool de numéros détermine le nombre de visiteurs simultanés que nous pouvons suivre sur votre site Web à un moment donné. La taille de votre pool doit correspondre à un quart du trafic horaire maximal rapporté dans Google Analytics, avec un minimum de quatre chiffres.",
          "swappingHelp": "Indiquez-nous quel numéro de téléphone nous devons remplacer sur le site web. Par exemple : 404-555-1212",
          "swappingNumber": "Échange de numéros",
          "validationError": "Une erreur s'est produite lors de la validation du formulaire."
        },
        "features": {
          "activateNumber": "Activer le numéro",
          "address": "{type} Adresse",
          "addressHelp": "L'achat d'un numéro pour certains pays nécessite une adresse. Veuillez communiquer avec le service d'assistance pour savoir comment ajouter une adresse si vous avez besoin d'aide.",
          "heading": "Caractéristiques des numéros",
          "leaveBlank": "Laissez ce champ vide si vous n'avez aucun message.",
          "recordingDescription": "Activez l'enregistrement des appels et diffusez un court message à l'appelant.",
          "recordingHelp": "Certaines juridictions exigent que les deux parties consentent à toute conversation enregistrée. Pour vous aider à respecter ces lois, vous pouvez activer un message d'accueil informant l'appelant que l'appel peut être enregistré.",
          "whisperDescription": "Un court message qui est diffusé avant l'appel. L'appelant ne peut pas entendre ce message."
        },
        "tracking": {
          "heading": "Options de suivi",
          "nextCreatePool": "Ensuite : Créer un pool",
          "percentComplete": "34 % complété",
          "searchLower": "recherche"
        },
        "whatToTrack": {
          "heading": "Que voulez-vous suivre sur votre site Web?",
          "trackCampaign": "Suivre une campagne de marketing",
          "trackCampaignDescription": "Créez un numéro de téléphone unique qui redirige tous les appelants vers une seule campagne de marketing.",
          "trackVisitor": "Suivre l'activité des visiteurs",
          "trackVisitorDescription": "Créez plusieurs numéros qui relient les appels aux visiteurs du site Web, aux mots-clés au coût par clic (PPC), et plus encore."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "cliquez ici pour actualiser.",
      "issuesLoadingApp": "Si vous avez des problèmes pour charger l'application",
      "loadingFreshData": "Chargement des nouvelles données…",
      "loadingNewSubAccountData": "Chargement des données du nouveau sous-compte…"
    },
    "login": {
      "bySigningInYouAgree": "En vous connectant, vous acceptez nos <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>conditions générales d'utilisation</a>",
      "newPasswordSent": "Un nouveau mot de passe est envoyé par courriel."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Par :"
        },
        "affiliates": {
          "partnerBadgeAlt": "Insigne de partenaire"
        },
        "checkout": {
          "cardInformation": "Renseignements sur la carte",
          "cardNumberInvalid": "Votre numéro de carte n'est pas valide.",
          "commitment": "engagement",
          "consentOneTime": "En confirmant, vous permettez à LeadConnector de facturer votre carte pour ce paiement.",
          "consentSubscription": "En confirmant votre abonnement, vous permettez à LeadConnector de facturer votre carte pour ce paiement et les paiements futurs pour cet abonnement.",
          "defaultIntervalCount": "1",
          "endingIn": "se terminant par",
          "errorImageAlt": "Illustration d'erreur",
          "intervalSuffix": "(s)",
          "month": "mois",
          "pay": "Payer",
          "payWithCard": "payez par cartr",
          "paymentProcessing": "Le paiement est en cours de traitement. Veuillez ne pas recharger ni cliquer sur le bouton Retour.",
          "proceedWithExistingCard": "Continuer avec la carte existante",
          "proceedWithNewCard": "Continuer avec une nouvelle carte",
          "prorationDetails": "Vous serez facturé pour {days} jours dès maintenant pour la période allant jusqu'au {billingEnd}, et vous commencerez à être facturé pour le montant total de ${amount}/mois à partir du {billingDate}.",
          "prorationMessage": "Les frais initiaux sont calculés au prorata et la facturation régulière commencera à partir du {billingDate}.",
          "purchase": "achat",
          "subscribe": "S'abonner",
          "subscribeTo": "S’abonner à",
          "updateCardDetails": "Veuillez mettre à jour les détails de la carte.",
          "zip": "zip"
        },
        "options": {
          "jobPosition": {
            "gm": "Directeur général",
            "vp": "Vice-président"
          }
        },
        "registration": {
          "stepProgress": "Étape {currentStep} sur 8",
          "successDescription": "Votre marque A2P et votre campagne ont été soumises.",
          "successMessage": "Remarque : Vous recevrez un message avec mot de passe à usage unique (OTP) sur le numéro de cellulaire fourni pour la vérification TCR. Veuillez répondre « Oui » dans les 24 heures suivant la réception du SMS.",
          "successWaitDays": "7 jours",
          "successWaitPrefix": "Cela pourrait prendre jusqu'à ",
          "successWaitSuffix": " pour l'approbation de votre marque et quatre à cinq semaines supplémentaires pour l'approbation de la campagne."
        },
        "reminder": {
          "noReplyYet": "Aucune réponse pour le moment",
          "patientConfirmed": "Patient confirmé"
        },
        "sendGrid": {
          "apiKeyRequired": "La clé API est obligatoire."
        },
        "update": {
          "brandNameHelper": "Utilisez le nom légal de l'organisation qui envoie les messages.",
          "businessVerticals": "Secteurs d'affaires*",
          "resendOTP": "Réenvoyer l’OTP",
          "retryOTPTitle": "Réessayer la vérification OTP"
        }
      },
      "addCustomEmailModal": {
        "title": "Ajouter un courriel personnalisé"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Ajouter un fournisseur",
        "clickHereForInfo": "Cliquez ici pour en savoir plus.",
        "clickHereToFindOut": "Cliquez ici pour en savoir plus à leur sujet.",
        "createProviderError": "Une erreur s'est produite lors de la création du fournisseur!",
        "gmailLimitations": "Gmail présente certaines limitations.",
        "needHelp": "Besoin d’aide pour trouver le serveur SMTP et le numéro de port?",
        "port25NotSupported": "Le port 25 n'est pas pris en charge! Veuillez utiliser plutôt le port 2525.",
        "providerExists": "Un fournisseur avec ce courriel/nom d'utilisateur existe déjà.",
        "providerName": "Nom du fournisseur",
        "selectProvider": "Sélectionnez. un fournisseur",
        "smtpPortNumber": "Numéro de port SMTP",
        "smtpProvider": "Fournisseur SMTP",
        "smtpServer": "Serveur SMTP",
        "username": "Nom d'utilisateur",
        "usernameOrEmailRequired": "Le nom d'utilisateur ou le courriel est obligatoire.",
        "verifySmtpAccount": "Vérifier le compte SMTP"
      },
      "addTagModal": {
        "addTag": "Ajouter une balise",
        "editTag": "Modifier l'étiquette",
        "tagAlreadyExists": "La balise {tag} existe déjà."
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Ces rapports FirstPromoter ne sont accessibles que par le <strong>propriétaire de l'agence et les administrateurs</strong>. Si vous avez besoin d'aide, veuillez communiquer avec le <strong>propriétaire de votre agence ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "Tableau de bord FirstPromoter",
        "noPartnersFound": "Aucun partenaire ne correspond à vos filtres. Cliquez <a href='javascript:void(0);'>ici</a> pour demander à devenir partenaire.",
        "paymentDetailsAccessMessage": "Cette section sur les détails de paiement est accessible et modifiable uniquement par le <strong>propriétaire de l’agence</strong>. Si vous avez besoin d'aide, veuillez communiquer avec le <strong>propriétaire de votre agence ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Détails du rendez-vous"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Charger l’instantané :",
        "loadSnapshotWarning": "Voulez-vous charger l'instantané associé à ce forfait? <br /> <strong class='text-danger'>Les données existantes peuvent être perdues</strong>."
      },
      "auth": {
        "changePassword": {
          "changeButton": "Modifier le mot de passe",
          "confirmPassword": "Confirmez le nouveau mot de passe",
          "expired": "Votre lien de réinitialisation du mot de passe a expiré.",
          "regenerateLink": "Régénérer le lien",
          "success": "Mot de passe modifié avec succès",
          "title": "Définir un nouveau mot de passe",
          "passwordMismatch": "Les mots de passe ne correspondent pas"
        },
        "forgotPassword": {
          "contactAgency": "contactez votre agence.",
          "contactSupport": "contactez l'assistance HighLevel 24 h/24, 7 j/7 en appelant le",
          "supportMessage": "Si vous n'avez pas accès à cette boîte courriel, veuillez",
          "successMessage": "Un lien de réinitialisation de mot de passe a été envoyé à votre adresse courriel.",
          "rateLimitError": "Trop de demandes de réinitialisation de mot de passe. Veuillez réessayer plus tard."
        },
        "login": {
          "inactivityMsg": "Nous avons remarqué que vous êtes inactif/inactive depuis un certain temps, nous vous avons donc déconnecté(e) pour assurer votre sécurité.",
          "loginButton": "Ouvrir une session",
          "resetPasswordMsg": "Un lien de réinitialisation du mot de passe est envoyé à votre courriel.",
          "signInWithGoogle": "Connectez-vous avec Google",
          "contactHighLevelSupport": " contactez l'assistance HighLevel 24 h/24, 7 j/7 en appelant le"
        },
        "logout": {
          "loggingOut": "Déconnexion en cours..."
        },
        "otp": {
          "enterBackupCode": "Entrez votre code Instantané",
          "resend": "Renvoyer",
          "resendIn": "Renvoyer dans",
          "sendToPhone": "Envoyer le code par téléphone",
          "sending": "Envoi",
          "useAuthenticator": "Utilisez l'application Authenticator",
          "useBackupCode": "Utilisez le code de secours",
          "verifyButton": "Vérifiez avec le code de secours"
        },
        "sso": {
          "agreeTerms": "En vous connectant, vous acceptez nos <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>conditions générales d'utilisation</a>",
          "and": ", et",
          "loginDifferentMethod": "Connectez-vous avec une méthode différente",
          "loginSuccessRedirecting": "Connexion réussie, redirection...",
          "processing": "Traitement de votre demande...",
          "redirecting": "Redirection...",
          "redirectingToDashboard": "Redirection vers le tableau de bord...",
          "signedIn": "Connecté",
          "signingIn": "Connexion en cours...",
          "testFailedRedirecting": "Test échoué, redirection...",
          "testSuccessRedirecting": "Essai réussi, redirection en cours..."
        }
      },
      "businessDetailModal": {
        "businessAddress": "Adresse de l'entreprise : {address}",
        "businessDetailsText": "Les renseignements suivants relatifs à l'entreprise seront transmis à Google Local Services Ads pour l'intégration à Reserve with Google. Veuillez vérifier et confirmer ou {link} pour mettre à jour votre profil d'entreprise.",
        "businessInfoRequired": "Les informations commerciales ci-dessus sont nécessaires à l'intégration. {link} pour mettre à jour les informations commerciales manquantes/incorrectes.",
        "businessName": "Nom de l'entreprise : {name}",
        "businessNiche": "Niche commerciale : {niche}",
        "city": "Ville : {city}",
        "confirmDetails": "Je confirme par les présentes que les détails mentionnés ci-dessus sont exacts.",
        "country": "Pays : {country}",
        "mustConfirmDetails": "Vous devez confirmer les détails mentionnés ci-dessus.",
        "phoneNumber": "Numéro de téléphone : {phone}",
        "state": "État : {state}",
        "zipCode": "Code postal : {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Ajouter des Heures",
        "applyAll": "Tout appliquer"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Répondez à l’appel et entrez ce code de vérification :",
          "leadConnectorCalling": "Appel de Lead Connector…",
          "title": "Ajouter une Identification de l'appelant via la voix",
          "waitingForVerification": "En attente de la vérification…"
        },
        "callerIdVerificationStatus": {
          "failed": "La vérification de l'identification de l'appelant a échoué. Veuillez réessayer.",
          "success": "Vous avez bien vérifié <strong>{contact}</strong>."
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Ajouter un ou plusieurs numéro(s) existant(s)",
          "areaCode": "Indicatif régional :",
          "checkAvailability": "Vérifier la disponibilité",
          "checkingAvailability": "Vérification de la disponibilité du numéro.",
          "chooseAreaCode": "Sélectionnez un indicatif régional.",
          "choosePhoneNumbers": "Choisissez le(s) numéro(s) de téléphone.",
          "goBack": "Revenir en arrière",
          "localNumbers": "{type} local",
          "nextNumberFeatures": "Suivant : caractéristiques des numéros",
          "noExistingNumbers": "Aucun numéro existant à ajouter",
          "noNumbersAvailable": "Aucun numéro disponible",
          "notEnoughNumbers": "Pas assez de numéros disponibles",
          "numbersAvailable": "Numéros disponibles",
          "numbersDifferentArea": "Numéros avec un autre indicatif régional",
          "numbersLocalTo": "Numéros locaux à <strong>{number}</strong>",
          "problemChecking": "Problème lors de la vérification de la disponibilité du numéro. Veuillez vérifier votre connexion réseau ou communiquer avec le service d'assistance.",
          "somethingWentWrong": "Une erreur s'est produite. Veuillez vérifier vos identifiants de compte Twilio et communiquer avec le service d'assistance si le problème persiste.",
          "tollFreeNumbers": "Numéros sans frais (supplément mensuel de 2,00 $ par numéro)",
          "percentageComplete": "67 % complété"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Je comprends les conséquences, supprimez le pool.",
          "confirmText": "Veuillez taper <b>{name}</b> pour confirmer.",
          "title": "Supprimer le pool de numéros – <strong>{name}</strong>",
          "warning": "Cette action ne peut pas être annulée. Cela supprimera définitivement le(s) numéro(s) de votre compte Twilio ainsi que du pool de numéros de notre base de données. En outre, si vous supprimez un pool de numéros parce que vous rencontrez un problème, veuillez communiquer notre équipe d'assistance."
        },
        "editNumberFormatModal": {
          "description": "Vous pouvez mettre à jour le formatage de(s) numéro(s) d'échange et de(s) numéro(s) de pool selon vos besoins. Assurez-vous que le(s) numéro(s) d'échange apparaissent sur le site Web comme formatés.",
          "title": "Mise à jour du formatage des numéros – <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Ajouter/Modifier l'Id de groupe",
          "callConnectTooltip": "Cette fonctionnalité exige que le récepteur appuie sur une touche pour connecter l’appel, ce qui entraîne une meilleure précision pour le signalement des appels.",
          "createGroupIdDescription": "Créez/ajoutez un id de groupe unique pour utiliser plusieurs pools de numéros avec un seul extrait JavaScript.",
          "enableCallConnect": "Activer la fonctionnalité de connexion d'appel",
          "groupId": "ID de groupe",
          "outboundCallTimeout": "Temps d'arrêt des appels sortants",
          "passCallerID": "Transmettre le numéro appelé comme identifiant de l'appelant",
          "passCallerIDTooltip": "Par défaut, le système transmet le numéro de l'appelant, mais si vous souhaitez que l'identification de l'appelant soit plutôt le numéro composé par l'appelant, activez cette fonctionnalité.",
          "selectCallerID": "Sélectionnez l'identification de l'appelant.",
          "timeDuration": "Durée en seconde (s)",
          "titleNumber": "Numéro - <strong>{number}</strong>",
          "updateWhisperWarning": "Mettez à jour le message chuchoté, car cette fonction exige que le récepteur appuie sur une touche pour connecter l'appel.",
          "useVerifiedNumber": "Utiliser votre numéro vérifié comme identifiant de l'appelant pour les appels sortants",
          "useVerifiedNumberTooltip": "Applicable uniquement aux numéros de téléphone vérifiés. Vous pouvez vérifier un numéro de téléphone dans les paramètres > numéros de téléphone > ajouter un identifiant d'appel vérifié"
        },
        "emailOTPModal": {
          "confirmCode": "Confirmer le code",
          "resendCode": "Si vous n’avez pas reçu le code, cliquez ici pour le renvoyer",
          "unexpectedIssue": "Un problème inattendu est survenu."
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Informations sur les champs personnalisés",
          "customFieldTooltip": "Infobulle de champ personnalisé : {options}",
          "field": "Champ {companyName}",
          "trackingParameters": "Paramètres de suivi",
          "zipCode": "Code postal"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Ajouter des numéros d'échange",
          "addingSnippets": "Ajout d'extraits de Javascript",
          "groupSnippet": "Extrait du groupe « {id} »",
          "normalSnippet": "Extrait normal",
          "noswapDescription": "Si vous ne souhaitez pas que nous échangions le numéro à un certain emplacement, ajoutez une classe « noswap ».",
          "notReplacing": "Ne pas remplacer à un certain emplacement",
          "requiredSteps": "Étapes obligatoires",
          "snippetsDescription": "Copiez l'extrait ci-dessous et ajoutez-le juste au-dessus de la balise de fermeture du corps sur chaque page où vous souhaitez remplacer les numéros.",
          "swappingDescription": "Utilisez les numéros ci-dessous pour activer l'échange de numéros de téléphone. Sélectionnez un format local ou international, ou même les deux."
        },
        "newPhoneNumberModal": {
          "areaCode": "Indicatif régional",
          "availableNumbers": "Numéros disponibles",
          "bundle": "Lot",
          "chooseAddress": "Choisissez l'adresse…",
          "chooseBundle": "Choisissez le lot…",
          "createRegulatory": "Créez un lot/une adresse réglementaire ici.",
          "monthlyFee": "Frais mensuels",
          "noNumbersFound": "Aucun numéro trouvé, veuillez essayer un autre indicatif.",
          "selectAddress": "Veuillez sélectionner « Adresse » pour acheter un numéro.",
          "selectBundle": "Veuillez sélectionner « Lot » pour acheter un numéro.",
          "title": "Ajouter un numéro de téléphone",
          "upgradeAccount": "Veuillez mettre à niveau votre compte Twilio : seuls les comptes mis à niveau peuvent acheter des numéros de téléphone et passer des appels téléphoniques.",
          "cardAuthenticationFailed": "Échec de l'authentification de la carte!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "Vous devez accepter les conditions générales et la condition de confidentialité.",
          "clickingProceed": "Cliquez sur Continuer pour ouvrir la page de liaison LSA dans un nouvel onglet.",
          "configureCalendar": "Configurez au moins un calendrier pour procéder à la réservation avec l'intégration de Google.",
          "configureCalendarBtn": "Configurer le calendrier",
          "linkOneAccount": "Assurez-vous de ne lier qu'un seul compte. Communiquez avec le service d'assistance si vous ne pouvez pas consulter la page sur la capture d'écran ci-dessus.",
          "readInstructions": "J’ai lu les instructions mentionnées ci-dessus"
        },
        "updateTrackingModal": {
          "title": "Mettre à jour l'option de suivi"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(Ceci n'est visible que par les administrateurs de l'agence)",
          "updatedEvery24Hours": "(mise à jour toutes les 24 heures)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Calendrier non sélectionné pour la synchronisation",
          "check": "Vérifier {email}",
          "checkForConflicts": "Vérifier s'il y a des conflits",
          "checkForConflictsTooltip": "Configurez le(s) calendrier(s) pour vérifier les conflits afin d'éviter les doubles réservations.",
          "contactCreationAllowed": "Création de contact autorisée",
          "googleCalendar": "Logo du calendrier Google",
          "noGoogleAccounts": "Aucun compte Google/Outlook n'a encore été ajouté dans les paramètres d'intégration.",
          "noGoogleAccountsTeamMember": "Aucun compte Google/Outlook n'a été ajouté pour ce membre de l'équipe à l'emplacement actuel. Veuillez demander au membre de votre équipe de se connecter par l'entremise de son compte et d'ajouter une connexion Google à partir de ses paramètres d'intégration.",
          "outlookCalendar": "Calendrier utilisateur Outlook",
          "primaryCalendarTooltip": "Définissez le calendrier auquel vous souhaitez ajouter de nouveaux événements au fur et à mesure qu'ils sont programmés.",
          "runTriggerAllowed": "Exécution du déclencheur autorisée"
        },
        "warningModal": {
          "contactAgency": "Veuillez communiquer avec votre agence pour modifier les paramètres du courriel.",
          "title": "Avertissement"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Assistance par clavardage plus rapide 24 h/24 et 7 j/7",
            "faster247Ticket": "Assistance et temps de réponse plus rapides 24 heures sur 24, 7 jours sur 7"
          },
          "highlight": {
            "description": "Nous comprenons, vous devez aller plus vite. Quand vous avez une question ou une préoccupation, vous voulez qu'on y réponde le plus rapidement possible! Avec la mise à niveau vers l'assistance prioritaire, vous pouvez passer devant tout le monde et accélérer automatiquement vos demandes.",
            "heading": "Êtes-vous prêt pour le traitement VIP?"
          },
          "name": "Assistance prioritaire",
          "success": {
            "description": "L'assistance prioritaire a été activée sur votre compte. Vous n'aurez plus à faire la queue.",
            "heading": "Vous êtes maintenant un client prioritaire!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "Dupliquer {entityName}",
        "cloning": "Duplication en cours….",
        "cloningLimit": "La duplication est limitée à trois emplacements à la fois.",
        "error": "Une erreur s'est produite lors de la duplication de l'entonnoir!",
        "locationsLabel": "Sélectionner les emplacements",
        "nameLabel": "Nom du {entityName} cloné",
        "namePlaceholder": "Entrez le nom pour le cloné {entityName}",
        "selectUpTo": "Sélectionnez jusqu'à {maxSelectableLocations} emplacements",
        "title": "Dupliquer {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "Avec le CNAM, le nom de votre entreprise apparaît sur l'identification de l'appelant, rendant vos appels instantanément reconnaissables et renforçant ainsi la confiance. Faites savoir à vos clients que c'est vous qui appelez, à chaque fois.",
          "title": "Faites en sorte que vos appels se démarquent!"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Confirmer et s'inscrire",
          "description": "Affichez le nom de votre entreprise aux destinataires des appels pour augmenter la confiance et les taux de réponse aux appels.",
          "title": "Renforcez la confiance dans le appels avec CNAM",
          "warning": "L'affichage du nom de l'entreprise n'est pas garanti, surtout sur mobile."
        },
        "submitted": {
          "checkStatus": "Vérifier le statut du CNAM",
          "description": "Le nom de votre entreprise devrait être affiché aux contacts concernés dans environ 3 à 5 jours.",
          "subtitle": "Votre demande CNAM est désormais soumise.",
          "title": "Félicitations!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Confirmer la suppression",
        "confirmation": "Confirmation"
      },
      "createAddress": {
        "successTitle": "Adresse soumise avec succès",
        "underReview": "L'adresse soumise est en cours d'examen."
      },
      "createEndUser": {
        "dateFormat": "Le format de la date doit être AAAA-MM-JJ.",
        "phoneExample": " Exemple : +14155552671",
        "title": "Détails de l’entreprise :"
      },
      "customValueModal": {
        "changingNameWarning": "La modification du nom n'affecte pas la clé de champ.",
        "editCustomValue": "Modifier la valeur personnalisée",
        "fieldKeyCreatedWarning": "La clé de champ sera créée en fonction du nom et ne pourra pas être modifiée ultérieurement.",
        "nameRequired": "Le champ Nom est obligatoire.",
        "nameValidation": "Le nom doit être alphanumérique et contenir au moins un caractère.",
        "valueRequired": "Le champ Valeur est obligatoire."
      },
      "details": {
        "addressName": "Nom de l'adresse",
        "addressTitle": "Détails de l'adresse",
        "bundleName": "Nom du forfait",
        "bundleTitle": "Détails du lot réglementaire",
        "countryFlag": "drapeau {country}",
        "id": "ID",
        "organisation": "Organisation",
        "rejectionReason": "Raison du rejet",
        "status": {
          "approved": "Approuvé",
          "notValidated": "Non validé",
          "rejected": "Refusé",
          "validated": "Validé"
        },
        "typeOfNumber": "Type de nombre"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Sélectionner un bureau",
        "whichOffice": "Quel bureau souhaitez-vous associer à ce compte?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Autoriser la création de contacts :",
        "allowTrigger": "Autoriser le déclencheur :",
        "doNotSync": "Ne pas synchroniser les nouveaux événements avec le calendrier principal",
        "primaryCalendarTooltip": "Vous ne pouvez sélectionner qu'un calendrier avec accès en écriture que vous n'avez pas sélectionné pour vérifier les conflits.",
        "selectDefaultCalendar": "Sélectionner le calendrier par défaut",
        "whichCalendar": "Quel calendrier devons-nous utiliser pour synchroniser (lire et écrire) les événements?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Vérifiez ces endroits pour voir s'il y a des conflits.",
        "howToCheckConflicts": "Comment vérifier s'il y a des conflits?"
      },
      "ejectModal": {
        "agencyClosing": "Le compte de l'agence Elite Marketing chez Highlevel est en cours de fermeture. Pour garder votre compte, veuillez communiquer avec {userName} pour transférer directement votre compte vers Highlevel.",
        "cancelWarning": "Veuillez noter que votre compte sera officiellement annulé le 30 juin 2025, et que nous ne pourrons plus récupérer vos données après cette date si le transfert n'a pas été opéré.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "Si vous avez des questions, veuillez communiquer avec nous à l'adresse",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "Pour vous soutenir durant cette transition gratuite, nous appliquons {months} d'accès gratuit à votre nouvel abonnement.",
        "intro": "En raison de violations récurrentes des conditions d'utilisation de HighLevel, Elite Marketing Authority (EMA) a été définitivement supprimée de la plateforme HighLevel.",
        "platformCommitment": "En tant que plateforme qui alimente les services d'EMA, HighLevel s’engage à maintenir un environnement sûr, conforme et digne de confiance pour tous les utilisateurs. Pour éviter toute perturbation de votre compte, nous sommes là pour vous aider à effectuer une transition en douceur, que ce soit vers un autre fournisseur en marque blanche ou directement vers HighLevel.",
        "questions": "Si vous avez des questions,",
        "retainAccess": "Pour conserver l'accès à vos données et outils existants, cliquez sur le bouton ci-dessous et suivez les instructions pour initier le transfert.",
        "speakWithTeam": "pour parler à notre équipe.",
        "startTransfer": "Commencez votre transfert gratuit.",
        "title": "À l'attention des clients d'Elite Marketing",
        "viewFaqs": "Consultez la FAQ ici\t:",
        "whiteLabel": "Si vous préférez accéder à HighLevel par l'intermédiaire d'un autre fournisseur en marque blanche, nous serons heureux de prendre en charge ce changement par le biais de notre système de billets d'assistance une fois que vous aurez transféré votre compte directement à HighLevel."
      },
      "emailTemplate": {
        "createdOn": "Créé le",
        "updatedOn": "Mis à jour le"
      },
      "error": {
        "title": "La soumission de l'ensemble réglementaire a échoué."
      },
      "errors": {
        "funnel": {
          "multiplePages": "Plus d'une page a cette URL, modifiez le chemin d'accès de cette page pour qu'elle fonctionne.",
          "urlNotFound": "Désolé, nous ne trouvons pas l'URL que vous cherchez."
        },
        "productRebilling": {
          "requestFailed": "La demande a échoué."
        },
        "template": {
          "categoryNotFound": "Désolé, nous ne trouvons pas la catégorie que vous cherchiez.",
          "internalError": "Une erreur interne s'est produite!"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "Le sous-compte que vous tentez de transférer est compatible avec la loi HIPAA et ne peut pas être transféré à une agence qui ne l'est pas."
          },
          "limitExceeded": {
            "message": "L'agence à laquelle vous essayez de transférer le sous-compte a épuisé sa limite d'utilisation et ne peut plus obtenir de sous-comptes.  Veuillez lui demander soit de supprimer un sous-compte qui n'est pas utilisé, soit de passer à un forfait d'agence supérieur afin d'obtenir ce sous-compte."
          },
          "pendingRequest": {
            "heading": "Une demande de transfert pour ce sous-compte est déjà en attente.",
            "message": "Veuillez annuler la demande de transfert déjà existante pour ce sous-compte avant de procéder à une nouvelle demande."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Vous ne trouvez pas la page que vous cherchez? Veuillez consulter vos paramètres Facebook et vous assurer que toutes les pages sont sélectionnées.",
        "instagramAvailable": "Instagram est disponible pour ce compte!",
        "noPages": "Vous n'avez aucune page sous ce compte.",
        "title": "Sélectionnez la page Facebook que vous souhaitez relier à cet emplacement"
      },
      "googleLocationSelect": {
        "closeButton": "Fermez!",
        "enableCallTracking": "Activez le suivi des appels GBP",
        "noBusinesses": "Vous n'avez aucune entreprise connectée sous ce compte."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Plus efficace",
          "faster": "Plus rapide",
          "itsText": "C'est",
          "smoother": "Plus fluide",
          "title": "Une nouvelle expérience d'importation est disponible!",
          "warningMessage": "L'activation de la nouvelle expérience d'importation active les laboratoires pour ce sous-compte et active la fonctionnalité Bêta."
        },
        "validateEmails": "Valider les courriels?"
      },
      "initBundle": {
        "numberType": "Type de numéros que vous prévoyez d'utiliser",
        "numberTypes": {
          "local": "Numéros locaux",
          "mobile": "Mobile",
          "tollfree": "Sans frais"
        },
        "selectCountry": "Sélectionnez votre pays.",
        "selectUserType": "Sélectionnez le type d'utilisateur.",
        "userTypes": {
          "business": "Entreprise",
          "individual": "Individuel"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Dernier crédit ajouté le :",
        "currentBalance": "Solde actuel",
        "debitBalance": "- Solde débiteur",
        "depositComplimentaryCreditsOf": "Dépôt de crédits gratuits de",
        "manageBalance": "Gérer le solde",
        "mustBeValidInteger": "Doit être un nombre entier valide",
        "nextDate": "Date suivante :",
        "perMonth": "par mois",
        "remainingWalletBalance": "Solde disponible dans le portefeuille de ce sous-compte",
        "rolloverCredits": "Crédits transférés au mois prochain",
        "toManageMonthlyCredits": "Pour gérer les crédits mensuels,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Ajouter un nouvel abonnement"
      },
      "manualActions": {
        "confirmDelete": "Voulez-vous vraiment supprimer cette action?",
        "confirmDeleteAll": "Êtes-vous certain de vouloir supprimer toutes les actions manuelles sur cette page?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Générez un mot de passe fort",
          "sendEmailNotification": "Envoyez une notification par courriel également."
        }
      },
      "modal": {
        "description": "Vous devez suivre quelques étapes simples de conformité pour utiliser les systèmes téléphoniques.",
        "submit": "Soumettre",
        "title": "Connecteur principal Service téléphonique"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Visiteurs de la page d'accueil",
          "launched": "Lancé",
          "newNotification": "Nouvelle notification",
          "startMessage": "Commencez à augmenter vos conversions en créant votre première notification.",
          "types": {
            "combination": "Combinaison"
          }
        },
        "page": {
          "createTitle": "Créer une nouvelle notification",
          "steps": {
            "display": "Affichage",
            "track": "Suivi"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Renseignements supplémentaires",
          "calendarEvent": "Événement du calendrier",
          "hideAssignedTo": "Masquer les affectations",
          "hideTags": "Masquer les étiquettes"
        },
        "filters": {
          "dateAddedAsc": "↑ Date ajoutée (ASC)",
          "dateAddedDesc": "↓ Date d’ajout (DESC)",
          "orderBy": "OrderBy"
        },
        "getStarted": "commencez!",
        "noPipelines": "Oups! On dirait qu'il n'y a pas de flux. Créez un nouveau flux pour"
      },
      "pages": {
        "pageMoved": {
          "title": "Les annonces en ligne ont été déplacées"
        }
      },
      "recentlyVisited": {
        "prices": "{count} prix"
      },
      "reminders": {
        "appointmentReminders": "Rappels de rendez-vous",
        "apptTime": "Heure de rendez-vous",
        "defaultDateRange": "Dimanche 1er avril 2018 – Lundi 31 avril 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "En attente",
        "rebillingOnHoldWarning": "Ce compte a déjà des configurations de refacturation en attente. Le forfait SaaS ne peut être associé qu'après que le client a ajouté un mode de paiement.",
        "subscriptionId": "ID d'abonnement :"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Confirmer et continuer",
        "documents": {
          "acceptedDocuments": "Documents acceptés",
          "acceptedDocumentsLabel": "Documents acceptés :",
          "additionalInfo": "Renseignements supplémentaires :",
          "createAddressLink": "Créez une adresse.",
          "createAddressPrompt": "Veuillez d'abord créer une adresse, puis procéder à la création du lot.",
          "documentInfo": "PNG, JPG, PDF jusqu'à 5 Mo",
          "documentType": "Type de document",
          "option": "Option {number}",
          "selectAddress": "Sélectionnez l'adresse :",
          "selectDocumentType": "Sélectionnez le type de document :",
          "selectFile": "Sélectionnez le fichier",
          "title": "Documents requis\t:",
          "updateDocuments": "Mettre à jour les documents"
        },
        "everythingIn": "Tout dans <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "ajoutez votre carte de crédit ici.",
          "message": "Veuillez demander à votre client de",
          "title": "L'emplacement doit d'abord ajouter un mode de paiement."
        },
        "noSaasPlan": {
          "linkText": "Créez vos forfaits SaaS ici.",
          "message": "Veuillez",
          "title": "Vous n’avez pas de plan SaaS configuré."
        },
        "saasModeSetupPendingWarning": "Le plan SaaS sera activé après que le client aura ajouté une méthode de paiement. D'ici là, l'accès à leur compte sera restreint.",
        "skipForNow": "Ignorer pour l'instant",
        "skipPlan": "Ignorer le forfait",
        "success": {
          "title": "L'ensemble réglementaire a bien été soumis.",
          "underReview": "L'ensemble soumis est en cours d'examen."
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Cette option ajoutera une nouvelle adresse à votre compte.",
          "label": "Offre groupée d'adresses"
        },
        "regulatoryBundle": {
          "description": "Cette option vous aidera à créer un nouveau forfait réglementaire",
          "label": "Ensemble réglementaire"
        },
        "title": "Sélectionnez l'offre groupée que vous souhaitez inclure."
      },
      "settings": {
        "billing": "Facturation",
        "calendars": "Calendriers",
        "customEmails": "Courriels personnalisés",
        "domains": "Domaines",
        "domainsAndUrlRedirects": "Domaines et redirections d'URL",
        "facebookFormFieldsMapping": "Mappage des champs du formulaire Facebook",
        "groups": "Groupes",
        "integrations": "Intégrations",
        "labs": "Laboratoires",
        "media": "Médias",
        "noShowSMS": "SMS de non-présentation",
        "pipelines": "Flux",
        "profile": "Profil",
        "smtpAndMailGunService": "Service SMTP et Mailgun",
        "templates": "Modèles",
        "urlRedirects": "Redirections d'URL"
      },
      "shakenStir": {
        "confirmation": {
          "title": "Vos appels sont maintenant vérifiés!"
        },
        "modal": {
          "andThe": " et le ",
          "certification": "Je certifie que le profil d'entreprise associé est à l'origine des appels téléphoniques et je certifie que je participerai aux efforts de traçabilité, y compris ceux initiés par le",
          "failedTitle": "La soumission a échoué.",
          "friendlyNamePlaceholder": "Ex. : SHST 2022-11-24 à 19:47:14",
          "linkInfo": {
            "description": "Tous les numéros actuels disponibles et les futurs numéros achetés seront automatiquement enregistrés auprès de SHAKEN/STIR.",
            "title": "Tous les numéros seront liés automatiquement."
          },
          "stiPa": "Administrateur de la politique d'identité téléphonique sécurisée (STI-PA)",
          "subtitle": "Saisissez les détails et la description.",
          "successMessage": "Votre demande d’enregistrement SHAKEN/STIR a été soumise. Ça peut prendre jusqu’à <b>3 à 4 jours</b> avant d’être approuvé. Le statut sera mis à jour bientôt.",
          "successTitle": "Fonction SHAKEN/STIR appels de confiance activés.",
          "title": "Activer l'appel de confiance SHAKEN/STIR",
          "tracebackGroup": "Groupe américain de traçabilité des télécommunications"
        },
        "withCnam": {
          "cnamPromo": "Vous voulez aller plus loin? Affichez le nom de votre entreprise lors des appels avec CNAM.",
          "registerCnam": "S'inscrire au CNAM",
          "title": "Bâtissez la confiance des clients et augmentez le taux de réponses aux appels"
        },
        "successMessage": "Votre demande d’enregistrement SHAKEN/STIR a été soumise. Ça peut prendre jusqu’à <b>3 à 4 jours</b> avant d’être approuvé. Le statut sera mis à jour bientôt."
      },
      "shopify": {
        "selectLocation": "Sélectionnez l'emplacement que vous souhaitez relier à cette boutique Shopify."
      },
      "signup": {
        "accountType": "Type de compte",
        "agencyProAccount": "Compte Agency Pro (497 $/mois)",
        "agencyTestAccount": "Compte test de l'agence",
        "freeTrialMessage": "Obtenez un essai <strong>gratuit</strong> de 14 jours en vous inscrivant dès maintenant.",
        "freelancerAccount": "Compte Freelancer (pigiste) (297 $/mois)",
        "getStartedForFree": "Commencez gratuitement!",
        "pickPassword": "Sélectionnez un mot de passe",
        "signUp": "Inscrivez-vous",
        "starterAccount": "Compte de démarrage (97 $/mois)",
        "termsAndConditions": "En vous inscrivant, vous acceptez nos <a href='https://www.gohighlevel.com/privacy' target='_blank'>Conditions générales d'utilisation</a>",
        "yourCompanyName": "Nom de votre entreprise",
        "yourFullName": "Votre nom complet"
      },
      "standardPlan": {
        "description": "Nous avons les forfaits suivants pour les enregistrements de marque standard.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN obligatoire pour l’enregistrement",
            "moreThan1Phone": "Plus d'un numéro de téléphone autorisé"
          },
          "highVolume": {
            "heading": "Standard à haut volume",
            "point3": "Jusqu'à 600 000 segments par jour",
            "infoText": "L'enregistrement de la marque et de la campagne sera facturé 20,95 $ une seule fois. Des frais supplémentaires pouvant atteindre 2,25 $ par mois s'appliqueront conformément aux règles du TCR.",
            "point2": "Envoyez jusqu'à 3 000 segments par jour",
            "point1": "EIN obligatoire pour l'inscription"
          },
          "lowVolume": {
            "heading": "Standard à faible volume",
            "recommended": "Recommandé",
            "point3": "Jusqu'à 6 000 segments par jour",
            "infoText": "L'enregistrement de la marque et de la campagne sera facturé 20,95 $ une seule fois. Des frais supplémentaires pouvant atteindre 2,25 $ par mois s'appliqueront conformément aux règles du TCR.",
            "point2": "Envoyez jusqu'à 3 000 segments par jour",
            "point1": "EIN obligatoire pour l'enregistrement"
          }
        },
        "title": "Sélectionnez votre forfait de marque standard."
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Détails de la réservation",
          "form": "Formulaire",
          "quiz": "Questionnaire",
          "submissionDetail": "Détails de la soumission",
          "survey": "Sondage"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Seuls les administrateurs/utilisateurs de l'agence ont accès à ce sous-compte. Actuellement, vous et les autres administrateurs/utilisateurs du compte n'avez pas accès à ce sous-compte.",
          "heading": "Ce sous-compte a été suspendu."
        },
        "temporarily": {
          "description": "Toutes vos données sont en sécurité et tous les déclencheurs/campagnes, etc. recommenceront à fonctionner après l'activation.",
          "heading": " Votre compte a été suspendu temporairement."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Ne s'applique qu'aux contacts non attribués",
          "splitTraffic": "Répartition du trafic",
          "trafficWeightage": "Pondération du trafic",
          "userRequired": "L'utilisateur doit être sélectionné.",
          "weightage": "Pondération"
        },
        "birthdayFilters": {
          "afterDays": "Après un certain nombre de jours",
          "beforeDays": "Avant le nombre de jours.",
          "dayIs": "Le jour est",
          "daysInNumber": "Nombre de jours",
          "hasTag": "Possède une balise",
          "monthIs": "Le mois est",
          "selectDay": "Sélectionnez le jour.",
          "selectMonth": "Sélectionnez le mois."
        },
        "botConversation": {
          "enterTimeout": "Veuillez saisir un délai d'attente (heures)",
          "selectEliza": "Sélectionnez Eliza.",
          "selectThankyouTemplate": "Sélectionnez le modèle de remerciement",
          "selectWelcomeTemplate": "Sélectionnez le modèle de bienvenue"
        },
        "contactField": {
          "addField": "Ajouter un champ",
          "defineFilters": "Définir les filtres"
        },
        "copyModal": {
          "title": "Copier le déclencheur"
        },
        "detailModal": {
          "actionsPerform": "Quelles activités devrions-nous effectuer?",
          "campaignNameRequired": "Le champ Nom de la campagne est obligatoire.",
          "campaignsDeprecation": "Les campagnes ne sont plus maintenues. Pour assurer une transition fluide, veuillez convertir vos campagnes existantes en flux de travail.",
          "folderName": "Nom du dossier",
          "mustSelectFolder": "Vous devez sélectionner un dossier.",
          "newFolderName": "Nouveau nom de dossier",
          "selectFolder": "Sélectionner un dossier",
          "triggerNameRequired": "Le champ Nom du déclencheur est obligatoire.",
          "triggersDeprecation": "Les déclencheurs ne sont plus maintenus. Pour assurer une transition fluide, veuillez convertir vos déclencheurs existants en flux de travail.",
          "triggerName": "Nom du Déclencheur"
        },
        "dnd": {
          "disableAll": "Désactiver DND pour tous les canaux",
          "disableSpecific": "Désactiver DND pour des canaux spécifiques",
          "enableAll": "Activer DND pour tous les canaux",
          "enableSpecific": "Activer DND pour des canaux spécifiques",
          "selectAction": "Sélectionnez une action."
        },
        "email": {
          "sendTestEmail": "Envoyer un courriel test",
          "smtpWarning": "Les fournisseurs SMTP présentent certaines limitations. Cliquez ici pour en savoir plus."
        },
        "facebook": {
          "avatarAlt": "Avatar Facebook",
          "selectCustomAudience": "Sélectionnez un auditoire personnalisé."
        },
        "googleAds": {
          "conversionName": "Nom de conversion",
          "conversionTooltip": "La source de conversion doit être « Importation à partir des clics » et la catégorie doit être « Prospect importé » ou « Prospect »",
          "noConversions": "Aucune conversion n'a été trouvée",
          "selectConversion": "Sélectionnez la conversion."
        },
        "googleAnalytics": {
          "eventAction": "Action de l'événement",
          "eventActionRequired": "Une action est requise pour l'événement.",
          "eventCategory": "Catégorie d'événement",
          "eventCategoryRequired": "La catégorie d'Événement est obligatoire.",
          "eventLabel": "Étiquette de l'événement",
          "eventValue": "Valeur de l'événement",
          "hitType": "Type de frappe",
          "hitTypeRequired": "Le type de frappe est obligatoire.",
          "trackingId": "ID de suivi",
          "trackingIdRequired": "L'Id de suivi est obligatoire."
        },
        "membershipOffer": {
          "selectOffer": "Sélectionnez une offre."
        },
        "notification": {
          "selectRedirectPage": "Sélectionnez la page de redirection",
          "selectUser": "Sélectionne' l’utilisateur.",
          "selectUserType": "Sélectionnez le type d'utilisateur."
        },
        "sms": {
          "sendTestSMS": "Envoyer un SMS test"
        },
        "stripeCharge": {
          "customerId": "ID client Stripe",
          "enterAmount": "Saisissez le montant.",
          "selectCurrency": "Sélectionnez la devise."
        },
        "webhook": {
          "webhookUrl": "URL du webhook"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Date de l'activité",
            "balance": "Solde",
            "id": "id"
          }
        },
        "upgradeBanner": {
          "subtitle": "Les agences ayant souscrit au forfait pro gagnent environ 363 $ par mois en refacturant les frais téléphoniques à leurs clients",
          "title": "Souhaitez-vous refacturer cela à vos clients?"
        }
      },
      "updateModals": {
        "error": {
          "title": "La soumission de votre profil a échoué."
        },
        "success": {
          "message": "Votre marque A2P et votre campagne ont été soumises.<br/><br/><b>Remarque :</b> Vous <b>recevrez un message avec mot de passe à usage unique (OTP) sur le numéro de cellulaire fourni pour la vérification</b> TCR. Veuillez <b>répondre Oui dans les 24 heures</b> suivant la réception du SMS."
        }
      },
      "usageLimit": {
        "contactLimit": "Limite de contacts",
        "maxContactsAllowed": "Nombre maximal de contacts autorisés dans le sous-compte",
        "maxUsersAllowed": "Nombre maximal d'utilisateurs autorisés dans le sous-compte",
        "unlimited": "Illimité",
        "usageLimits": "Limites d'utilisation",
        "userLimit": "Limite d’utilisateurs",
        "userLimitHelpMessage": "Seuls les utilisateurs au niveau des sous-comptes sont comptabilisés dans cette limite. Vous pouvez toujours ajouter autant d'utilisateurs d'agence que vous le souhaitez aux sous-comptes"
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "J'accepte d'activer les annonces pour ce client sans vente incitative et je reconnais que des frais me seront facturés.",
          "deployDirectly": "Déployer les annonces directement",
          "deployDirectlyDesc": "Utilisez cette option si vous proposez des inscriptions dans le cadre de votre offre ou si vous souhaitez facturer votre client à l'externe.",
          "minimumCommitment": "avec une période d'engagement minimale de 1 mois.",
          "offerListings": "Listes d'offres",
          "resellListings": "Annonces de revente",
          "subscribedInfo": "{withoutUpsell} Sans vente incitative, {withUpsell} Avec vente incitative et {withSaas} Avec forfait Saas",
          "subscriptionCreated": "L'abonnement a bien été créé. Veuillez patienter…",
          "subscriptionCreating": "L'abonnement est en cours de création.<br/>Veuillez ne pas recharger ou cliquer sur le bouton Retour.",
          "unableToCreate": "Impossible de créer un abonnement, veuillez communiquer avec le service d'assistance.",
          "unavailabilityForAgencyAdmin": "Yext n'est pas disponible dans ce pays. Si vous pensez que c'est une erreur, veuillez le demander sur notre feuille de route à",
          "yourResellOffer": "Votre offre de revente"
        }
      },
      "selectCountry": "Sélectionnez votre pays",
      "documents": {
        "additionalInfo": "Informations supplémentaires",
        "createAddressLink": "Créez une adresse.",
        "createAddressPrompt": "Veuillez d'abord créer une adresse, puis procéder à la création du lot.",
        "selectAddress": "Sélectionnez l'adresse :"
      }
    },
    "triggers": {
      "emptyTrigger": "Déclencheur vide"
    },
    "util": {
      "addFiles": "+ Ajouter des fichiers",
      "fillValues": "Remplissez les valeurs",
      "image": "img",
      "ok": "OK",
      "pleaseTypeOrCancel": "Veuillez taper {consentString} ci-dessus ou annuler cette action.",
      "pressEnterToAddCustomOption": "Appuyez sur Entrée pour ajouter une option personnalisée.",
      "required": "* obligatoire",
      "unsaved": "Non enregistré"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "Pour activer le flux de travail pour un sous-compte, accédez à l'onglet Comptes, cliquez sur l'icône à trois points à droite d'un sous-compte, puis sélectionnez <strong>Activer l'outil de création de flux de travail</strong>. Ce processus est temporaire car les flux de travail seront actifs dans tous les emplacements la semaine prochaine."
      },
      "faq": "FAQ",
      "gotIt": "J'ai compris",
      "workflowIsLive": "Le flux de travail est actif dans votre compte!"
    },
    "action": {
      "stats": {
        "bounced": "A rebondi",
        "clicked": "Cliqué",
        "delivered": "Livré",
        "opened": "Ouvert",
        "replied": "Répondu",
        "unsubscribed": "Désabonné",
        "total": "Total",
        "failed": "Échec"
      },
      "actions": {
        "edit": "Modifier",
        "send": "Envoyer",
        "remove": "Supprimer"
      },
      "timing": {
        "days": "Jours",
        "immediately": "Immédiatement",
        "before": "Avant",
        "after": "Après",
        "minutes": "Minutes",
        "hours": "Heures"
      },
      "labels": {
        "template": "Modèle",
        "manual": "Manuel"
      },
      "details": {
        "hideDetail": "Cacher les détails",
        "showDetail": "Afficher les détails"
      },
      "queue": {
        "people": "personnes",
        "person": "personne",
        "queued": "en attente"
      },
      "tooltips": {
        "clickedHelp": "La précision du suivi des clics peut varier en fonction du client de messagerie et des paramètres de l'utilisateur.",
        "statsAccuracy": "La précision des statistiques peut varier en fonction du client de messagerie et des paramètres de l'utilisateur."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Voulez-vous vraiment supprimer cette demande groupée ?",
        "startImmediately": "Commencez immédiatement"
      },
      "modal": {
        "contactTypes": {
          "all": "Tous",
          "leads": "Pistes",
          "customers": "Clients"
        },
        "buttons": {
          "cancel": "Annuler",
          "update": "Mise à jour",
          "add": "Ajouter"
        },
        "labels": {
          "name": "Nom",
          "contactType": "Type de contact",
          "campaign": "Campagne",
          "scheduledDate": "Jour prévu",
          "tag": "Mot clé"
        },
        "placeholders": {
          "tags": "Mots clés",
          "selectCampaign": "Sélectionnez une campagne",
          "pickType": "Sélectionner le type"
        },
        "sections": {
          "bulkRequest": "Demande en masse",
          "whoShouldRun": "Pour qui devrait-il fonctionner ?"
        },
        "titleAdd": "Ajouter une demande en masse",
        "titleEdit": "Modifier la demande en masse",
        "validation": {
          "scheduledDateRequired": "La date de programmation est obligatoire"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Élargir"
    },
    "list": {
      "confirmDeleteFolder": "Confirmer la suppression du dossier",
      "delete": "Supprimer",
      "confirmDelete": "Voulez-vous vraiment supprimer cette campagne?",
      "moveToFolder": "Déplacer vers le dossier",
      "pleaseRename": "veuillez renommer",
      "removeFromFolder": "Retirer du dossier"
    },
    "copy": {
      "title": "Copier la campagne",
      "newCampaignName": "Nouveau nom de campagne",
      "locations": "Emplacements"
    }
  },
  "compliance": {
    "findOutMore": "En savoir plus",
    "gdprDescription": "Nous prenons très au sérieux la protection de vos données personnelles et de celles de vos clients et traitons les données à caractère personnel de manière confidentielle et conformément aux réglementations légales en matière de protection des données et à la présente déclaration de protection des données",
    "gdprTitle": "Conformité RGPD",
    "hipaaDescription": "Activez les mises à niveau de sécurité pour vous assurer que les données de votre compte HighLevel sont sécurisées et répondent aux exigences de la HIPAA.",
    "hipaaTitle": "Conformité HIPAA"
  },
  "customValues": {
    "key": "Clé",
    "selectedItemsCountSingular": "{count} ligne sélectionnée",
    "selectedItemsCountPlural": "{count} lignes sélectionnées"
  },
  "facebookAdFields": {
    "checkIcon": "Le formulaire a été mappé avec succès.",
    "errorMessage": "Le jeton d'accès à la page est soit expiré, soit ne dispose pas des autorisations requises. Veuillez vous assurer de disposer d'un accès administrateur aux pages."
  },
  "fbLeadSync": {
    "confirmTitle": "Confirmer la synchronisation des prospects Facebook ?",
    "impactMessage": "Assurez-vous de comprendre l'impact de la synchronisation des pistes Facebook avant de continuer :",
    "observations": "1. Cela synchronisera les pistes Facebook et créera de nouveaux contacts pour chaque piste générée au cours des {days} derniers jours qui n'existe pas dans votre liste de contacts. <br>2. Si vous avez importé manuellement des pistes manquantes via un fichier CSV exporté depuis le gestionnaire de publicités Facebook, veuillez désactiver l'option « Autoriser les contacts en double » afin d'empêcher la synchronisation de créer des contacts en double. <br>3. Si vous avez des flux de travail qui se déclenchent lors de la <b>création de contacts</b> ou de la <b>soumission du formulaire de pistes Facebook</b>, ils se déclencheront pour chaque nouveau contact créé. <br>4. Les contacts existants créés par le biais des formulaires de pistes Facebook ne seront pas touchés. <br>5. L'heure de création du contact enregistrée sera l'heure actuelle. <br>6. La synchronisation peut prendre jusqu'à une heure, selon le nombre de pistes qui ne sont pas encore synchronisées. <br>",
    "proceedQuestion": "Voulez-vous poursuivre la synchronisation des pistes Facebook?"
  },
  "integrationAI": {
    "accountDisconnected": "Compte déconnecté!",
    "appNotFound": "Configuration de l'application introuvable. Utilisation de données de secours.",
    "checkingConnection": "Vérification du statut de la connexion…",
    "connecting": "Connexion en cours…",
    "disconnectApp": "Déconnecter l'application",
    "disconnecting": "Déconnexion en cours…",
    "loadingAppInfo": "Chargement des détails de l'application…",
    "refreshConnection": "Rafraîchir la connexion",
    "refreshing": "Actualisation en cours…",
    "svgNotAvailable": "SVG non disponible"
  },
  "phoneSystem": {
    "additionalSettings": "Paramètres supplémentaires",
    "messaging": "Envoi de message",
    "messagingAnalytics": "Statistiques de messagerie",
    "regulatoryBundles": "Ensembles réglementaires",
    "title": "Système téléphonique",
    "trustCenter": "Centre de confiance",
    "voice": "Voix"
  },
  "demo": {
    "draggable": {
      "title": "Test du composant déplaçable",
      "usingVue3": "Utilisation du composant déplaçable compatible Vue 3",
      "description": "Ce composant utilise désormais la version révisée du composant déplaçable compatible Vue 3.",
      "buttons": {
        "resetAllLists": "Réinitialiser toutes les listes",
        "clearLog": "Effacer le journal",
        "stopLoading": "Arrêter le chargement",
        "simulateLoading": "Simuler le chargement",
        "refreshData": "Actualiser les données"
      },
      "examples": {
        "basicDraggable": "Déplaçable simple",
        "draggableWithElement": "Déplaçable avec élément",
        "draggableWithTransitionGroup": "Déplaçable avec groupe d'effet d'animation",
        "draggableWithMoveFunction": "Déplaçable avec fonction de déplacement"
      },
      "eventLog": "Journal d'événements",
      "handle": "Poignée",
      "name": "Nom",
      "cannotMove": "(impossible à déplacer)"
    },
    "tableDemo": {
      "title": "Démonstration Vue 3 UIBTable",
      "basicControls": "Contrôles simples",
      "labels": {
        "filter": "Filtre :",
        "sortBy": "Trier par :",
        "sortDirection": "Direction du tri :",
        "perPage": "Par page :",
        "tableStyling": "Style du tableau :"
      },
      "placeholders": {
        "typeToSearch": "Tapez pour rechercher…"
      },
      "checkboxLabels": {
        "striped": "Rayé",
        "bordered": "Bordé",
        "hover": "Survol",
        "small": "Petit",
        "responsive": "Adaptatif"
      },
      "fields": {
        "id": "ID",
        "name": "Nom",
        "email": "Courriel",
        "status": "Statut",
        "created": "Créé",
        "actions": "Actions"
      },
      "statuses": {
        "active": "Actif",
        "inactive": "Inactif",
        "pending": "En attente",
        "banned": "Interdit"
      },
      "modal": {
        "title": "Détails de l'élément",
        "close": "Fermer"
      },
      "messages": {
        "confirmDelete": "Voulez-vous vraiment supprimer {name}?",
        "editItem": "Modifier l'Objet {id}",
        "showingItems": "Affichage de {count} sur {total} articles"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Confirmer et continuer",
      "everythingIn": "Tout en <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "ajouter une carte de crédit ici",
        "message": "Veuillez demander à votre client de",
        "title": "L’emplacement doit d’abord ajouter un mode de paiement."
      },
      "noSaasPlan": {
        "linkText": "créez vos plans SaaS ici.",
        "message": "Veuillez",
        "title": "Vous n’avez pas de plan SaaS configuré."
      },
      "saasModeSetupPendingWarning": "Le plan SaaS sera activé après que le client aura ajouté une méthode de paiement. D’ici là, l’accès à leur compte sera restreint.",
      "skipForNow": "Ignorer pour le moment",
      "skipPlan": "Ignorer le plan"
    }
  },
  "isv": {
    "business_registration_id_type": "Type d'identifiant d’enregistrement d’entreprise",
    "business_registration_number": "Numéro d’enregistrement de l’entreprise",
    "business_website": "Site Web de l'entreprise",
    "enter_your_business_registration_id_type": "Saisissez le type d'identifiant d'enregistrement de votre entreprise",
    "name_of_other_registration_id_type": "Nom d'un autre type d'identifiant d'enregistrement",
    "pick_business_industry": "Sélectionnez le secteur d'activité",
    "pick_business_registration_id_type": "Sélectionnez le type d'ID d'enregistrement de l'entreprise",
    "emailWithStar": "Courriel*",
    "businessIndustry": "Secteur d'activité*",
    "businessType": "Type d'entreprise*",
    "regionsOfOperations": "Régions d’activités*",
    "registrationNumber": "Numéro d’enregistrement de l’entreprise*",
    "registrationNumberHelper": "Le numéro utilisé pour identifier votre entreprise. En cas de numéro EIN américain, doit être un numéro à 9 chiffres, par exemple 12-3456789.",
    "businessWebsiteWithStar": "Site Web de l'entreprise*",
    "businessTypeWithStar": "Type d'entreprise",
    "businessWebsite": "Site Web de l'entreprise"
  },
  "aiProductRebilling": {
    "enableRebilling": "Activer la refacturation",
    "ratesMayDiffer": "Les taux peuvent varier selon la région. Les calculs présentés sont basés sur les taux pour le Royaume-Uni,",
    "supportDoc": "documentation à l'appui",
    "cancel": "Annuler",
    "profit": "Profit",
    "chargedToCustomer": "Facturé au client",
    "enabling": "Activation en cours….",
    "forMore": "pour plus de détails.",
    "rebillAmount": "Montant de refacturation",
    "tenDollarsWillGive": "10 $ vous donneront environ",
    "yourCost": "Vos coûts",
    "clientBillingPage": "page de facturation de l'entreprise du client",
    "needStripeConnection": "Pour activer la refacturation, vous devez connecter votre compte Stripe",
    "per1000Words": "par 1 000 mots",
    "perImage": "par image",
    "perReviewResponse": "par réponse d'avis",
    "perFunnel": "par entonnoir",
    "minimumBetween": "La valeur minimale doit être comprise entre {min} et {max}",
    "images": "images",
    "reviewResponse": "réponse à l'avis",
    "funnel": "entonnoir",
    "pleaseCheckSupport": "veuillez vérifier"
  },
  "a2p": {
    "otpSuccess": {
      "title": "OTP Réussi",
      "message": "Message de réussite de l'OTP"
    },
    "otpError": {
      "title": "Erreur OTP",
      "message": "Message d’erreur OTP"
    },
    "businessProfileError": {
      "title": "Erreur de Profil d'Entreprise",
      "message": "Message d’erreur du profil d’entreprise"
    },
    "addressError": {
      "title": "Erreur d'adresse",
      "status": "Statut d'erreur d'adresse"
    },
    "profileError": {
      "title": "Erreur de profil A2P",
      "message": "Message d'erreur de profil A2P"
    },
    "address": {
      "country": "Pays",
      "state": "État",
      "chooseCountry": "Sélectionnez un pays...",
      "statePlaceholder": "Saisissez l'État",
      "chooseState": "Sélectionnez un État...",
      "city": "Ville*",
      "postalCode": "Code postal*",
      "streetAddress": "Adresse civique*",
      "streetAddressHelper": "Il doit s'agir d'une adresse valide liée à votre entreprise.",
      "title": "Adresse de l'entreprise"
    },
    "validation": {
      "brandNameRequired": "Le nom de la marque est requis.",
      "businessVerticalRequired": "Le secteur d'activité est obligatoire.",
      "cityRequired": "La ville est obligatoire.",
      "countryRequired": "Le pays est obligatoire.",
      "invalidMobileNumber": "Numéro de téléphone mobile invalide.",
      "mobileNumberRequired": "Le numéro de cellulaire est obligatoire.",
      "postalCodeRequired": "Le code postal est obligatoire.",
      "stateRequired": "L’état est obligatoire.",
      "streetAddressRequired": "L'adresse civique est obligatoire."
    },
    "authorizedRep": {
      "email": "Courriel*",
      "firstName": "Prénom*",
      "jobPosition": "Poste d’emploi*",
      "jobTitle": "Titre du poste*",
      "jobTitlePlaceholder": "Entrez le titre du poste",
      "lastName": "Nom de famille*",
      "phoneNumber": "Numéro de téléphone*",
      "phoneNumberPlaceholder": "Entrez le numéro de téléphone",
      "pickJobPosition": "Sélectionnez un poste",
      "title": "Détails du représentant autorisé"
    },
    "registration": {
      "stepProgress": "Étape {currentStep} de 8",
      "successTitle": "Votre marque A2P et votre campagne ont été soumises.",
      "successWaitDays": "7 jours",
      "successWaitPrefix": "Cela pourrait prendre jusqu'à ",
      "successWaitSuffix": " pour l'approbation de votre marque et 4 à 5 semaines supplémentaires pour l'approbation de la campagne.",
      "otpNote": "Remarque : Vous recevrez un message OTP sur le numéro de cellulaire que vous avez fourni pour vérification auprès de TCR. Veuillez répondre « Oui » dans les 24 heures suivant la réception du SMS."
    },
    "update": {
      "brandDetailsTitle": "Mettre à jour les détails de la marque",
      "brandName": "Nom de marque*",
      "brandNameHelper": "Utilisez soit le nom légal de l’organisation qui envoie les messages, soit votre propre nom si cette marque n’est pas pour une organisation.",
      "businessVerticals": "Secteur d'activité*",
      "chooseVertical": "Sélectionnez le secteur…",
      "mobileNumber": "Numéro de cellulaire pour la vérification OTP (avec indicatif de pays)*",
      "mobileNumberHelper": "Veuillez fournir un numéro de cellulaire auquel vous avez accès afin de confirmer la vérification OTP. Seuls les numéros américains/canadiens seront acceptés. Vous ne pouvez pas utiliser un numéro de téléphone CPaaS tel que celui obtenu auprès de LeadConnector. Vous ne pouvez pas utiliser le même numéro de cellulaire pour enregistrer plus de 3 marques de propriétaire unique. Cette limite est gérée par TCR.",
      "updateButton": "Mise à jour",
      "retryOTPTitle": "Réessayer OTP",
      "retryOTPMessage": "Cliquez sur le bouton ci-dessous pour renvoyer le message de vérification OTP.",
      "sending": "Envoi en cours…",
      "resendOTP": "Renvoyer le mot de passe à usage unique"
    },
    "einModal": {
      "title": "Avez-vous un EIN ?",
      "question": "Avez-vous un numéro d'identification d'employeur (EIN) ?",
      "hasEIN": "Oui, j’ai un EIN",
      "noEIN": "Non, je n'ai pas d'EIN",
      "disableNoEINText": "L'EIN est requis pour les emplacements en dehors des États-Unis et du Canada.",
      "infoText": "Un EIN est requis pour les entreprises aux États-Unis et au Canada."
    },
    "brandDetails": {
      "brandHeading": "Détails de la marque",
      "brandName": "Nom de marque*",
      "brandNameHelper": "Utilisez soit le nom légal de l’organisation qui envoie les messages, soit votre propre nom si cette marque n’est pas pour une organisation.",
      "businessIndustry": "Secteur d'activité*",
      "chooseVertical": "Choisissez verticalement...",
      "mobileNumber": "Numéro de cellulaire pour la vérification OTP (avec indicatif de pays)*",
      "mobileNumberHelper": "Veuillez fournir un numéro de cellulaire auquel vous avez accès afin de confirmer la vérification OTP. Seuls les numéros américains/canadiens seront acceptés. Vous ne pouvez pas utiliser un numéro de téléphone CPaaS tel que celui obtenu auprès de LeadConnector. Vous ne pouvez pas utiliser le même numéro de téléphone portable pour enregistrer plus de 3 marques de propriétaire unique. Cette limite est gérée par TCR.",
      "solePropBrand": {
        "heading": "Marque Sole Prop",
        "point1": "Un seul numéro de téléphone est autorisé",
        "point2": "EIN/SSN/DUNS non obligatoire",
        "subheading": "Enregistrement de marque de propriétaire unique"
      },
      "solePropCampaign": {
        "heading": "Campagne de propriétaire unique",
        "point1": "Un seul numéro peut être associé à une campagne de propriétaire unique",
        "point2": "Une fois approuvé, votre numéro par défaut sera lié automatiquement",
        "infoText": "Vous pouvez également mettre à jour le numéro après approbation",
        "warningText": "Un seul numéro peut être associé à une campagne Sole Prop. Une fois approuvé, votre numéro par défaut sera automatiquement associé. Vous pouvez également mettre à jour le numéro après approbation.",
        "subheading": "Inscription à la campagne d’entreprise individuelle"
      },
      "solePropSubtitle": "Détails de la marque et de la campagne Sole Prop",
      "standardBrand": {
        "heading": "4,41 $ - Une seule fois",
        "point1": "EIN/SSN/DUNS obligatoire",
        "point2": "Plus d’un numéro de téléphone permis",
        "subheading": "Enregistrement Standard de Marque"
      },
      "standardCampaign": {
        "heading": "16,54 $ - en une seule fois",
        "point1": "Plus d'un numéro est autorisé à être lié à une campagne standard",
        "point2": "EIN/SSN/DUNS obligatoire",
        "infoText": "Des frais supplémentaires pouvant aller jusqu'à 12 $ par mois s'appliqueront conformément aux règles du TCR.",
        "subheading": "Inscription de la campagne standard"
      },
      "standardSubtitle": "Détails standards de la marque et de la campagne",
      "title": "Détails de la marque et de la campagne"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Détails des cas d’utilisation des campagnes",
        "subtitle": "Saisissez les détails et la description de la campagne",
        "useCase": "Cas d'utilisation de campagne*",
        "pickUseCase": "Sélectionnez le cas d’utilisation de la Campagne",
        "useCaseDescription": "Description du cas d'utilisation*",
        "explainInDetail": "Veuillez expliquer en détail",
        "useCaseDescriptionPlaceholder": "Exemple : cette campagne envoie des informations relatives aux rendez-vous (messages de confirmation et de rappel) à nos clients dès qu'ils ont pris rendez-vous sur notre site web et accepté de recevoir des SMS promotionnels et des notifications de notre part.",
        "useCaseDescriptionHelper": "Veuillez fournir une description détaillée de la façon dont vous allez utiliser cette campagne.",
        "solePropLabel": "Sole Proprietor",
        "seeExamples": "Voir les exemples",
        "closeExamples": "Fermer les exemples"
      }
    }
  },
  "opportunities": {
    "email": "Courriel",
    "phone": "Téléphone",
    "status": "Statut",
    "contactType": "Type de contact",
    "bulkOperation": "Opération en masse",
    "contactName": "Nom du contact",
    "unassigned": "Non assigné",
    "abandoned": "Abandonné",
    "addOpportunityName": "Ajouter un nom de l'opportunité",
    "companyName": "Nom de l’entreprise",
    "contactInfo": "Contact",
    "enterValue": "Saisissez une valeur",
    "lost": "Perdu",
    "open": "Ouvrir",
    "opportunityInfo": "Infos sur l'opportunité",
    "opportunityName": "Nom de l'opportunité",
    "opportunitySource": "Source d'opportunité",
    "owner": "Propriétaire",
    "pipeline": "Flux",
    "selectPipeline": "Sélectionner un flux",
    "selectStage": "Sélectionnez l'étape",
    "stage": "Étape",
    "won": "Réussi",
    "createdOn": "Créé le",
    "goToContactDetail": "Accédez à la page des détails de contact",
    "leadValue": "Valeur du prospect",
    "removeOwner": "Supprimer le propriétaire",
    "createdBy": "Créé par",
    "notAllowedToChange": "Vous n'êtes pas autorisé à modifier ce contact",
    "opportunityAlreadyExists": "Une opportunité existe déjà pour ce contact dans le flux sélectionné",
    "filters": {
      "all": "Tous",
      "statuses": {
        "all": "Tous",
        "open": "Ouvrir",
        "won": "Gagné",
        "lost": "Perdu",
        "abandoned": "Abandonné"
      },
      "search": "Rechercher",
      "status": "Statut",
      "campaign": "Campagne",
      "owner": "Propriétaire",
      "pipeline": "Flux",
      "dateAddedAsc": "↑ Date ajoutée (ASC)",
      "dateAddedDesc": "↓ Date d’ajout (DESC)",
      "orderBy": "OrderBy"
    },
    "columns": {
      "note": "Remarque",
      "task": "Tâche",
      "companyName": "Nom de l'entreprise",
      "additionalInfo": "Informations supplémentaires",
      "calendarEvent": "Événement du calendrier",
      "hideAssignedTo": "Masquer les affectations",
      "hideTags": "Masquer les étiquettes"
    },
    "buttons": {
      "new": "Nouveau"
    },
    "dragActions": {
      "abandoned": "Abandonné",
      "lost": "Perdu",
      "won": "Gagné"
    },
    "getStarted": "commencez!",
    "noPipelines": "Oups! On dirait qu’il n’y a pas de flux. Créer un nouveau flux pour",
    "addTask": "Ajouter une tâche",
    "tasksCount": "{count} tâches"
  },
  "appointmentDetails": "Détails du rendez-vous",
  "cloneFunnel": {
    "cloneButton": "Dupliquer {entityName}",
    "cloning": "Duplication en cours…",
    "cloningLimit": "La duplication est limitée à trois emplacements à la fois.",
    "error": "Une erreur s'est produite lors de la duplication de l'entonnoir!",
    "locationsLabel": "Sélectionner les emplacements",
    "nameLabel": "Nom du clone {entityName}",
    "namePlaceholder": "Entrez le nom du {entityName}cloné",
    "selectUpTo": "Sélectionnez jusqu'à {maxSelectableLocations} emplacements",
    "title": "Dupliquer {entityName}"
  },
  "errors": "Erreurs",
  "renderEmailAddress": "Afficher l'adresse courriel",
  "noPaymentMethodWarning": "Aucun avertissement de méthode de paiement",
  "pageDetail": "Détails de la page",
  "activityHistory": "Historique d'activité",
  "uiAlert": "Alerte UI",
  "eventModals": {
    "wait": {
      "save": "Enregistrer",
      "days": "Jours",
      "fri": "Vendredi",
      "mon": "Lundi",
      "sat": "Samedi",
      "sun": "Dimanche",
      "thu": "Jeudi",
      "tue": "Mardi",
      "wed": "Mercredi",
      "wait": "Attendre",
      "minutes": "Minutes",
      "hours": "Heures",
      "title": "Modifier l'événement d'attente",
      "whichDaysResume": "Quels jours devrions-nous reprendre?",
      "pickDayError": "Veuillez sélectionner au moins un jour",
      "whatTimeResume": "À quelle heure devrions-nous reprendre?"
    },
    "sms": {
      "send": "Envoyer",
      "name": "Nom",
      "attachFile": "Joindre un document",
      "learnMore": "En savoir plus",
      "sendTest": "Envoyer le test",
      "title": "Modifier l'événement {eventType}",
      "titleTemplate": "Modifier le modèle {eventType}",
      "nameRequired": "Le nom est obligatoire",
      "pickTemplate": "Choisissez un modèle",
      "appCharacters": "Caractères de l'application :",
      "numSegments": "Nombre de segments",
      "approximateCost": "Coût approximatif",
      "costEstimateNote": "Note d'estimation des coûts",
      "urlAttachmentAutocompleteToken": "Pièce jointe URL",
      "addFileUrl": "Ajouter une URL de fichier",
      "urlImageAlt": "URL de l'image",
      "fileImageAlt": "Image de fichier",
      "enterMessage": "Saisissez le message",
      "mobilePhonePlaceholder": "Téléphone mobile",
      "unsupportedContentType": "Type de contenu non pris en charge : {fileType}",
      "urlAttachmentWarning": "La pièce jointe URL {count} {plural} n'a pas pu être chargée. Voulez-vous continuer?",
      "provideMobileNumber": "Veuillez fournir le numéro de téléphone mobile"
    },
    "email": {
      "text": "Texte",
      "checkLinks": "Veuillez vérifier les liens où vous avez une valeur personnalisée. Il y a un « %20 » supplémentaire entre les {{ et les custom_values.",
      "errorOccurred": "Une erreur s'est produite, veuillez réessayer.",
      "insertToAddress": "Veuillez insérer une adresse de destination."
    },
    "voicemail": {
      "save": "Enregistrer",
      "dropFile": "Téléverser le fichier ici ou cliquer pour téléverser",
      "faq": "FAQ",
      "title": "Modifier l’événement de boîte vocale",
      "voicemailFile": "Fichier de boîte vocale",
      "warning": "Avertissement : Les fichiers de messagerie vocale doivent être au format MP3, WAV ou GSM.",
      "unsupportedFormat": "Format de fichier non pris en charge. Veuillez utiliser MP3, WAV ou GSM."
    },
    "call": {
      "title": "Modifier l'événement d'appel",
      "save": "Enregistrer",
      "name": "Nom",
      "nameRequired": "Le nom est obligatoire",
      "callWhisper": "Appel Whisper",
      "whisperMessage": "Message chuchoté",
      "thisIsTheMessage": "Voici le message qui sera diffusé à l'agent avant de connecter l'appel.",
      "callTimeoutS": "Délai d'attente d'appel(s)",
      "timeoutSeconds": "Délai d'attente (secondes)",
      "disableVoicemailDetect": "Désactiver la détection de messagerie vocale",
      "callWillPatchInstantly": "L’appel sera corrigé instantanément sans détecter la messagerie vocale."
    }
  },
  "emailTemplate": {
    "createdOn": "Créé le",
    "updatedOn": "Mis à jour le"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM En savoir plus",
      "description": "Description CNAM"
    },
    "submitted": {
      "checkStatus": "Vérifier le statut du CNAM",
      "description": "Le nom de votre entreprise devrait être affiché aux contacts concernés dans environ 3 à 5 jours.",
      "subtitle": "Votre demande CNAM est désormais soumise.",
      "title": "Félicitations!"
    },
    "registration": {
      "confirm": "Confirmer",
      "learnMore": "En savoir plus",
      "characterLimit": "{count}/15",
      "title": "Enregistrement CNAM",
      "description": "Veuillez entrer le nom de votre entreprise (maximum 15 caractères)",
      "warning": "Avertissement : Le nom de votre entreprise sera affiché sur l'identification de l'appelant. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Erreur de mise à jour",
      "message": "Message d'erreur de mise à jour"
    },
    "success": {
      "message": "Votre marque A2P et votre campagne ont été soumises.<br/><br/><b>Remarque :</b> Vous <b>recevrez un message OTP sur le numéro de téléphone mobile que vous avez fourni afin de vérifier</b> votre inscription auprès de TCR. Veuillez <b>répondre Oui dans les 24 heures</b> suivant la réception du SMS.",
      "title": "Votre marque A2P et votre campagne ont été soumises. L'approbation de votre marque peut prendre jusqu'à <b>7 jours</b> et l'approbation de la campagne peut prendre 4 à 5 semaines supplémentaires."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Erreur de forfait réglementaire",
      "status": "Statut d'erreur de l'ensemble réglementaire"
    },
    "createAddress": {
      "successMessage": "Votre marque A2P et votre campagne ont été soumises.",
      "successTitle": "Adresse soumise avec succès",
      "underReview": "L’adresse soumise est en cours d’examen"
    },
    "createEndUser": {
      "dateFormat": "Le format de la date doit être AAAA-MM-JJ.",
      "phoneExample": " Exemple : +14155552671",
      "title": "Détails de l’entreprise :"
    },
    "success": {
      "title": "Ensemble réglementaire soumis avec succès",
      "underReview": "Ensemble soumis en cours d’examen",
      "message": "Votre demande d’enregistrement SHAKEN/STIR a été soumise. Ça peut prendre jusqu’à <b>3 à 4 jours</b> avant d’être approuvé. Le statut sera mis à jour bientôt."
    },
    "documents": {
      "additionalInfo": "Informations supplémentaires",
      "createAddressLink": "Créez une adresse.",
      "createAddressPrompt": "Veuillez d'abord créer une adresse, puis procéder à la création du lot.",
      "selectAddress": "Sélectionnez l'adresse :"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Cette option ajoutera une nouvelle adresse à votre compte",
        "label": "Forfait d'adresses"
      },
      "regulatoryBundle": {
        "description": "Cette option vous aidera à créer un nouveau forfait réglementaire",
        "label": "Forfait réglementaire"
      },
      "title": "Sélectionner le forfait que vous souhaitez Inclure"
    },
    "modal": {
      "back": "Retour",
      "next": "Suivant",
      "submit": "Soumettre",
      "title": "Nouveau lot réglementaire",
      "description": "Créez un nouveau forfait réglementaire pour votre emplacement"
    }
  },
  "reminder": {
    "phone": "Téléphone",
    "noReplyYet": "Aucune réponse pour le moment"
  },
  "sendGrid": {
    "apiKey": "Clé API SendGrid",
    "save": "Enregistrer SendGrid",
    "apiKeyRequired": "Clé API SendGrid requise"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Mettre à niveau",
      "subtitle": "Les agences ayant souscrit au plan pro gagnent environ 363 dollars par mois en refacturant les frais téléphoniques à leurs clients",
      "title": "Souhaitez-vous refacturer cela à vos clients?"
    }
  },
  "emailField": {
    "label": "Courriel",
    "placeholder": "Courriel",
    "tooltip": {
      "primary": "Principal",
      "emails": "Courriels"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Charger l’instantané :",
    "loadSnapshotWarning": "Souhaitez-vous charger l’instantané associé à ce plan? <br /> <strong class='text-danger'>Les données existantes peuvent être perdues</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Seuls les administrateurs/utilisateurs de l'agence ont accès à ce sous-compte. Actuellement, vous et les autres administrateurs/utilisateurs du compte n'avez pas accès à ce sous-compte.",
      "heading": "Ce sous-compte a été mis en pause."
    },
    "temporarily": {
      "description": "Toutes vos données sont en sécurité et tous les déclencheurs/campagnes, etc. recommenceront à fonctionner après l'activation.",
      "heading": " Votre compte a été suspendu temporairement."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Nom convivial de l'entreprise",
    "title": "Mise à jour de l'identification de l'appelant"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Sélectionner un bureau",
    "whichOffice": "Quel bureau souhaitez-vous associer à ce compte?",
    "connect": "Connectez-vous!"
  },
  "phoneField": {
    "label": "Téléphone",
    "placeholder": "Numéro de téléphone",
    "tooltip": {
      "invalidNumber": "Numéro de téléphone non valide",
      "notSmsCapable": "Ce {type} numéro n’est pas compatible avec les SMS"
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Détails de la réservation",
      "form": "Formulaire",
      "quiz": "Questionnaire",
      "submissionDetail": "Détails de soumission",
      "survey": "Sondage"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "Votre demande d’enregistrement SHAKEN/STIR a été soumise. Ça peut prendre jusqu’à <b>3 à 4 jours</b> avant d’être approuvé. Le statut sera mis à jour bientôt.",
      "title": "SHAKEN/STIR Appel de confiance activé."
    },
    "modal": {
      "andThe": " et le ",
      "businessProfile": "Profil d'entreprise",
      "certification": "Je certifie que le profil d'entreprise associé est à l'origine des appels téléphoniques et je certifie que je participerai aux efforts de traçabilité, y compris ceux initiés par le",
      "failedTitle": "Échec de la soumission",
      "friendlyName": "Nom amical",
      "friendlyNamePlaceholder": "Ex : SHST 2022-11-24 à 19:47:14",
      "linkInfo": {
        "description": "Tous les numéros actuels disponibles et les futurs numéros achetés seront automatiquement enregistrés auprès de SHAKEN/STIR.",
        "title": "Tous les numéros seront liés automatiquement"
      },
      "stiPa": "Administrateur de la politique d'identité téléphonique sécurisée (STI-PA)",
      "subtitle": "Saisissez les détails et la description",
      "successMessage": "Votre demande d’enregistrement SHAKEN/STIR a été soumise. Ça peut prendre jusqu’à <b>3 à 4 jours</b> avant d’être approuvé. Le statut sera mis à jour bientôt.",
      "successTitle": "Fonction SHAKEN/STIR Appels sécurisés activés.",
      "title": "Activez l’appel de confiance SHAKEN/STIR",
      "tracebackGroup": "Groupe américain de traçabilité des télécommunications"
    },
    "withCnam": {
      "cnamPromo": "Inscrivez-vous à CNAM pour afficher le nom de votre entreprise sur l'identification de l'appelant",
      "registerCnam": "Enregistrez-vous au CNAM"
    }
  },
  "task": {
    "2day": "2 jours",
    "3day": "3 jours",
    "4day": "4 jours",
    "5day": "5 jours",
    "addTask": "Ajouter une tâche",
    "countTasks": "{count} tâches"
  },
  "updatedProductsModal": {
    "title": "Produits mis à jour",
    "copyDirectSaleLink": "Copier le lien de vente directe",
    "setupFeeInstruction": "Les frais d'installation peuvent être configurés dans le tableau de bord Stripe. ",
    "doNotDeleteWarning": "Ne supprimez pas les produits ni les prix du tableau de bord Stripe. Cela va rompre l’intégration."
  },
  "termsOfService": {
    "privacyLink": "Politique de confidentialité",
    "accept": "Accepter",
    "termsLink": "Conditions d'utilisation",
    "updateMessage": "Nous avons mis à jour nos conditions d'utilisation et notre politique de confidentialité. Veuillez examiner et accepter pour continuer.",
    "agreementPrefix": "En continuant, vous acceptez nos conditions ",
    "agreementConjunction": " et "
  },
  "callerIdVerificationModal": {
    "answerCall": "Répondez à l’appel et entrez ce code de vérification :",
    "leadConnectorCalling": "Lead Connector appelle...",
    "title": "Ajouter une Identification de l'appelant via la voix",
    "waitingForVerification": "En attendant la vérification..."
  },
  "emailOTPModal": {
    "confirmCode": "Confirmer le code",
    "resendCode": "Si vous n'avez pas reçu le code, cliquez ici pour le renvoyer"
  },
  "survey": {
    "copy": {
      "cancel": "Annuler",
      "location": "Emplacement",
      "copy": "Copier",
      "newSurveyName": "Nouveau nom du sondage",
      "title": "Copier le sondage",
      "locationRequired": "L'emplacement est requis"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Nom du produit",
    "planDetails": "Détails du forfait",
    "title": "Description du produit",
    "planId": "ID du plan",
    "copiedToClipboard": "Copié dans le presse-papiers"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Plus efficace",
      "faster": "Plus rapide",
      "itsText": "C'est",
      "smoother": "Plus fluide",
      "title": "Une nouvelle expérience d’importation est disponible!",
      "warningMessage": "L'activation de la nouvelle expérience d'importation active les laboratoires pour ce sous-compte et active la fonction Bêta.",
      "tryNow": "Essayer maintenant"
    },
    "validateEmails": "Valider les courriels ?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "Prix HighLevel",
      "howDoesItWork": "Comment ça fonctionne?",
      "payNow": "Payer maintenant",
      "priceError": "Le prix doit être supérieur ou égal au prix HighLevel.",
      "saving": "Sauvegarde en cours",
      "yourPrice": "Votre prix",
      "yourProfit": "Votre marge",
      "subscriptionCreating": "L'abonnement est en cours de création.<br/>Veuillez ne pas recharger ni cliquer sur le bouton Retour.",
      "subscriptionCreated": "L'abonnement a bien été créé. Veuillez patienter…",
      "unableToCreate": "Impossible de créer un abonnement, veuillez contacter le soutien.",
      "perMonth": "par mois",
      "agreeToEnable": "J'accepte d'activer les inscriptions pour ce client sans surenchère et je reconnais que des frais me seront facturés",
      "deployDirectly": "Déployer les annonces directement",
      "deployDirectlyDesc": "Utilisez cette option si vous proposez des inscriptions dans le cadre de votre offre ou si vous souhaitez facturer votre client à l'externe.",
      "minimumCommitment": "avec une période d'engagement minimale de 1 mois",
      "offerListings": "Listes d'offres",
      "resellListings": "Annonces de revente",
      "subscribedInfo": "{withoutUpsell} Sans vente incitative, {withUpsell} Avec vente incitative et {withSaas} Avec forfait Saas",
      "yourResellOffer": "Votre offre de revente"
    }
  }
}
